webpackJsonp([23],{

/***/ 1188:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__clerkinn_shared_input_text__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__clerkinn_shared_input_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__clerkinn_shared_input_text__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function mounted() {
	this.val = '$' + this.value;
}

function sendValue(value) {
	this.$emit('input', value);
}

function activateFn() {
	if (!this.blockButton) {
		this.activate = !this.activate;
		this.$emit('activate-button', this.activate);
	}
}

function activatedButton(newValue) {
	this.activate = newValue;
}

function updateValue(newValue) {
	this.val = '$' + newValue;
}

function data() {
	return {
		activate: false,
		val: null
	};
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'button-field',
	components: {
		inputText: __WEBPACK_IMPORTED_MODULE_0__clerkinn_shared_input_text___default.a
	},
	inheritAttrs: false,
	data: data,
	methods: {
		activateFn: activateFn,
		sendValue: sendValue,
		updateValue: updateValue
	},
	mounted: mounted,
	props: {
		activatedButton: {
			default: false,
			type: Boolean
		},
		blockButton: {
			default: false,
			type: Boolean
		},
		labelText: {
			default: '',
			type: String
		},
		value: null
	},
	watch: {
		activatedButton: activatedButton,
		value: updateValue
	}
});

/***/ }),

/***/ 1210:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1188),
  /* template */
  __webpack_require__(1222),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1222:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', [_vm._v(_vm._s(_vm.labelText))]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "mr-3 mask",
    on: {
      "click": _vm.activateFn
    }
  }, [_c('input-text', _vm._b({
    class: [
      'input-button',
      _vm.activate ? 'active-input' : null
    ],
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  }, 'input-text', _vm.$attrs, false))], 1), _vm._v(" "), (_vm.activate) ? _c('input-text', {
    attrs: {
      "readonly": _vm.blockButton,
      "value": _vm.value
    },
    on: {
      "input": _vm.sendValue
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__clerkinn_checkin_modal_bill__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__clerkinn_checkin_modal_bill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__clerkinn_checkin_modal_bill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_table_run__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_table_run___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_table_run__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_helper__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_mixins__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_filters__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_shared_ButtonCreate__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_shared_ButtonCreate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_shared_ButtonCreate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__clerkinn_shared_ButtonField__ = __webpack_require__(1210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__clerkinn_shared_ButtonField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__clerkinn_shared_ButtonField__);









var postPreview = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee() {
		var _this = this;

		var dataModel, baseUrl, params, codeBooking, responseType, response, blob;
		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						dataModel = {
							codeBooking: this.bookingData.code,
							commentary: this.commentary,
							flagTaxes: this.flagTaxes,
							flagShowCustomer: this.flagShowCustomer,
							tip: this.tip,
							transactions: this.paysByTypePayment.map(function (pays) {
								var newPays = {
									amount: pays.amount,
									currency: _this.currencySelected,
									paymentAmount: pays.amount,
									paymentDate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_date_fns__["format"])(new Date(), 'YYYY-MM-DD'),
									typePaymentId: pays.id
								};
								return newPays;
							}),
							transactionId: this.typePaymentsSelected.map(function (typePay) {
								return typePay.id;
							}),
							typeDocumentCode: this.saleModel.typeDocumentCode,
							typePaymentCode: this.saleModel.typePaymentCode,
							paymentMethodCode: this.saleModel.paymentMethodCode,
							currency: this.currencySelected,
							exchangeRate: this.exchangeRate
						};

						dataModel.details = this.newLocalProductsRows.map(function (local) {
							var newLocal = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, local);
							newLocal.detail = {
								brandId: local.brandId,
								discount: 0,
								quantity: local.quantity,
								price: local.price,
								productType: local.product.type,
								stockQuantity: local.stockQuantity,
								warProductsId: local.idDetail,
								warWarehousesId: local.warWarehousesId,
								flagIgv: local.product.flagIgv,
								flagIgvRequired: local.product.flagIgvRequired,
								igvId: local.product.igvId,
								name: local.product.name,
								code: local.product.code
							};
							return newLocal.detail;
						});
						if (this.saleCustomerId > 0) {
							dataModel.customerId = this.saleCustomerId;
						}
						if (this.creditPayment) {
							dataModel.expirationDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_date_fns__["format"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_date_fns__["addDays"])(new Date(), this.paymentDays), 'YYYY-MM-DD');
						}
						_context.prev = 4;
						baseUrl = '//pms.controlinn.com/api';
						params = { recipe: 'phantom-pdf' };
						codeBooking = this.bookingData.code;
						responseType = 'blob';
						_context.next = 11;
						return this.$http.post(baseUrl + '/booking/' + codeBooking + '/report/document-previous', dataModel, { params: params, responseType: responseType });

					case 11:
						response = _context.sent;
						blob = helperMethods.generateBlob(response.bodyBlob);

						helperMethods.showDownloadDialog(blob, 'PREVISUALIZACIÓN DE DOCUMENTO', 'pdf', true);
						_context.next = 19;
						break;

					case 16:
						_context.prev = 16;
						_context.t0 = _context['catch'](4);

						if (_context.t0.body.message === 'CHECKIN_IS_REQUIRED') {
							this.showNotification('El CheckIn es requerido', 'error');
						} else if (_context.t0.body.message === 'CHECKIN_REQUIRED') {
							this.showNotification('El CheckIn es requerido', 'error');
						}

					case 19:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[4, 16]]);
	}));

	return function postPreview() {
		return _ref.apply(this, arguments);
	};
}();

var dowloadFunction = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var urlBase, query, serie, response, blob;
		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						urlBase = '//pms.controlinn.com/api' + '/report/command-preview';
						query = '?format=tabloid&recipe=html-with-browser-client&documentId=' + this.id;
						serie = this.sale.serie + '-' + this.sale.number;
						_context2.next = 5;
						return this.$http.post('' + urlBase + query);

					case 5:
						response = _context2.sent;
						blob = helperMethods.generateBlob(response.bodyText);

						helperMethods.showDownloadDialog(blob, serie, 'html');

					case 8:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function dowloadFunction() {
		return _ref2.apply(this, arguments);
	};
}();

var saveModal = function () {
	var _ref4 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee3(dateBill, idDetailProduct) {
		var idDetail, codeProduct, bookingCode;
		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						_context3.prev = 0;
						idDetail = idDetailProduct;
						codeProduct = this.summaryData.details[0].product.code;
						bookingCode = this.$route.query.bookingCode;
						_context3.next = 6;
						return this.$http.patch('//pms.controlinn.com/api' + '/details-booking/' + idDetail + '/' + codeProduct + '/' + bookingCode, dateBill);

					case 6:
						this.closeModal();
						this.loadSummaryData();
						_context3.next = 13;
						break;

					case 10:
						_context3.prev = 10;
						_context3.t0 = _context3['catch'](0);

						if (_context3.t0.status === 404) {
							if (_context3.t0.data.message === 'PAYMENT_EXCEEDED_DOCUMENT') {
								this.showNotification('Ingrese de nuevo Monto Excesivo al Monto Total', 'primary');
							}if (_context3.t0.data.message === 'DETAILS_NOT_FOUND') {
								this.showNotification('Detalle de Producto no encontrado', 'primary');
							}
						}

					case 13:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this, [[0, 10]]);
	}));

	return function saveModal(_x, _x2) {
		return _ref4.apply(this, arguments);
	};
}();

var addGuest = function () {
	var _ref5 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee4() {
		var flagUpdate, method, updateUrl, url, successMessage;
		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						this.model.flagPerson = this.personTypeName;
						if (!this.model.flagMain) {
							this.model.codeBooking = this.bookingData.code;
							this.model.flagMain = false;
						}
						flagUpdate = this.customerBtnText === 'Actualizar';
						method = flagUpdate ? 'put' : 'post';
						updateUrl = this.model.flagMain ? 'customer/' + this.model.id : 'bookings-customer/' + this.model.id;
						url = flagUpdate ? updateUrl : 'bookings-customer';
						successMessage = flagUpdate ? 'actualizado' : 'agregado';
						_context4.prev = 7;
						_context4.next = 10;
						return this.$http[method]('//pms.controlinn.com/api' + '/' + url, this.model);

					case 10:
						this.showNotification('El hu\xE9sped ha sido ' + successMessage + ' correctamente.', 'success');
						this.loadBookingData();
						this.cancelAddGuest();
						_context4.next = 18;
						break;

					case 15:
						_context4.prev = 15;
						_context4.t0 = _context4['catch'](7);

						if (_context4.t0.status === 405) {
							if (_context4.t0.data.message === 'CUSTOMER_MAX_REGISTER') {
								this.showNotification('No se pudo agregar el huésped. La cantidad de huéspedes registrados es igual a la cantidad de huéspedes agregados en la reserva.', 'error');
							}
							if (_context4.t0.data.message === 'CHILDS_MAX_REGISTER') {
								this.showNotification('No se pudo agregar el huésped. La cantidad de niños registrados es igual a la cantidad de niños agregados en la reserva.', 'error');
							}
						}

					case 18:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, this, [[7, 15]]);
	}));

	return function addGuest() {
		return _ref5.apply(this, arguments);
	};
}();

var cancelBilling = function () {
	var _ref6 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee5() {
		var modelBillingCancel;
		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
			while (1) {
				switch (_context5.prev = _context5.next) {
					case 0:
						modelBillingCancel = {
							commentary: '',
							subsidiaryId: this.hotelId
						};
						_context5.next = 3;
						return this.$http.patch('//pms.controlinn.com/api' + '/point/' + this.billingId + '/document', modelBillingCancel);

					case 3:
						this.showNotification('La factura ha sido anulada correctamente.', 'success');
						this.closeBillingDialog();
						this.loadBillings();

					case 6:
					case 'end':
						return _context5.stop();
				}
			}
		}, _callee5, this);
	}));

	return function cancelBilling() {
		return _ref6.apply(this, arguments);
	};
}();

var changeMainCustomer = function () {
	var _ref7 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee6(_ref8) {
		var id = _ref8.id;
		var modelMain;
		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
			while (1) {
				switch (_context6.prev = _context6.next) {
					case 0:
						modelMain = {
							codeBooking: this.bookingData.code
						};
						_context6.next = 3;
						return this.$http.put('//pms.controlinn.com/api' + '/bookings-customer/' + id + '/main', modelMain);

					case 3:
						this.showNotification('Se cambió de cliente principal para la reserva.', 'success');
						this.loadBookingData();

					case 5:
					case 'end':
						return _context6.stop();
				}
			}
		}, _callee6, this);
	}));

	return function changeMainCustomer(_x4) {
		return _ref7.apply(this, arguments);
	};
}();

var checkout = function () {
	var _ref9 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee7() {
		var _this6 = this;

		var baseUrl, codeBooking, _ref10, response;

		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
			while (1) {
				switch (_context7.prev = _context7.next) {
					case 0:
						baseUrl = '' + '//pms.controlinn.com/api';
						codeBooking = this.bookingData.code;
						_context7.prev = 2;
						_context7.next = 5;
						return this.$http.put(baseUrl + '/booking/checkout', { codeBooking: codeBooking });

					case 5:
						_ref10 = _context7.sent;
						response = _ref10.data;

						this.bookingData.bookingState = response.data.bookingState;
						this.showNotification('Se completó el check out de la reserva.', 'success');
						this.active = 'tab-' + this.items[(this.items.indexOf(function (row) {
							return 'tab-' + row.id === _this6.active;
						}) + 3) % this.items.length].id;
						_context7.next = 15;
						break;

					case 12:
						_context7.prev = 12;
						_context7.t0 = _context7['catch'](2);

						if (_context7.t0.body.message === 'CHECKIN_IS_REQUIRED') {
							this.showNotification('El CheckIn es requerido', 'error');
						}

					case 15:
						_context7.prev = 15;

						this.loadSummaryData();
						return _context7.finish(15);

					case 18:
					case 'end':
						return _context7.stop();
				}
			}
		}, _callee7, this, [[2, 12, 15, 18]]);
	}));

	return function checkout() {
		return _ref9.apply(this, arguments);
	};
}();

var deleteCustomer = function () {
	var _ref13 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee8() {
		var modelDelete;
		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
			while (1) {
				switch (_context8.prev = _context8.next) {
					case 0:
						modelDelete = {
							codeBooking: this.bookingData.code
						};
						_context8.next = 3;
						return this.$http.delete('//pms.controlinn.com/api' + '/bookings-customer/' + this.customerIdSelected, { body: modelDelete });

					case 3:
						this.showNotification('El cliente ha sido eliminado correctamente.', 'success');
						this.customerIndex = null;
						this.customerIdSelected = null;
						this.dialogCustomer = false;
						this.loadBookingData();

					case 8:
					case 'end':
						return _context8.stop();
				}
			}
		}, _callee8, this);
	}));

	return function deleteCustomer() {
		return _ref13.apply(this, arguments);
	};
}();

var deleteNote = function () {
	var _ref14 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee9() {
		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
			while (1) {
				switch (_context9.prev = _context9.next) {
					case 0:
						_context9.next = 2;
						return this.$http.delete('//pms.controlinn.com/api' + '/notes/' + this.noteId);

					case 2:
						this.showNotification('La nota se eliminó correctamente.', 'success');
						this.paramsNotes.status = 1;
						this.loadNotes();
						this.noteId = 0;
						this.dialogNote = false;

					case 7:
					case 'end':
						return _context9.stop();
				}
			}
		}, _callee9, this);
	}));

	return function deleteNote() {
		return _ref14.apply(this, arguments);
	};
}();

var deleteSummaryDetail = function () {
	var _ref15 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee10() {
		var bookingCode, productCode;
		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
			while (1) {
				switch (_context10.prev = _context10.next) {
					case 0:
						bookingCode = this.$route.query.bookingCode;
						productCode = this.summaryProductCode;
						_context10.next = 4;
						return this.$http.delete('//pms.controlinn.com/api' + '/details-booking/' + this.summaryId + '/' + productCode + '/' + bookingCode);

					case 4:
						this.showNotification('El producto del resumen de cuenta ha sido eliminado correctamente.', 'success');
						this.closeSummaryConfirm();
						this.loadSummaryData();

					case 7:
					case 'end':
						return _context10.stop();
				}
			}
		}, _callee10, this);
	}));

	return function deleteSummaryDetail() {
		return _ref15.apply(this, arguments);
	};
}();

var downloadSale = function () {
	var _ref17 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee11(_ref18) {
		var saleId = _ref18.saleId,
		    documentNumber = _ref18.documentNumber;
		var id, serie, model, responseType, params, response, blob;
		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
			while (1) {
				switch (_context11.prev = _context11.next) {
					case 0:
						id = saleId || this.saleId;
						serie = documentNumber || this.documentNumber;
						model = { code: 'pdf' };
						responseType = 'blob';
						params = { documentId: id };
						_context11.next = 7;
						return this.$http.post('//pms.controlinn.com/api' + '/report/accountStatus', model, { params: params, responseType: responseType });

					case 7:
						response = _context11.sent;
						blob = helperMethods.generateBlob(response.data);

						helperMethods.showDownloadDialog(blob, serie, 'pdf');

					case 10:
					case 'end':
						return _context11.stop();
				}
			}
		}, _callee11, this);
	}));

	return function downloadSale(_x5) {
		return _ref17.apply(this, arguments);
	};
}();

var downloadSaleTicket = function () {
	var _ref19 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee12(documentId) {
		var urlBase, query, serie, response, blob;
		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
			while (1) {
				switch (_context12.prev = _context12.next) {
					case 0:
						urlBase = '//pms.controlinn.com/api' + '/report/command-preview';
						query = '?format=tabloid&recipe=html-with-browser-client&documentId=' + documentId;
						serie = 'COMANDA-' + documentId;
						_context12.next = 5;
						return this.$http.post('' + urlBase + query);

					case 5:
						response = _context12.sent;
						blob = helperMethods.generateBlob(response.bodyText);

						helperMethods.showDownloadDialog(blob, serie, 'html');

					case 8:
					case 'end':
						return _context12.stop();
				}
			}
		}, _callee12, this);
	}));

	return function downloadSaleTicket(_x6) {
		return _ref19.apply(this, arguments);
	};
}();

var downLoadUniqueTicket = function () {
	var _ref20 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee13(row) {
		var _bookingData, code, numReservation, id, name, baseUrl, query, url, response, blob;

		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
			while (1) {
				switch (_context13.prev = _context13.next) {
					case 0:
						_bookingData = this.bookingData, code = _bookingData.code, numReservation = _bookingData.numReservation;
						id = row.id;
						name = 'COMANDA-' + numReservation;
						baseUrl = '//pms.controlinn.com/api';
						query = '?format=pdf&recipe=html-with-browser-client&documentId=' + id;
						url = 'booking/' + code + '/report/command-preview' + query;
						_context13.next = 8;
						return this.$http.post(baseUrl + '/' + url);

					case 8:
						response = _context13.sent;
						blob = helperMethods.generateBlob(response.bodyText);

						helperMethods.showDownloadDialog(blob, name, 'html');

					case 11:
					case 'end':
						return _context13.stop();
				}
			}
		}, _callee13, this);
	}));

	return function downLoadUniqueTicket(_x7) {
		return _ref20.apply(this, arguments);
	};
}();

var generateSale = function () {
	var _ref21 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee14() {
		var _this9 = this;

		var typeDocumentCode, dataModel, dateResponse, documentId;
		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
			while (1) {
				switch (_context14.prev = _context14.next) {
					case 0:
						typeDocumentCode = this.saleModel.typeDocumentCode;
						dataModel = {
							codeBooking: this.bookingData.code,
							commentary: this.commentary,
							flagTaxes: this.flagTaxes,
							flagShowCustomer: this.flagShowCustomer,
							tip: this.tip,
							transactions: this.paysByTypePayment.map(function (pays) {
								var newPays = {
									amount: pays.amount,
									currency: _this9.currencySelected,
									paymentAmount: pays.amount,
									paymentDate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_date_fns__["format"])(new Date(), 'YYYY-MM-DD'),
									typePaymentId: pays.id
								};
								return newPays;
							}),
							transactionId: this.typePaymentsSelected.map(function (typePay) {
								return typePay.id;
							}),
							typeDocumentCode: this.saleModel.typeDocumentCode,
							typePaymentCode: this.saleModel.typePaymentCode,
							paymentMethodCode: this.saleModel.paymentMethodCode,
							currency: this.currencySelected,
							exchangeRate: this.exchangeRate
						};

						dataModel.details = this.newLocalProductsRows.map(function (local) {
							var newLocal = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, local);
							newLocal.detail = {
								brandId: local.brandId,
								discount: 0,
								quantity: local.quantity,
								price: local.price,
								productType: local.product.type,
								stockQuantity: local.stockQuantity,
								warProductsId: local.idDetail,
								warWarehousesId: local.warWarehousesId,
								flagIgv: local.product.flagIgv,
								flagIgvRequired: local.product.flagIgvRequired,
								igvId: local.product.igvId,
								name: local.product.name,
								code: local.product.code
							};
							return newLocal.detail;
						});
						if (this.saleCustomerId > 0) {
							dataModel.customerId = this.saleCustomerId;
						}
						if (this.creditPayment) {
							dataModel.expirationDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_date_fns__["format"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_date_fns__["addDays"])(new Date(), this.paymentDays), 'YYYY-MM-DD');
						}
						_context14.prev = 5;
						_context14.next = 8;
						return this.$http.post('//pms.controlinn.com/api' + '/booking/payments', dataModel);

					case 8:
						dateResponse = _context14.sent;

						this.showNotification('El cobro se realizó correctamente.', 'success');
						if (typeDocumentCode === 'COT') {
							documentId = dateResponse.body.data.salePaymentId;

							this.downloadSaleTicket(documentId);
						}
						this.loadBookingData();
						_context14.next = 17;
						break;

					case 14:
						_context14.prev = 14;
						_context14.t0 = _context14['catch'](5);

						if (_context14.t0.body.message === 'CHECKIN_IS_REQUIRED') {
							this.showNotification('El CheckIn es requerido', 'error');
						} else if (_context14.t0.body.message === 'CHECKIN_REQUIRED') {
							this.showNotification('El CheckIn es requerido', 'error');
						}

					case 17:
						_context14.prev = 17;

						this.loadSummaryData();
						this.typePaymentsSelected = [];
						this.saleModal = false;
						return _context14.finish(17);

					case 22:
					case 'end':
						return _context14.stop();
				}
			}
		}, _callee14, this, [[5, 14, 17, 22]]);
	}));

	return function generateSale() {
		return _ref21.apply(this, arguments);
	};
}();

var loadBankAccounts = function () {
	var _ref23 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee15() {
		var _ref24, banks;

		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
			while (1) {
				switch (_context15.prev = _context15.next) {
					case 0:
						_context15.next = 2;
						return this.$http.get('//pms.controlinn.com/api' + '/bank-account');

					case 2:
						_ref24 = _context15.sent;
						banks = _ref24.data;

						this.bankAccounts = banks.data;

					case 5:
					case 'end':
						return _context15.stop();
				}
			}
		}, _callee15, this);
	}));

	return function loadBankAccounts() {
		return _ref23.apply(this, arguments);
	};
}();

var loadBillingDetail = function () {
	var _ref25 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee16(id) {
		var baseUrl, code, _ref26, billing;

		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
			while (1) {
				switch (_context16.prev = _context16.next) {
					case 0:
						baseUrl = '//pms.controlinn.com/api';
						code = this.$route.query.bookingCode;
						_context16.next = 4;
						return this.$http.get(baseUrl + '/details-accounts/' + code + '/payments/' + id);

					case 4:
						_ref26 = _context16.sent;
						billing = _ref26.data;

						this.billingDetail = billing.data;
						this.currencySelected = billing.data.currency || billing.data.saleDocument.currency;
						if (billing.data.documentId) {
							this.billingDetails = billing.data.details.map(function (bill) {
								var newBill = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, bill);
								var toPay = bill.amount - bill.amountPayment;
								newBill.documentId = billing.data.documentId;
								newBill.amountToPay = toPay.toFixed(2);
								return newBill;
							});
						} else {
							this.billingDetails = [{
								amount: billing.data.amount,
								amountPayment: billing.data.amount,
								amountToPay: 0,
								documentId: billing.data.id,
								expirationDate: billing.data.createdAt
							}];
						}

					case 9:
					case 'end':
						return _context16.stop();
				}
			}
		}, _callee16, this);
	}));

	return function loadBillingDetail(_x8) {
		return _ref25.apply(this, arguments);
	};
}();

var loadBillings = function () {
	var _ref27 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee17() {
		var baseUrl, code, _ref28, billings;

		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
			while (1) {
				switch (_context17.prev = _context17.next) {
					case 0:
						baseUrl = '//pms.controlinn.com/api';
						code = this.$route.query.bookingCode;
						_context17.next = 4;
						return this.$http.get(baseUrl + '/details-accounts/' + code + '/payments');

					case 4:
						_ref28 = _context17.sent;
						billings = _ref28.data;

						this.billingRows = billings.data.map(function (billing) {
							var newBilling = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, billing);
							newBilling.stateName = billing.flagAmountTotal ? 'Pagado' : 'Pendiente';
							newBilling.showCancel = billing.state.code !== 'ANU' && billing.typeDocument.code !== 'COT';
							newBilling.showCanceled = billing.state.code === 'ANU';
							newBilling.showPrintCot = billing.typeDocument.code === 'COT';
							return newBilling;
						});

					case 7:
					case 'end':
						return _context17.stop();
				}
			}
		}, _callee17, this);
	}));

	return function loadBillings() {
		return _ref27.apply(this, arguments);
	};
}();

var loadBookingData = function () {
	var _ref29 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee18() {
		var _this11 = this;

		var _ref30, booking, services, customerInfo;

		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
			while (1) {
				switch (_context18.prev = _context18.next) {
					case 0:
						_context18.next = 2;
						return this.$http.get('//pms.controlinn.com/api' + '/bookings/' + this.$route.query.bookingCode);

					case 2:
						_ref30 = _context18.sent;
						booking = _ref30.data;

						if (!booking.data.room) {
							booking.data.room = {
								data: {
									roomTypes: {
										data: {
											codeRoomtype: ''
										}
									},
									codeRoom: ''
								}
							};
						}
						booking.data.customerAditional = booking.data.customerAditional || [];
						if (!booking.data.channel) {
							booking.data.channel = {
								data: {
									questions: {}
								}
							};
						}
						if (!booking.data.customer.data.country) {
							booking.data.customer.data.country = { data: {} };
							booking.data.customer.data.countryId = 0;
						}
						this.bookingData = booking.data;
						if (this.bookingData.summary.earlyCheckIn) {
							this.arrayEarly = this.arrayEarly.map(function (earlyObject) {
								var newEarlyObject = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, earlyObject);
								if (earlyObject.id === _this11.bookingData.summary.earlyCheckIn.id) {
									newEarlyObject.hour = _this11.bookingData.summary.earlyCheckIn ? _this11.bookingData.summary.earlyCheckIn.hour : '';
									newEarlyObject.price = _this11.bookingData.summary.earlyCheckIn ? _this11.bookingData.summary.earlyCheckIn.price : 0;
								}
								return newEarlyObject;
							});
							this.earlyCheckin = this.arrayEarly.find(function (early) {
								return early.id === _this11.bookingData.summary.earlyCheckIn.id;
							});
							this.earlyCheckinDisabled = true;
						}
						if (this.bookingData.summary.lateCheckOut) {
							this.arrayLate = this.arrayLate.map(function (lateObject) {
								var newLateObject = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, lateObject);
								if (lateObject.id === _this11.bookingData.summary.lateCheckOut.id) {
									newLateObject.hour = _this11.bookingData.summary.lateCheckOut ? _this11.bookingData.summary.lateCheckOut.hour : '';
									newLateObject.price = _this11.bookingData.summary.lateCheckOut ? _this11.bookingData.summary.lateCheckOut.price : 0;
								}
								return newLateObject;
							});
							this.lateCheckOut = this.arrayLate.find(function (late) {
								return late.id === _this11.bookingData.summary.lateCheckOut.id;
							});
							this.lateCheckOutDisabled = true;
						}
						if (this.bookingData.summary.services && this.bookingData.summary.services.length > 0) {
							services = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.bookingData.summary.services));

							this.getServicesPrices(services);
						}
						customerInfo = this.bookingData.customer ? this.bookingData.customer.data : false;

						if (customerInfo) {
							this.customerId = customerInfo.id;
							this.saleId = this.getSaleId(this.bookingData);
							this.documentNumber = this.bookingData.room ? this.bookingData.room.documentNumber : 0;
							if (customerInfo.flagLoyalty === 1) {
								this.showCheckLoyalty = false;
							}
						}

					case 14:
					case 'end':
						return _context18.stop();
				}
			}
		}, _callee18, this);
	}));

	return function loadBookingData() {
		return _ref29.apply(this, arguments);
	};
}();

var loadBookingHistory = function () {
	var _ref31 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee19() {
		var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
		var response;
		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
			while (1) {
				switch (_context19.prev = _context19.next) {
					case 0:
						this.paramsBookingHistory.page = page;
						this.paramsBookingHistory.idCustomer = this.customerId;
						_context19.next = 4;
						return this.$http.get('//pms.controlinn.com/api' + '/customer/bookings', { params: this.paramsBookingHistory });

					case 4:
						response = _context19.sent;

						this.totalHistoryPages = response.data.meta.pagination.total_pages;
						this.rows = response.data.data.map(function (row) {
							var newRow = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, row);
							if (row.summary && row.summary.booking) {
								newRow.guests = row.summary.booking.adults + row.summary.booking.childrens;
							}
							return newRow;
						});

					case 7:
					case 'end':
						return _context19.stop();
				}
			}
		}, _callee19, this);
	}));

	return function loadBookingHistory() {
		return _ref31.apply(this, arguments);
	};
}();

var loadCities = function () {
	var _ref32 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee20(id) {
		var params, _ref33, cities;

		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
			while (1) {
				switch (_context20.prev = _context20.next) {
					case 0:
						this.model.cityId = 0;
						params = { countryId: id };

						if (!(id > 0)) {
							_context20.next = 8;
							break;
						}

						_context20.next = 5;
						return this.$http.get('//pms.controlinn.com/api' + '/cities', { params: params });

					case 5:
						_ref33 = _context20.sent;
						cities = _ref33.data;

						this.cities = cities.data;

					case 8:
					case 'end':
						return _context20.stop();
				}
			}
		}, _callee20, this);
	}));

	return function loadCities(_x10) {
		return _ref32.apply(this, arguments);
	};
}();

var loadCurrencies = function () {
	var _ref34 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee21() {
		var _ref35, currencies;

		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21) {
			while (1) {
				switch (_context21.prev = _context21.next) {
					case 0:
						_context21.next = 2;
						return this.$http.get('//pms.controlinn.com/api' + '/currency');

					case 2:
						_ref35 = _context21.sent;
						currencies = _ref35.data;

						this.currencies = currencies.data;
						this.currencySelected = currencies.data.find(function (cur) {
							return cur.code === 'USD';
						}).code;

					case 6:
					case 'end':
						return _context21.stop();
				}
			}
		}, _callee21, this);
	}));

	return function loadCurrencies() {
		return _ref34.apply(this, arguments);
	};
}();

var loadEmails = function () {
	var _ref36 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee22() {
		var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

		var emailSearch, _ref37, emails, headers;

		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22) {
			while (1) {
				switch (_context22.prev = _context22.next) {
					case 0:
						this.emailParams.page = page;
						emailSearch = this.bookingData.customer.data.email;

						if (!emailSearch) {
							_context22.next = 12;
							break;
						}

						_context22.next = 5;
						return this.$http.get('//notifications.japisale.com' + '/notifications/' + emailSearch + '/email', { params: this.emailParams });

					case 5:
						_ref37 = _context22.sent;
						emails = _ref37.data;
						headers = _ref37.headers;

						this.emailPages = Number(headers.get('x-last-page'));
						this.emailRows = emails;
						_context22.next = 13;
						break;

					case 12:
						this.showNotification('El huésped no tiene un correo registrado.');

					case 13:
					case 'end':
						return _context22.stop();
				}
			}
		}, _callee22, this);
	}));

	return function loadEmails() {
		return _ref36.apply(this, arguments);
	};
}();

var loadExchangeRate = function () {
	var _ref38 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee23() {
		var today, _ref39, exchangeRate;

		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23) {
			while (1) {
				switch (_context23.prev = _context23.next) {
					case 0:
						today = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_date_fns__["format"])(new Date(), 'YYYY-MM-DD');
						_context23.next = 3;
						return this.$http.get('//pms.controlinn.com/api' + '/exchange-rates/' + today);

					case 3:
						_ref39 = _context23.sent;
						exchangeRate = _ref39.data;

						this.exchangeRate = exchangeRate.data.amount;

					case 6:
					case 'end':
						return _context23.stop();
				}
			}
		}, _callee23, this);
	}));

	return function loadExchangeRate() {
		return _ref38.apply(this, arguments);
	};
}();

var loadNotes = function () {
	var _ref40 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee24() {
		var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

		var request, _ref41, _ref42, notes, count;

		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24) {
			while (1) {
				switch (_context24.prev = _context24.next) {
					case 0:
						this.paramsNotes.page = page;
						request = [this.$http.get('//pms.controlinn.com/api' + '/notes-list', { params: this.paramsNotes }), this.$http.get('//pms.controlinn.com/api' + '/notes/' + this.paramsNotes.bookingCode + '/count')];
						_context24.next = 4;
						return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(request);

					case 4:
						_ref41 = _context24.sent;
						_ref42 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref41, 2);
						notes = _ref42[0];
						count = _ref42[1];

						this.notesRows = notes.data.data;
						this.totalNotesPages = notes.data.meta.pagination.total_pages;
						this.quantityNotes = count.data.data;

					case 11:
					case 'end':
						return _context24.stop();
				}
			}
		}, _callee24, this);
	}));

	return function loadNotes() {
		return _ref40.apply(this, arguments);
	};
}();

var loadResources = function () {
	var _ref43 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee25() {
		var _this13 = this;

		var request, _ref44, _ref45, roomsType, countries, reservationsProducts, typeDocuments, roomtypeSelected;

		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee25$(_context25) {
			while (1) {
				switch (_context25.prev = _context25.next) {
					case 0:
						request = [this.$http.get('//pms.controlinn.com/api' + '/roomtype/' + this.hotelId), this.$http.get('//pms.controlinn.com/api' + '/countries'), this.$http.get('//products.japisale.com' + '/p/products/reservations'), this.$http.get('//pms.controlinn.com/api' + '/documents-type')];
						_context25.next = 3;
						return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(request);

					case 3:
						_ref44 = _context25.sent;
						_ref45 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref44, 4);
						roomsType = _ref45[0];
						countries = _ref45[1];
						reservationsProducts = _ref45[2];
						typeDocuments = _ref45[3];

						this.roomsType = roomsType.data.data;
						this.countries = countries.data.data;
						this.reservationsProducts = reservationsProducts.data;
						roomtypeSelected = this.roomsType.find(function (rt) {
							return rt.id === Number(_this13.roomTypeId);
						});

						this.arrayEarly = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()([], roomtypeSelected.earlyCheckin);
						this.arrayLate = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()([], roomtypeSelected.lateCheckout);
						this.typeDocuments = typeDocuments.data.data;

					case 16:
					case 'end':
						return _context25.stop();
				}
			}
		}, _callee25, this);
	}));

	return function loadResources() {
		return _ref43.apply(this, arguments);
	};
}();

var loadRooms = function () {
	var _ref46 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee26(roomtypeId) {
		var response;
		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee26$(_context26) {
			while (1) {
				switch (_context26.prev = _context26.next) {
					case 0:
						_context26.next = 2;
						return this.$http.get('//pms.controlinn.com/api' + '/roomtype/' + this.hotelId + '/rooms/' + roomtypeId);

					case 2:
						response = _context26.sent;

						this.rooms = response.data.data;

					case 4:
					case 'end':
						return _context26.stop();
				}
			}
		}, _callee26, this);
	}));

	return function loadRooms(_x13) {
		return _ref46.apply(this, arguments);
	};
}();

var loadSaleResources = function () {
	var _ref47 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee27() {
		var request, _ref48, _ref49, documents, payments, paymentMethods, typeDocumentsModified;

		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee27$(_context27) {
			while (1) {
				switch (_context27.prev = _context27.next) {
					case 0:
						request = [this.$http.get('//sales.japisale.com' + '/p/type-documents'), this.$http.get('//sales.japisale.com' + '/p/type-payments'), this.$http.get('//sales.japisale.com' + '/payments-methods')];
						_context27.next = 3;
						return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(request);

					case 3:
						_ref48 = _context27.sent;
						_ref49 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref48, 3);
						documents = _ref49[0];
						payments = _ref49[1];
						paymentMethods = _ref49[2];
						typeDocumentsModified = documents.data.map(function (doc) {
							var newDoc = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, doc);
							if (doc.documentType.code === 'COT') {
								newDoc.documentType.name = 'COMANDA';
							}
							return newDoc;
						});

						this.documentTypes[0] = typeDocumentsModified.find(function (tdm) {
							return tdm.documentType.code === 'BOL';
						});
						this.documentTypes[1] = typeDocumentsModified.find(function (tdm) {
							return tdm.documentType.code === 'FAC';
						});
						this.documentTypes[2] = typeDocumentsModified.find(function (tdm) {
							return tdm.documentType.code === 'COT';
						});
						this.typePayments = payments.data.map(function (pay) {
							var newPay = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, pay);
							newPay.payment = pay.paymentType;
							return newPay.payment;
						});
						this.paymentMethods = paymentMethods.data;
						this.billingTypePaymentCode = this.typePayments[0].code;
						this.saleModel.typePaymentCode = 'efectivo';
						this.saleModel.paymentMethodCode = 'CONTADO';

					case 17:
					case 'end':
						return _context27.stop();
				}
			}
		}, _callee27, this);
	}));

	return function loadSaleResources() {
		return _ref47.apply(this, arguments);
	};
}();

var loadSummaryCategories = function () {
	var _ref50 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee28() {
		var _this14 = this;

		var params, request, _ref51, _ref52, categories, categoriesPermanent, products;

		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee28$(_context28) {
			while (1) {
				switch (_context28.prev = _context28.next) {
					case 0:
						params = {
							permanent: 1
						};
						request = [this.$http.get('//products.japisale.com' + '/p/categories'), this.$http.get('//products.japisale.com' + '/p/categories', { params: params })];
						_context28.next = 4;
						return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(request);

					case 4:
						_ref51 = _context28.sent;
						_ref52 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref51, 2);
						categories = _ref52[0];
						categoriesPermanent = _ref52[1];

						categoriesPermanent.data.forEach(function (categoryPermanent) {
							var newCategory = _this14.categories.every(function (c) {
								return c.id !== categoryPermanent.id;
							});
							if (newCategory) {
								_this14.categories.push(categoryPermanent);
							}
						});
						categories.data.forEach(function (category) {
							var newCategory = _this14.categories.every(function (c) {
								return c.id !== category.id;
							});
							if (newCategory) {
								_this14.categories.push(category);
							}
						});
						products = this.summaryRowsData.map(function (row) {
							var newRow = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, row);
							newRow.categoryId = row.product.categoryId;
							return newRow.categoryId;
						});

						products.forEach(function (p) {
							var productCategory = _this14.categories.find(function (c) {
								return c.id === p;
							});
							var newCategory = _this14.localCategories.every(function (lc) {
								return lc.id !== p;
							});
							if (productCategory && newCategory) {
								_this14.localCategories.push(productCategory);
							}
						});

					case 12:
					case 'end':
						return _context28.stop();
				}
			}
		}, _callee28, this);
	}));

	return function loadSummaryCategories() {
		return _ref50.apply(this, arguments);
	};
}();

var loadSummaryData = function () {
	var _ref53 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee29() {
		var _this15 = this;

		var codeBooking, _ref54, summaryRows;

		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee29$(_context29) {
			while (1) {
				switch (_context29.prev = _context29.next) {
					case 0:
						codeBooking = this.$route.query.bookingCode;
						_context29.next = 3;
						return this.$http.get('//pms.controlinn.com/api' + '/details-booking/' + codeBooking, { params: this.paramsDocuments });

					case 3:
						_ref54 = _context29.sent;
						summaryRows = _ref54.data;

						this.summaryData = summaryRows.data;
						if (summaryRows.data.id || summaryRows.data.length > 0) {
							this.documentNumber = summaryRows.data.serie + '-' + summaryRows.data.number;
							this.summaryRows = summaryRows.data.details.map(function (detail, index) {
								var newDetail = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, detail);
								newDetail.isSelected = false;
								newDetail.createdAt = detail.createdAt;
								newDetail.flagUse = detail.flagUse === 0 ? null : detail.flagUse;
								newDetail.flagIgv = detail.product.flagIgv;
								newDetail.flagIgvRequired = detail.product.flagIgvRequired;
								newDetail.igvId = detail.product.igvId;
								newDetail.name = detail.product.name;
								newDetail.code = detail.product.code;
								newDetail.id = detail.product.id;
								newDetail.idDetail = _this15.summaryData.details[index].id;
								return newDetail;
							});
						} else {
							this.documentNumber = '';
							this.summaryRows = [];
						}
						this.summaryRowsData = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.summaryRows));
						this.loadSummaryCategories();

					case 9:
					case 'end':
						return _context29.stop();
				}
			}
		}, _callee29, this);
	}));

	return function loadSummaryData() {
		return _ref53.apply(this, arguments);
	};
}();

var loadSummaryProducts = function () {
	var _ref55 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee30() {
		var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
		var response;
		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee30$(_context30) {
			while (1) {
				switch (_context30.prev = _context30.next) {
					case 0:
						this.paramsSummary.page = page;
						_context30.next = 3;
						return this.$http.get('//products.japisale.com' + '/p/products', { params: this.paramsSummary });

					case 3:
						response = _context30.sent;

						this.totalModalPages = Number(response.headers.get('x-last-page'));
						this.productRows = response.data.map(function (product) {
							var newProduct = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, product);
							newProduct.quantity = 1;
							newProduct.isSelected = false;
							newProduct.discount = 0;
							return newProduct;
						});

					case 6:
					case 'end':
						return _context30.stop();
				}
			}
		}, _callee30, this);
	}));

	return function loadSummaryProducts() {
		return _ref55.apply(this, arguments);
	};
}();

var loadWarehouses = function () {
	var _ref56 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee31() {
		var _this16 = this;

		var params, response;
		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee31$(_context31) {
			while (1) {
				switch (_context31.prev = _context31.next) {
					case 0:
						params = {
							flagActive: 1
						};
						_context31.next = 3;
						return this.$http.get('//products.japisale.com' + '/p/warehouses', { params: params });

					case 3:
						response = _context31.sent;

						response.data.forEach(function (warehouse) {
							_this16.warehouses.push(warehouse);
						});

					case 5:
					case 'end':
						return _context31.stop();
				}
			}
		}, _callee31, this);
	}));

	return function loadWarehouses() {
		return _ref56.apply(this, arguments);
	};
}();

var payBilling = function () {
	var _ref61 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee32() {
		var billingModel;
		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee32$(_context32) {
			while (1) {
				switch (_context32.prev = _context32.next) {
					case 0:
						billingModel = {
							bankAccountId: this.billingBankAccountId > 0 ? this.billingBankAccountId : null,
							typePaymentCode: this.billingTypePaymentCode,
							currency: this.currencySelected,
							amount: this.billingDetails[0].amountToPay,
							codeBooking: this.$route.query.bookingCode,
							idDocument: this.billingDetail.documentId
						};
						_context32.next = 3;
						return this.$http.post('//pms.controlinn.com/api' + '/amortizations', billingModel);

					case 3:
						this.showNotification('El pago se realizó correctamente.', 'success');
						this.closeBillingDialog();
						this.loadBillings();

					case 6:
					case 'end':
						return _context32.stop();
				}
			}
		}, _callee32, this);
	}));

	return function payBilling() {
		return _ref61.apply(this, arguments);
	};
}();

var saveCustomer = function () {
	var _ref63 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee33() {
		var _ref64, customer;

		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee33$(_context33) {
			while (1) {
				switch (_context33.prev = _context33.next) {
					case 0:
						_context33.next = 2;
						return this.$http.post('//pms.controlinn.com/api' + '/customers', this.newCustomerSale);

					case 2:
						_ref64 = _context33.sent;
						customer = _ref64.data;

						this.showNotification('El cliente ha sido registrado correctamente.', 'success');
						this.saleCustomer.name = this.newCustomerSale.name + ' ' + this.newCustomerSale.lastname;
						this.saleCustomer.document = this.newCustomerSale.numDocument;
						this.saleData.typeDocument = this.newCustomerSale.documentType;
						this.saleData.numDocument = this.newCustomerSale.numDocument;
						this.saleCustomerId = customer.data.id;
						this.backToSales();

					case 11:
					case 'end':
						return _context33.stop();
				}
			}
		}, _callee33, this);
	}));

	return function saveCustomer() {
		return _ref63.apply(this, arguments);
	};
}();

var saveData = function () {
	var _ref65 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee34() {
		var _this17 = this;

		var modelData, _ref66, checkin;

		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee34$(_context34) {
			while (1) {
				switch (_context34.prev = _context34.next) {
					case 0:
						if (this.bookingData.customer.data.flagGeneric) {
							_context34.next = 21;
							break;
						}

						modelData = {
							codeBooking: this.bookingData.code,
							idSubsidiary: this.hotelId,
							specialRequest: this.bookingData.summary.personalInformation.specialRequest,
							extraBed: this.bedSelected ? this.getExtraBed(this.aditionalBedPrice) : null,
							addCrib: this.cribSelected ? this.getCrib(this.cribPrice) : null
						};

						if (this.earlyCheckin) {
							modelData.earlyCheckin = this.earlyCheckin;
						}
						if (this.lateCheckOut) {
							modelData.lateCheckout = this.lateCheckOut;
						}
						_context34.prev = 4;
						_context34.next = 7;
						return this.$http.put('//pms.controlinn.com/api' + '/booking/checkin', modelData);

					case 7:
						_ref66 = _context34.sent;
						checkin = _ref66.data;

						this.customerId = checkin.data.id;
						if (!this.saleId || this.saleId === 0) {
							this.saleId = checkin.data.room.data.saleId;
						}
						if (!this.bookingData.bookingState) {
							this.bookingData.bookingState = checkin.data.bookingState;
						}
						this.showNotification('La información se guardó correctamente.', 'success');
						this.active = 'tab-' + this.items[(this.items.indexOf(function (row) {
							return 'tab-' + row.id === _this17.active;
						}) + 2) % this.items.length].id;
						_context34.next = 19;
						break;

					case 16:
						_context34.prev = 16;
						_context34.t0 = _context34['catch'](4);

						if (_context34.t0.status === 405) {
							this.showNotification('Esta habitación no cuenta con disponibilidad para las fechas seleccionadas.', 'error');
						} else if (_context34.t0.status === 400) {
							if (_context34.t0.data.cellPhone) {
								this.showNotification('El teléfono celular debe tener entre 9 y 11 dígitos.', 'error');
							}
						}

					case 19:
						_context34.next = 22;
						break;

					case 21:
						this.showNotification('Este usuario es Genérico, no es posible hacer CheckIn', 'warning');

					case 22:
					case 'end':
						return _context34.stop();
				}
			}
		}, _callee34, this, [[4, 16]]);
	}));

	return function saveData() {
		return _ref65.apply(this, arguments);
	};
}();

var saveNote = function () {
	var _ref67 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee35(_ref68) {
		var note = _ref68.note,
		    id = _ref68.id,
		    status = _ref68.status;
		var update, updateId, method, url, archiveMessage, filter, filterVal, saveMessage, archiveModel, updateModel, createModel, putModel, model, message;
		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee35$(_context35) {
			while (1) {
				switch (_context35.prev = _context35.next) {
					case 0:
						update = id || this.noteId > 0;
						updateId = id || this.noteId;
						method = update ? 'put' : 'post';
						url = update ? 'notes/' + updateId : 'notes';
						archiveMessage = status > 0 ? 'archivó' : 'activó';
						filter = status && status > 1 ? 1 : 2;
						filterVal = id ? filter : 1;
						saveMessage = this.noteId > 0 ? 'actualizó' : 'creó';
						archiveModel = {
							note: note,
							status: status > 1 ? 1 : 2
						};
						updateModel = {
							note: this.note,
							status: this.noteStatus
						};
						createModel = {
							note: this.note,
							bookingCode: this.$route.query.bookingCode,
							status: 1,
							flagActive: 1
						};
						putModel = id ? archiveModel : updateModel;
						model = update ? putModel : createModel;
						message = id ? archiveMessage : saveMessage;
						_context35.next = 16;
						return this.$http[method]('//pms.controlinn.com/api' + '/' + url, model);

					case 16:
						this.showNotification('La nota se ' + message + ' correctamente.', 'success');
						this.filterValue = filterVal;
						this.paramsNotes.status = model.status;
						this.loadNotes();
						this.note = '';
						this.noteId = 0;
						this.noteStatus = null;
						this.inputNote = false;

					case 24:
					case 'end':
						return _context35.stop();
				}
			}
		}, _callee35, this);
	}));

	return function saveNote(_x15) {
		return _ref67.apply(this, arguments);
	};
}();

var searchCustomer = function () {
	var _ref69 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee36() {
		var params, _ref70, customer;

		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee36$(_context36) {
			while (1) {
				switch (_context36.prev = _context36.next) {
					case 0:
						params = {
							documentType: this.model.documentType,
							numDocument: this.model.numDocument
						};

						if (!(this.model.numDocument !== '')) {
							_context36.next = 13;
							break;
						}

						_context36.prev = 2;
						_context36.next = 5;
						return this.$http.get('//pms.controlinn.com/api' + '/customer-search', { params: params });

					case 5:
						_ref70 = _context36.sent;
						customer = _ref70.data;

						if (customer.data) {
							this.model = customer.data;
							this.model.countryId = '' + 172;
							this.model.dateBirth = customer.data.dateBirth && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_date_fns__["isDate"])(new Date(customer.data.dateBirth)) ? customer.data.dateBirth : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_date_fns__["format"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_date_fns__["subYears"])(new Date(), 18), 'YYYY-MM-DD');
							if (this.model.flagLoyalty === 1) {
								this.showCheckLoyalty = false;
							}
						}
						_context36.next = 13;
						break;

					case 10:
						_context36.prev = 10;
						_context36.t0 = _context36['catch'](2);

						if (_context36.t0.status === 405) {
							if (_context36.t0.data.message === 'CUSTOMER_NOT_FOUND') {
								if (Number(this.model.documentType) === 4) {
									this.searchCustomerByMixin();
								} else {
									this.showNotification('El cliente no se encuentra registrado', 'error');
								}
							}
						} else if (_context36.t0.status === 404) {
							if (_context36.t0.data.message === 'CUSTOMER_NOT_FOUND') {
								if (Number(this.model.documentType) === 4) {
									this.searchCustomerByMixin();
								} else {
									this.showNotification('El cliente no se encuentra registrado', 'error');
								}
							}
						}

					case 13:
					case 'end':
						return _context36.stop();
				}
			}
		}, _callee36, this, [[2, 10]]);
	}));

	return function searchCustomer() {
		return _ref69.apply(this, arguments);
	};
}();

var searchCustomerByMixin = function () {
	var _ref71 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee37() {
		var _ref72, customer, newCustomer;

		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee37$(_context37) {
			while (1) {
				switch (_context37.prev = _context37.next) {
					case 0:
						_context37.prev = 0;
						_context37.next = 3;
						return this.mixinSearchCustomer(this.model.documentType, this.model.numDocument);

					case 3:
						_ref72 = _context37.sent;
						customer = _ref72.data;
						newCustomer = {
							address: customer.data.domicilio,
							cardVip: '',
							cityId: 0,
							civilStatus: 0,
							countryId: 172,
							dateBirth: customer.data.fecha_inscripcion && customer.data.fecha_inscripcion !== '0000-00-00' && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_date_fns__["isDate"])(new Date(customer.data.fecha_inscripcion)) ? customer.data.fecha_inscripcion : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_date_fns__["format"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_date_fns__["subYears"])(new Date(), 18), 'YYYY-MM-DD'),
							documentType: 4,
							email: '',
							flagLoyalty: false,
							flagTaxes: false,
							gender: 0,
							lastname: '',
							name: customer.data.nombre,
							numDocument: customer.data.ruc,
							phone: customer.data.telefono
						};

						this.model = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, newCustomer);
						_context37.next = 12;
						break;

					case 9:
						_context37.prev = 9;
						_context37.t0 = _context37['catch'](0);

						if (_context37.t0.status === 405) {
							if (_context37.t0.data.message === 'No se ha encontrado resultados.') {
								this.showNotification('No se encontraron resultados.', 'error');
							}
						}

					case 12:
					case 'end':
						return _context37.stop();
				}
			}
		}, _callee37, this, [[0, 9]]);
	}));

	return function searchCustomerByMixin() {
		return _ref71.apply(this, arguments);
	};
}();

var searchCustomerSale = function () {
	var _ref73 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee38() {
		var params, _ref74, customer, saleCustomer;

		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee38$(_context38) {
			while (1) {
				switch (_context38.prev = _context38.next) {
					case 0:
						params = {
							documentType: this.saleData.typeDocument,
							numDocument: this.saleData.numDocument
						};

						if (!(this.saleData.numDocument !== '')) {
							_context38.next = 13;
							break;
						}

						_context38.prev = 2;
						_context38.next = 5;
						return this.$http.get('//pms.controlinn.com/api' + '/customer-search', { params: params });

					case 5:
						_ref74 = _context38.sent;
						customer = _ref74.data;

						if (customer.data) {
							saleCustomer = customer.data;

							this.saleCustomer.name = saleCustomer.name + ' ' + saleCustomer.lastname;
							this.saleCustomer.document = saleCustomer.numDocument;
							this.saleCustomerId = customer.data.id;
						}
						_context38.next = 13;
						break;

					case 10:
						_context38.prev = 10;
						_context38.t0 = _context38['catch'](2);

						if (_context38.t0.status === 405) {
							if (_context38.t0.data.message === 'CUSTOMER_NOT_FOUND') {
								this.saleData.typeDocument = this.bookingData.customer.data.documentType;
								this.saleData.numDocument = this.bookingData.customer.data.numDocument;
								this.alertMessage = 'El cliente buscado no se encuentra registrado. Puede continuar el proceso con el cliente registrado en la reserva o agregar el cliente en el tab "Nuevo Cliente".';
								this.alertWarning = false;
								this.alertInfo = true;
								this.alert = true;
							}
						} else if (_context38.t0.status === 404) {
							if (_context38.t0.data.message === 'CUSTOMER_NOT_FOUND') {
								this.saleData.typeDocument = this.bookingData.customer.data.documentType;
								this.saleData.numDocument = this.bookingData.customer.data.numDocument;
								this.alertMessage = 'El cliente buscado no se encuentra registrado. Puede continuar el proceso con el cliente registrado en la reserva o agregar el cliente en el tab "Nuevo Cliente".';
								this.alertWarning = false;
								this.alertInfo = true;
								this.alert = true;
							}
						}

					case 13:
					case 'end':
						return _context38.stop();
				}
			}
		}, _callee38, this, [[2, 10]]);
	}));

	return function searchCustomerSale() {
		return _ref73.apply(this, arguments);
	};
}();

var searchCustomerNew = function () {
	var _ref75 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee39() {
		var _ref76, customer;

		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee39$(_context39) {
			while (1) {
				switch (_context39.prev = _context39.next) {
					case 0:
						if (!(Number(this.newCustomerSale.documentType) === 4)) {
							_context39.next = 7;
							break;
						}

						_context39.next = 3;
						return this.$http.get("//perudatos.controlinn.com/api" + '/ruc/' + this.newCustomerSale.numDocument);

					case 3:
						_ref76 = _context39.sent;
						customer = _ref76.data;

						this.newCustomerSale.name = customer.data.nombre;
						this.newCustomerSale.document = customer.data.ruc;

					case 7:
					case 'end':
						return _context39.stop();
				}
			}
		}, _callee39, this);
	}));

	return function searchCustomerNew() {
		return _ref75.apply(this, arguments);
	};
}();

var updateChannel = function () {
	var _ref79 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee40() {
		var modelUpdate;
		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee40$(_context40) {
			while (1) {
				switch (_context40.prev = _context40.next) {
					case 0:
						modelUpdate = {
							codeBooking: this.bookingData.code,
							channelInformation: this.bookingData.channel.data.questions
						};
						_context40.next = 3;
						return this.$http.put('//pms.controlinn.com/api' + '/booking/channel', modelUpdate);

					case 3:
						this.showNotification('La información del canal se actualizó correctamente.', 'success');
						this.showChannelForm = false;
						this.loadBookingData();

					case 6:
					case 'end':
						return _context40.stop();
				}
			}
		}, _callee40, this);
	}));

	return function updateChannel() {
		return _ref79.apply(this, arguments);
	};
}();

var updateProducts = function () {
	var _ref80 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee41() {
		var code, details, model, productWithOutWarehouse;
		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee41$(_context41) {
			while (1) {
				switch (_context41.prev = _context41.next) {
					case 0:
						code = this.$route.query.bookingCode;
						details = this.productRows.map(function (product) {
							var newProduct = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, product);
							if (product.isSelected) {
								newProduct.detail = {
									brandId: product.brandId,
									discount: product.discount,
									quantity: Number(product.quantity),
									price: product.price,
									productType: product.type,
									stockQuantity: product.stock,
									warProductsId: product.id,
									warWarehousesId: product.warehouseId
								};
							}
							return newProduct.detail;
						});
						model = details.filter(function (detail) {
							return detail;
						});
						productWithOutWarehouse = this.productRows.find(function (p) {
							return p.isSelected && !p.warehouseId;
						});

						if (productWithOutWarehouse) {
							_context41.next = 12;
							break;
						}

						_context41.next = 7;
						return this.$http.patch('//pms.controlinn.com/api' + '/sale/details/' + code, model);

					case 7:
						this.showNotification('Se agregaron nuevos productos.', 'success');
						this.dialog = false;
						this.loadSummaryData();
						_context41.next = 13;
						break;

					case 12:
						if (productWithOutWarehouse) {
							this.showNotification('Uno o más productos seleccionados ya han sido agregados y no cuentan con un almacén asignado.', 'error');
						} else {
							this.showNotification('Uno o más productos seleccionados no cuentan con un almacén asignado.', 'error');
						}

					case 13:
					case 'end':
						return _context41.stop();
				}
			}
		}, _callee41, this);
	}));

	return function updateProducts() {
		return _ref80.apply(this, arguments);
	};
}();

var updateCheckOut = function () {
	var _ref81 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee42() {
		var codeBooking, bodyUpdate;
		return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee42$(_context42) {
			while (1) {
				switch (_context42.prev = _context42.next) {
					case 0:
						this.disabledUpdateCheckOut = true;
						codeBooking = this.bookingData.code;
						bodyUpdate = {
							idSubsidiary: this.hotelId,
							lateCheckout: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, this.lateCheckOut)
						};
						_context42.prev = 3;
						_context42.next = 6;
						return this.$http.put('//pms.controlinn.com/api' + '/booking-checkout/' + codeBooking, bodyUpdate);

					case 6:
						_context42.next = 12;
						break;

					case 8:
						_context42.prev = 8;
						_context42.t0 = _context42['catch'](3);

						this.showNotification('No se realizo el check out', 'success');
						this.disabledUpdateCheckOut = false;

					case 12:
						_context42.prev = 12;

						this.showNotification('Se realizo el check out', 'error');
						this.disabledUpdateCheckOut = true;
						return _context42.finish(12);

					case 16:
					case 'end':
						return _context42.stop();
				}
			}
		}, _callee42, this, [[3, 8, 12, 16]]);
	}));

	return function updateCheckOut() {
		return _ref81.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var helperMethods = __WEBPACK_IMPORTED_MODULE_12__shared_helper__["a" /* default */].methods;

function showAccommodationOption(_ref3) {
	var salDocumentsNumber = _ref3.salDocumentsNumber;

	return !salDocumentsNumber;
}

function closeModal() {
	this.visibleModal = false;
	this.saveModal();
}

function openModal(subTotal, detail, code) {
	this.modalSubTotal = Number(subTotal);
	this.modalDetail = Number(detail);
	this.modalCode = Number(code);
	this.visibleModal = true;
}

function cancelModal() {
	this.visibleModal = false;
}

function created() {
	var _this2 = this;

	this.loadResources();
	this.loadCurrencies();
	this.loadExchangeRate();
	var allDays = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_date_fns__["eachDay"])(this.$route.query.initDate, this.$route.query.endDate);
	allDays.forEach(function (d) {
		if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_date_fns__["differenceInDays"])(new Date(), d) === 0) {
			_this2.isToday = true;
		}
	});
	if (!this.isToday) {
		this.showNotification('Esta reserva no está disponible para realizar el check in.', 'primary');
	}
	if (this.$route.query.active) {
		this.active = this.$route.query.active;
		this.loadBookingData();
	}
}

function actionNoteButton() {
	return this.noteId > 0 ? 'Actualizar Nota' : 'Guardar Nota';
}

function active(val) {
	if (val === 'tab-1' && this.$route.query.bookingCode) {
		this.loadBookingData();
	}
	if (val === 'tab-2') {
		this.loadSummaryData();
		if (Number(this.bookingData.bookingState) === 3) {
			this.showNotification('Ya se realizó el check out de esta reserva.', 'info');
		}
	}
	if (val === 'tab-3') {
		this.loadNotes();
	}
	if (val === 'tab-4') {
		this.loadBookingHistory();
	}
	if (val === 'tab-5') {
		this.loadEmails();
	}
	if (val === 'tab-6') {
		this.loadBillings();
	}
}

function addCustomer() {
	if (!this.saleCustomer.name && !this.saleCustomer.document) {
		this.newCustomerSale.documentType = this.saleData.typeDocument;
		this.newCustomerSale.numDocument = this.saleData.numDocument;
	}
	this.salesTabs = 'tab-customer';
}

function addGuestDisabled() {
	var childError = this.personType === 2 && this.personTypeName === 'Adulto';
	var adultError = this.personType === 1 && this.personTypeName === 'Niño(a)';
	if (childError) {
		this.showNotification('Este formulario solo acepta datos de un(a) niño(a). Para ingresar datos de un adulto cancele la operación y cambie de formulario.', 'info');
	}
	if (adultError) {
		this.showNotification('Este formulario requiere datos de un adulto. Para ingresar datos de un niño cancele la operación y cambie de formulario.', 'info');
	}
	return this.$v.model.$invalid || childError || adultError;
}

function additionalCustomersIsEmpty() {
	return this.bookingData.customerAditional.length === 0;
}

function addNotes() {
	this.inputNote = true;
}

function addPays(paymentsType) {
	var _this3 = this;

	this.paysByTypePayment = paymentsType.map(function (pay) {
		var newAmount = _this3.totalLocalAmount / paymentsType.length;
		var newPay = {
			amount: newAmount.toFixed(2),
			code: pay.code,
			id: pay.id,
			name: pay.name
		};
		return newPay;
	});
}

function addProductsDisabled() {
	return this.productRows.every(function (product) {
		return !product.isSelected;
	});
}

function arrowIconBirth() {
	var arrow = this.onChange ? 'arrow_drop_up' : 'arrow_drop_down';
	return arrow;
}

function arrowIconEnd() {
	var arrowEnd = this.onChangeEnd ? 'arrow_drop_up' : 'arrow_drop_down';
	return arrowEnd;
}

function arrowIconProduct() {
	var arrowProduct = this.onChangeProduct ? 'arrow_drop_up' : 'arrow_drop_down';
	return arrowProduct;
}

function arrowIconStart() {
	var arrowStart = this.onChangeStart ? 'arrow_drop_up' : 'arrow_drop_down';
	return arrowStart;
}

function backToSales() {
	this.salesTabs = 'tab-sales';
	this.newCustomerSale = {
		address: '',
		documentType: 1,
		email: '',
		name: '',
		lastname: '',
		numDocument: ''
	};
}

function backToTab() {
	var _this4 = this;

	this.active = 'tab-' + this.items[(this.items.findIndex(function (row) {
		return 'tab-' + row.id === _this4.active;
	}) - 1) % this.items.length].id;
}

function bankAccountsDisabled() {
	if (this.billingTypePaymentCode !== 'deposito-bancario') {
		this.billingBankAccountId = 0;
	}
	return this.billingTypePaymentCode !== 'deposito-bancario';
}

function billingActive() {
	return this.saleModel.typeDocumentCode === 'FAC';
}

function cancelAddGuest() {
	this.customerForm = false;
	this.personType = null;
	this.model = {
		address: '',
		cardVip: '',
		cityId: 0,
		civilStatus: 1,
		countryId: 0,
		dateBirth: '',
		documentType: 1,
		email: '',
		id: 0,
		gender: 1,
		lastname: '',
		name: '',
		numDocument: '',
		phone: ''
	};
}

function cancelDeleteCustomer() {
	this.dialogCustomer = false;
	this.customerIdSelected = null;
	this.customerIndex = null;
}

function cancelDeleteNote() {
	this.noteId = 0;
	this.dialogNote = false;
}

function cancelUpdateChannel() {
	this.showChannelForm = false;
}

function cantAddGuest() {
	return !this.personType || this.customerForm;
}

function cantBilling() {
	return this.saleData.typeDocument !== 4 && this.saleData.typeDocument !== 2 && this.saleData.typeDocument !== 5;
}

function exchangeNumber(number) {
	var exchangeRate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3.50;

	return Number(number) * exchangeRate;
}

function crazyConvertion(cur, detailItem) {
	if (cur === 'USD') {
		return detailItem.price;
	}
	if (detailItem.product.priceSoles) {
		return detailItem.product.priceSoles;
	}
	return exchangeNumber(detailItem.price, this.exchangeRate);
}

function changeAmounts(currencyCode, includes) {
	var _this5 = this;

	if (includes) {
		this.newLocalProductsRows = this.localProductsRows.map(function (lpr) {
			var newLpr = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, lpr);
			if (lpr.product.flagIgv) {
				newLpr.price = crazyConvertion.call(_this5, currencyCode, lpr);
				newLpr.subTotal = currencyCode === 'USD' ? Number(lpr.subTotal) : Number(lpr.subTotal) * Number(_this5.exchangeRate);
			} else {
				newLpr.price = crazyConvertion.call(_this5, currencyCode, lpr);
				newLpr.subTotal = currencyCode === 'USD' ? Number(lpr.subTotal) + Number(lpr.subTotal) * 0.18 : (Number(lpr.subTotal) + Number(lpr.subTotal) * 0.18) * Number(_this5.exchangeRate);
			}
			return newLpr;
		});
	} else {
		this.newLocalProductsRows = this.localProductsRows.map(function (lpr) {
			var newLpr = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, lpr);
			if (lpr.product.flagIgv && !lpr.product.flagIgvRequired) {
				newLpr.price = crazyConvertion.call(_this5, currencyCode, lpr);
				newLpr.subTotal = currencyCode === 'USD' ? Number(lpr.subTotal) - Number(lpr.subTotal) * 0.18 : (Number(lpr.subTotal) - Number(lpr.subTotal) * 0.18) * Number(_this5.exchangeRate);
			} else {
				newLpr.price = crazyConvertion.call(_this5, currencyCode, lpr);
				newLpr.subTotal = currencyCode === 'USD' ? Number(lpr.subTotal) : Number(lpr.subTotal) * Number(_this5.exchangeRate);
			}
			return newLpr;
		});
	}
}

function changeEndIcon(result) {
	this.onChangeEnd = result;
}

function changeIcon(result) {
	this.onChange = result;
}

function changeIconProduct(result) {
	this.onChangeProduct = result;
}

function changeIconStart(result) {
	this.onChangeStart = result;
}

function channelHasProperties() {
	var chanelQuestions = this.bookingData.channel.data.questions ? __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.bookingData.channel.data.questions).length > 0 : false;
	return chanelQuestions;
}

function chargeBtnText() {
	return this.$route.query && this.$route.query.code === 'no-show' ? 'Cobrar No-show' : 'Cobrar';
}

function checkinActive() {
	var state = Number(this.bookingData.bookingState);
	return state === 1 || state === 4;
}

function checkoutDisabled() {
	return !this.summaryData.flagCheckout || Number(this.bookingData.bookingState) === 3;
}

function closeBillingDialog() {
	this.dialogBillingDetail = false;
	this.dialogBillingPay = false;
	this.dialogCancelBilling = false;
	this.billingDetail = {};
	this.billingDetails = [];
	this.billingId = 0;
	this.billingNumber = '';
}

function closeSummaryConfirm() {
	this.summaryConfirm = false;
	this.summaryId = 0;
	this.summaryName = '';
}

function columnSortableEvent(_ref11) {
	var id = _ref11.id;

	var self = this;
	var newColumn = self.columns.filter(function (column) {
		return column.id === id;
	});
	newColumn[0].isSortable = newColumn[0].isSortable.down ? { down: false, up: true } : { down: true, up: false };
	self.columns = self.columns.map(function (columnSingle) {
		var newColumnSingle = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, columnSingle);
		if (columnSingle.isSortable) {
			if (columnSingle.id !== newColumn[0].id) {
				newColumnSingle.isSortable = { down: true, up: false };
			}
		}
		return newColumnSingle;
	});
	this.paramsBookingHistory.sortField = newColumn[0].code;
	this.paramsBookingHistory.sortDirection = newColumn[0].isSortable.up ? 'asc' : 'desc';
	this.loadBookingHistory();
}

function confirmCancelBilling(_ref12) {
	var id = _ref12.id,
	    serie = _ref12.serie,
	    number = _ref12.number;

	this.billingId = id;
	this.billingNumber = serie + '-' + number;
	this.dialogCancelBilling = true;
}

function creditPayment() {
	return this.saleModel.paymentMethodCode === 'CREDITO';
}

function customerBtnText() {
	var _this7 = this;

	var customerSelected = this.bookingData.customerAditional.find(function (c) {
		return c.id === _this7.model.id;
	});
	var idCustomer = customerSelected ? customerSelected.id : null;
	var modelId = this.model.id === this.bookingData.customer.data.id ? this.model.id : null;
	return idCustomer || modelId ? 'Actualizar' : 'Agregar';
}

function customerNumber() {
	return this.customerIndex + 2;
}

function datesDisabled(date) {
	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_date_fns__["isAfter"])(new Date(), date);
}

function deleteSummaryDetailConfirm(_ref16) {
	var idDetail = _ref16.idDetail,
	    description = _ref16.description,
	    product = _ref16.product;

	this.summaryId = idDetail;
	this.summaryName = description || product.name;
	this.summaryProductCode = product.code;
	this.summaryConfirm = true;
}

function disabledSave() {
	return this.billingActive && this.cantBilling;
}

function disableGenerateSale() {
	return !this.creditPayment && (this.paysByTypePayment.length === 0 || this.paysByTypePayment.some(function (payByType) {
		return !payByType.amount;
	}));
}

function documentTypeName() {
	var _this8 = this;

	var docType = this.typeDocuments.find(function (doc) {
		return doc.id === _this8.saleData.typeDocument;
	}) || {};
	return docType.name;
}

function earlyCheckInIsSelected() {
	return !!this.earlyCheckin;
}

function emailVisiblePages() {
	if (this.emailPages >= 1 && this.emailPages < 5) {
		return this.emailPages;
	}
	return 5;
}

function filterBookings() {
	this.paramsBookingHistory.dateInit = this.startDate;
	this.paramsBookingHistory.dateEnd = this.endDate;
	this.loadBookingHistory();
}

function filterProducts() {
	if (this.productCategory > 0) {
		this.paramsSummary.categories = this.productCategory;
	} else {
		delete this.paramsSummary.categories;
	}
	if (this.productWarehouse > 0) {
		this.paramsSummary.warehouses = this.productWarehouse;
	} else {
		delete this.paramsSummary.warehouses;
	}
	this.loadSummaryProducts();
}

function filterSummary() {
	this.paramsDocuments.dateStart = this.createdAt;
	this.paramsDocuments.dateEnd = this.createdAt;
	this.loadSummaryData();
}

function firstTabActive() {
	return this.active === 'tab-1';
}

function goToCalendar() {
	this.$router.push({ name: 'cms-calendar' });
}

function goToSummary() {
	var _this10 = this;

	this.active = 'tab-' + this.items[(this.items.indexOf(function (row) {
		return 'tab-' + row.id === _this10.active;
	}) + 2) % this.items.length].id;
}

function isAnAdult() {
	return this.personType === 1;
}

function igvExonerated(_ref22) {
	var product = _ref22.product;

	return product.igvId === 15;
}

function isNaturalPerson() {
	return this.newCustomerSale.documentType !== 4 || this.model.documentType === 5;
}

function isNaturalPersonModel() {
	return this.model.documentType !== 4;
}

function isNoShow() {
	return this.active !== 'tab-2' && this.$route.query.code && this.$route.query.code === 'no-show';
}

function lateCheckOutIsSelected() {
	return !!this.lateCheckOut;
}

function getSaleId(book) {
	var dataRoom = book.room.data;
	if (dataRoom.length) {
		return dataRoom[0].saleId;
	}
	return dataRoom.saleId;
}

function getServicesPrices(services) {
	var _this12 = this;

	services.forEach(function (service) {
		if (service.code === 'EXTRABEG') {
			_this12.bedSelected = true;
			_this12.aditionalBedPrice = service.price;
		}
		if (service.code === 'CRIB') {
			_this12.cribSelected = true;
			_this12.cribPrice = service.price;
		}
	});
}

function nameLabel() {
	return this.isNaturalPerson ? 'Nombres' : 'Razón Social';
}

function nameModelLabel() {
	return this.isNaturalPersonModel ? 'Nombres' : 'Razón Social';
}

function nameModelMessage() {
	return this.isNaturalPersonModel ? 'El nombre es requerido' : 'La razón social es requerida';
}

function nameValidateMessage() {
	return this.isNaturalPerson ? 'El nombre es requerido' : 'La razón social es requerida';
}

function noCustomerId() {
	return this.customerId !== null && (Number(this.bookingData.bookingState) === 2 || Number(this.bookingData.bookingState) === 3);
}

function notesColumnSortableEvent(_ref57) {
	var id = _ref57.id;

	var self = this;
	var newColumn = self.notesColumns.filter(function (column) {
		return column.id === id;
	});
	newColumn[0].isSortable = newColumn[0].isSortable.down ? { down: false, up: true } : { down: true, up: false };
	self.notesColumns = self.notesColumns.map(function (columnSingle) {
		var newColumnSingle = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, columnSingle);
		if (columnSingle.isSortable) {
			if (columnSingle.id !== newColumn[0].id) {
				newColumnSingle.isSortable = { down: true, up: false };
			}
		}
		return newColumnSingle;
	});
	this.notesSortField = newColumn[0].code;
	this.notesSortDirection = newColumn[0].isSortable.up ? 'asc' : 'desc';
}

function notesPagesVisible() {
	if (this.totalNotesPages >= 1 && this.totalNotesPages < 5) {
		return this.totalNotesPages;
	}
	return 5;
}

function numberNights() {
	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_date_fns__["differenceInDays"])(this.$route.query.endDate, this.$route.query.initDate);
}

function numDocumentLength() {
	if (this.model.documentType === 1) {
		return 8;
	} else if (this.model.documentType === 4) {
		return 11;
	}
	return 0;
}

function openBillingDetail(_ref58) {
	var id = _ref58.id;

	this.loadBillingDetail(id);
	this.dialogBillingDetail = true;
}

function openBillingPay(_ref59) {
	var id = _ref59.id;

	this.loadSaleResources();
	this.loadBankAccounts();
	this.loadBillingDetail(id);
	this.dialogBillingPay = true;
}

function openDeleteConfirm(id) {
	this.noteId = id;
	this.dialogNote = true;
}

function openDeleteCustomer(index, _ref60) {
	var id = _ref60.id;

	this.customerIndex = index;
	this.customerIdSelected = id;
	this.dialogCustomer = true;
}

function openProductsModal() {
	this.loadWarehouses();
	this.loadSummaryProducts();
	this.dialog = true;
}

function openSaleModal() {
	this.loadSaleResources();
	this.localProductsRows = this.summaryRowsData.filter(function (srd) {
		return srd.isSelected;
	});
	this.newLocalProductsRows = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.localProductsRows));
	this.saleData.numDocument = this.bookingData.customer.data.numDocument;
	this.saleData.typeDocument = this.bookingData.customer.data.documentType;
	this.saleCustomer.name = this.bookingData.customer.data.name + ' ' + this.bookingData.customer.data.lastname;
	this.saleCustomer.document = this.bookingData.customer.data.numDocument;
	this.saleCustomer.paymentMethod = this.saleModel.paymentMethodCode;
	this.saleModal = true;
	this.validateExoneration(this.flagTaxes);
}

function pagesVisible() {
	if (this.totalModalPages >= 1 && this.totalModalPages < 5) {
		return this.totalModalPages;
	}
	return 5;
}

function pagesVisibleHistory() {
	if (this.totalHistoryPages >= 1 && this.totalHistoryPages < 5) {
		return this.totalHistoryPages;
	}
	return 5;
}

function personTypeName() {
	var namePerson = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_date_fns__["differenceInYears"])(new Date(), this.model.dateBirth) >= 18 ? 'Adulto' : 'Niño(a)';
	return this.model.dateBirth ? namePerson : '';
}

function positiveValue(product, prop) {
	var productIndex = this.productRows.findIndex(function (pro) {
		return pro.id === product.id;
	});
	if (productIndex > -1) {
		this.productRows[productIndex].isSelected = product[prop] && product[prop] > 0;
	}
}

function previewEmail(_ref62) {
	var id = _ref62.id;

	window.open('//notifications.japisale.com' + '/notifications/' + id + '/view');
}

function printDisabled() {
	return this.summaryRows.filter(function (sr) {
		return sr.isSelected;
	}).length === 0;
}

function saleDisabled() {
	return this.summaryRows.every(function (r) {
		return !r.isSelected;
	});
}

function saleNumDocumentLength() {
	if (this.newCustomerSale.documentType === 1) {
		return 8;
	} else if (this.newCustomerSale.documentType === 4) {
		return 11;
	}
	return 0;
}

function searchByColumn(search) {
	this.paramsBookingHistory.search = search;
	this.loadBookingHistory();
}

function searchProductsByColumn(search) {
	this.paramsSummary.code = search;
	this.loadSummaryProducts();
}

function selectCategory(id) {
	var _this18 = this;

	this.categoryValue = id;
	var products = [];
	if (id > 0) {
		this.categories.forEach(function (category) {
			if (category.id === id) {
				var newProduct = _this18.summaryRowsData.find(function (row) {
					if (row.product) {
						return id === row.product.categoryId;
					}
					return false;
				});
				if (newProduct) {
					products.push(newProduct);
				}
			}
		});
		if (products.length > 0) {
			this.summaryRows = products;
		} else {
			this.summaryRows = [];
		}
	} else {
		this.summaryRows = this.summaryRowsData;
	}
}

function selectFilter(id) {
	this.filterValue = id;
	this.paramsNotes.status = id;
	this.loadNotes();
}

function setPaymentMethod(value) {
	this.saleCustomer.paymentMethod = this.paymentMethods.find(function (pm) {
		return pm.code === value;
	}).name;
	if (value === 'CREDITO') {
		this.paysByTypePayment = [];
		this.typePaymentsSelected = [];
	}
}

function setTypeDocument(value) {
	this.saleCustomer.typeDocument = this.documentTypes.find(function (dt) {
		return dt.documentType.code === value;
	}).documentType.name;
	if (value !== 'FAC') {
		this.validateExoneration();
		this.showError();
	} else {
		this.showError();
	}
}

function setTypePayment(value) {
	this.saleCustomer.typePayment = this.typePayments.find(function (tp) {
		return tp.code === value;
	}).name;
}

function showChannelData() {
	var _this19 = this;

	this.bookingData.channel.data.inputInformations = this.bookingData.channel.data.inputInformations.map(function (field) {
		var newField = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, field);
		newField[field.value] = _this19.bookingData.channel.data.questions[field.value];
		if (!field.items) {
			newField.items = {
				itemText: '',
				itemValue: '',
				name: []
			};
		} else {
			newField.items.name = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()([], _this19[field.items.name]);
		}
		return newField;
	});
	this.showChannelForm = true;
}

function showCustomerData(info, type) {
	var newInfo = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, info);
	if (type) {
		newInfo.flagPerson = 'Adulto';
		newInfo.countryId = this.bookingData.customer.data.country.data.id;
	}
	this.personType = newInfo.flagPerson === 'Adulto' ? 1 : 2;
	this.model = newInfo;
	this.customerForm = true;
}

function showError() {
	if (this.cantBilling) {
		this.showNotification('Para generar una factura es necesario tener el RUC o pasaporte del cliente.', 'primary');
	} else {
		this.flagTaxes = true;
		this.validateExoneration(this.flagTaxes);
	}
}

function showGuestForm() {
	if (!this.model.dateBirth) {
		this.model.dateBirth = this.personType === 1 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_date_fns__["format"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_date_fns__["subYears"])(new Date(), 18), 'YYYY-MM-DD') : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_date_fns__["format"])(new Date(), 'YYYY-MM-DD');
	}
	this.customerForm = true;
}

function deletePeque(_ref77) {
	var product = _ref77.product;

	return product.name !== 'Alojamiento';
}

function showSummaryOption(_ref78) {
	var salDocumentsNumber = _ref78.salDocumentsNumber,
	    product = _ref78.product;

	return product.code !== 'RESERVA' && !salDocumentsNumber;
}

function showTypeBooking() {
	return !this.saleId && (!this.bookingData.bookingState || Number(this.bookingData.bookingState) === 1);
}

function symbol() {
	var _this20 = this;

	var curSelected = this.currencies.find(function (cur) {
		return cur.code === _this20.currencySelected;
	}) || { saleDocument: {} };
	return curSelected.symbol || curSelected.saleDocument.symbol;
}

function toggleIconBirthDate() {
	this.onChange = !this.modal.dateBirth;
}

function toggleIconEndDate() {
	this.onChangeEnd = !this.endDate;
}

function toggleIconProductDate() {
	this.onChangeProduct = !this.createdAt;
}

function toggleIconStartDate() {
	this.onChangeStart = !this.startDate;
}

function totalAmount() {
	var total = this.summaryRows.reduce(function (acum, row) {
		return acum + row.subTotal;
	}, 0);
	return total;
}

function totalLocalAmount() {
	var totalLocal = this.newLocalProductsRows.reduce(function (acum, row) {
		return acum + row.price * row.quantity;
	}, 0);
	return Number(totalLocal).toFixed(2);
}

function totalNotes() {
	return this.bookingData.countNotes || this.quantityNotes.countNotes;
}

function updateNote(row, status) {
	this.note = row.note;
	this.noteId = row.id;
	this.noteStatus = status;
	this.inputNote = true;
}

function validateAmount() {
	var paysAmount = this.paysByTypePayment.reduce(function (acum, currentPay) {
		return acum + Number(currentPay.amount);
	}, 0);
	return !this.creditPayment && Number(paysAmount) !== Number(this.totalLocalAmount);
}

function validateExoneration(flag) {
	this.invalid = flag && this.newLocalProductsRows.some(function (lsr) {
		return lsr.product.igvId === 13 && lsr.product.flagIgvRequired;
	}) && this.saleModel.typeDocumentCode === 'FAC';
	this.invalidBol = this.newLocalProductsRows.some(function (lsr) {
		return lsr.product.igvId === 15;
	}) && (this.saleModel.typeDocumentCode === 'BOL' || !flag && this.saleModel.typeDocumentCode === 'FAC');
	if (flag && this.saleModel.typeDocumentCode === 'FAC') {
		this.changeAmounts(this.currencySelected);
		this.addPays(this.paysByTypePayment);
	} else {
		this.changeAmounts(this.currencySelected, true);
		this.addPays(this.paysByTypePayment);
	}
	if (this.invalid) {
		this.alertMessage = 'No se puede exonerar de impuestos esta venta porque uno o más productos han sido configurados con impuesto obligatorio.';
		this.alertInfo = false;
		this.alertWarning = true;
		this.alert = true;
	} else if (this.invalidBol) {
		this.alertMessage = 'No se puede generar la venta con boleta porque uno o más productos agregados han sido configurados con impuesto exonerado. Puede continuar con el proceso si genera una factura exonerando impuestos.';
		this.alertInfo = false;
		this.alertWarning = true;
		this.alert = true;
	} else {
		this.alert = false;
	}
}

function goToBill(id) {
	var routeGoToSales = this.$router.resolve({ path: '/sales/' + id + '/detail' });
	window.open(routeGoToSales.href, '_blank');
}

function validations() {
	var _this21 = this;

	var model = {
		countryId: {
			minValue: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["minValue"])(1),
			required: __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["required"]
		},
		documentType: {
			required: __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["required"]
		},
		email: {
			email: __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["email"]
		},
		lastname: {
			required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["requiredIf"])(function () {
				return _this21.isNaturalPersonModel;
			})
		},
		name: {
			required: __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["required"]
		},
		numDocument: {
			required: __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["required"]
		}
	};
	var newCustomerSale = {
		address: {
			required: __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["required"]
		},
		documentType: {
			required: __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["required"]
		},
		email: {
			email: __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["email"]
		},
		lastname: {
			required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["requiredIf"])(function () {
				return _this21.isNaturalPerson;
			})
		},
		name: {
			required: __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["required"]
		},
		numDocument: {
			required: __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["required"]
		}
	};
	if (this.numDocumentLength > 0) {
		model.numDocument.maxLength = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["maxLength"])(this.numDocumentLength);
		model.numDocument.minLength = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["minLength"])(this.numDocumentLength);
	}
	if (this.saleNumDocumentLength > 0) {
		newCustomerSale.numDocument.maxLength = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["maxLength"])(this.saleNumDocumentLength);
		newCustomerSale.numDocument.minLength = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["minLength"])(this.saleNumDocumentLength);
	}
	return {
		model: model,
		newCustomerSale: newCustomerSale,
		saleCustomer: {
			name: {
				required: __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["required"]
			},
			document: {
				required: __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["required"]
			},
			paymentMethod: {
				required: __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["required"]
			},
			typeDocument: {
				required: __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["required"]
			}
		},
		paymentDays: {
			required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["requiredIf"])(function () {
				return _this21.creditPayment;
			}),
			minValue: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["minValue"])(this.creditPayment ? 15 : 0)
		}
	};
}

function getExtraBed(price) {
	return {
		id: 1,
		quantity: 1,
		flag: 1,
		price: price
	};
}

function getCrib(price) {
	return {
		id: 2,
		quantity: 1,
		flag: 1,
		price: price
	};
}

function selectBed(value) {
	this.bedSelected = value;
}

function selectCrib(value) {
	this.cribSelected = value;
}

function getTypeAndCodeRoom(book) {
	var bookData = book.room.data;
	if (bookData.length) {
		var rooms = bookData.map(function (r) {
			var codeRoom = r.codeRoom;
			var codeRoomtype = r.roomTypes.data.codeRoomtype;

			return codeRoomtype + '-' + codeRoom;
		});
		return rooms.join(', ');
	}
	return bookData.roomTypes.data.codeRoomtype + ' - ' + bookData.codeRoom;
}

function getTypeDocumentName(row) {
	var name = row.typeDocument.name;
	if (name === 'COTIZACION') {
		name = 'COMANDA';
	}
	return name;
}

function data() {
	return {
		tip: '',
		modalDetail: '',
		modalCode: '',
		modalSubTotal: '',
		modalAccommodation: [{
			id: 1,
			price: 0
		}, {
			id: 2,
			prince: 1
		}],
		visibleModal: false,
		active: null,
		aditionalBedPrice: '20.00',
		alert: false,
		alertMessage: '',
		arrayEarly: [{ id: 1, flag: 1, price: '', hour: '' }, { id: 2, flag: 1, price: '', hour: '' }, { id: 3, flag: 1, price: '', hour: '' }],
		arrayLate: [{ id: 1, flag: 1, price: '', hour: '' }, { id: 2, flag: 1, price: '', hour: '' }, { id: 3, flag: 1, price: '', hour: '' }],
		bankAccounts: [],
		bed: [1],
		bedSelected: false,
		billingColumns: [{ id: 1, name: 'Nº Doc' }, { id: 2, name: 'Tipo de Documento' }, { id: 3, name: 'Fecha' }, { id: 4, name: 'Estado' }, { id: 5, name: 'Acciones' }],
		billingDetail: {},
		billingDetailsColumns: [{ id: 1, name: 'Nº Doc' }, { id: 2, name: 'Fecha' }, { id: 3, name: 'Total' }, { id: 4, name: 'Pagado' }, { id: 5, name: 'A pagar' }],
		billingDetails: [],
		billingId: 0,
		billingNumber: '',
		billingRows: [],
		billingBankAccountId: 0,
		billingTypePaymentCode: '',
		bookingData: {
			channel: {
				data: {
					inputInformations: [{ items: {} }],
					questions: {}
				}
			},
			customerAditional: [],
			customer: {
				data: {
					country: {
						data: {}
					}
				}
			},
			room: {
				data: {
					roomTypes: {
						data: {}
					}
				}
			},
			summary: {
				booking: {},
				personalInformation: {},
				earlyCheckIn: {},
				lateCheckOut: {}
			}
		},
		bookingTotal: 0,
		categories: [{ id: 0, name: 'Todas' }],
		categoryValue: 0,
		channelModel: {},
		cities: [],
		civilStatus: [{ id: 1, name: 'Soltero(a)' }, { id: 2, name: 'Casado(a)' }, { id: 3, name: 'Viudo(a)' }, { id: 4, name: 'Divorciado(a)' }],
		columns: [{ id: 1, name: '#', code: 'number' }, { id: 2, name: 'Habitación', code: 'room' }, { id: 3, name: 'Huésped', code: 'customer' }, { id: 4, name: 'Llegada/Salida', code: 'ranges' }, { id: 5, name: 'Huéspedes', code: 'guests' }, { id: 6, name: 'Noches', code: 'nights' }, { id: 7, name: 'Total', code: 'total' }, { id: 8, name: 'Descargar' }],
		commentary: '',
		countries: [],
		createdAt: null,
		cribPrice: '20.00',
		cribSelected: false,
		currencies: [],
		currencySelected: '',
		customerForm: false,
		customerId: null,
		customerIdSelected: null,
		customerIndex: null,
		dialog: false,
		dialogBillingDetail: false,
		dialogBillingPay: false,
		dialogCancelBilling: false,
		dialogCustomer: false,
		dialogNote: false,
		documentNumber: '',
		documentTypes: [],
		earlyCheckin: null,
		earlyCheckinDisabled: false,
		emailColumns: [{ id: 1, name: 'Fecha' }, { id: 2, name: 'Remitente' }, { id: 3, name: 'Destinatario' }, { id: 4, name: 'Asunto' }, { id: 5, name: 'Ver email' }],
		emailPages: 5,
		emailParams: {
			page: 1,
			limit: 10
		},
		emailRows: [],
		endDate: null,
		exchangeRate: '',
		flagTaxes: false,
		flagShowCustomer: true,
		filters: [{ id: 1, label: 'Notas activas' }, { id: 2, label: 'Notas archivadas' }],
		filterValue: 1,
		genders: [{ id: 1, name: 'Hombre' }, { id: 2, name: 'Mujer' }],
		inputNote: false,
		invalid: false,
		invalidBol: false,
		isToday: false,
		items: [{ id: 1, title: 'Detalle de Huésped' }, { id: 2, title: 'Resumen de cuenta' }, { id: 3, title: 'Notas' }, { id: 4, title: 'Historial de reservas' }, { id: 5, title: 'Email enviados' }, { id: 6, title: 'Facturas' }],
		lateCheckOut: null,
		lateCheckOutDisabled: false,
		loading: false,
		localCategories: [{ id: 0, name: 'Todas' }],
		localProductsColumns: [{ id: 1, name: 'Fecha' }, { id: 2, name: 'Cod. Producto' }, { id: 3, name: 'Categoría' }, { id: 4, name: 'Nombre Producto' }, { id: 5, name: 'Cant.' }, { id: 6, name: 'Precio Producto' }, { id: 7, name: 'Descuento %' }],
		localProductsRows: [],
		menu: false,
		menuBirthDate: false,
		menuEnd: false,
		menuProduct: false,
		model: {
			address: '',
			cardVip: '',
			cityId: 0,
			civilStatus: 1,
			countryId: 0,
			dateBirth: '',
			documentType: 1,
			email: '',
			gender: 1,
			lastname: '',
			name: '',
			numDocument: '',
			phone: ''
		},
		newCustomerSale: {
			address: '',
			documentType: 1,
			email: '',
			lastname: '',
			name: '',
			numDocument: ''
		},
		newLocalProductsRows: [],
		note: '',
		noteStatus: null,
		noteId: 0,
		notesColumns: [{ id: 1, name: 'Nota', code: 'note', isSortable: { down: true, up: false } }, { id: 2, name: '', code: 'action' }],
		notesRows: [],
		numberDays: [15, 30, 60, 90],
		onChange: false,
		onChangeProduct: false,
		onChangeEnd: false,
		onChangeStart: false,
		params: {
			room: null
		},
		paramsBookingHistory: {
			page: 1,
			perPage: 10,
			idCustomer: null
		},
		paramsDocuments: {},
		paramsNotes: {
			bookingCode: this.$route.query.bookingCode,
			status: 1,
			page: 1,
			perPage: 10
		},
		paramsSummary: {
			page: 1,
			limit: 10,
			withTransfer: 1
		},
		paymentDays: 0,
		paymentMethods: [],
		paysByTypePayment: [],
		personType: null,
		productCategory: 0,
		productColumns: [{ id: 1, name: 'Cod. Prod.', code: 'code' }, { id: 2, name: 'Almacén', code: 'warehouse' }, { id: 3, name: 'Categoría', code: 'category' }, { id: 4, name: 'Nombre Prod.', code: 'name' }, { id: 5, name: 'Stock', code: 'stock' }, { id: 6, name: 'Cant.', code: 'quantity' }, { id: 7, name: 'Precio', code: 'price' }, { id: 8, name: 'Descuento %', code: 'discount' }],
		productRows: [],
		productSearch: '',
		productWarehouse: 0,
		quantityNotes: {
			filedNotes: 0,
			activeNotes: 0,
			countNotes: 0
		},
		reservationsProducts: [],
		rooms: [],
		roomsType: [],
		rows: [],
		saleCustomer: {
			name: '',
			document: '',
			paymentMethod: '',
			typeDocument: 'BOLETA',
			typePayment: ''
		},
		saleCustomerId: 0,
		saleData: {
			numDocument: '',
			typeDocument: 1
		},
		saleId: 0,
		saleModal: false,
		saleModel: {
			paymentMethodCode: '',
			typeDocumentCode: 'BOL',
			typePaymentCode: ''
		},
		saleNumDocument: '',
		salesTabs: null,
		search: '',
		servicesBedCode: 'EXTRABEG',
		servicesCribCode: 'CRIB',
		showChannelForm: false,
		showCheckLoyalty: false,
		sortField: null,
		sortDirection: null,
		specialRequirement: '',
		startDate: null,
		createdHour: null,
		summaryColumns: [{ id: 0, name: 'Fecha', code: 'createdAt' }, { id: 1, name: 'Hora', code: 'createdHour' }, { id: 2, name: 'Cod. Producto', code: 'code' }, { id: 3, name: 'Cant.', code: 'quantity' }, { id: 4, name: 'Nombre Producto', code: 'name' }, { id: 5, name: 'Precio Producto', code: 'price' }, { id: 6, name: 'Nº Factura', code: 'billingNumber' }, { id: 7, name: '' }],
		summaryConfirm: false,
		summaryData: {},
		summaryId: 0,
		summaryName: '',
		summaryProductCode: '',
		summaryRows: [],
		summaryRowsData: null,
		totalHistoryPages: 5,
		totalModalPages: 5,
		totalNotesPages: 5,
		typeBooking: 0,
		typeCard: 1,
		typeCards: [{ id: 1, name: 'VIP' }],
		typeDocuments: [{ id: 1, name: 'DNI' }, { id: 2, name: 'Pasaporte' }, { id: 3, name: 'C. Extranjería' }, { id: 4, name: 'RUC' }],
		typePayments: [],
		typePaymentsSelected: [],
		warehouses: [{ id: 0, name: 'Todos' }],
		disabledUpdateCheckOut: false
	};
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'checkin-form-tabs',
	components: {
		modalBill: __WEBPACK_IMPORTED_MODULE_8__clerkinn_checkin_modal_bill___default.a,
		ButtonCreate: __WEBPACK_IMPORTED_MODULE_15__components_shared_ButtonCreate___default.a,
		ButtonField: __WEBPACK_IMPORTED_MODULE_16__clerkinn_shared_ButtonField___default.a,
		TableRun: __WEBPACK_IMPORTED_MODULE_11_table_run___default.a
	},
	computed: {
		actionNoteButton: actionNoteButton,
		addGuestDisabled: addGuestDisabled,
		additionalCustomersIsEmpty: additionalCustomersIsEmpty,
		addProductsDisabled: addProductsDisabled,
		arrowIconBirth: arrowIconBirth,
		arrowIconEnd: arrowIconEnd,
		arrowIconProduct: arrowIconProduct,
		arrowIconStart: arrowIconStart,
		bankAccountsDisabled: bankAccountsDisabled,
		billingActive: billingActive,
		cantAddGuest: cantAddGuest,
		cantBilling: cantBilling,
		channelHasProperties: channelHasProperties,
		chargeBtnText: chargeBtnText,
		checkinActive: checkinActive,
		checkoutDisabled: checkoutDisabled,
		creditPayment: creditPayment,
		customerBtnText: customerBtnText,
		customerNumber: customerNumber,
		disabledSave: disabledSave,
		disableGenerateSale: disableGenerateSale,
		documentTypeName: documentTypeName,
		earlyCheckInIsSelected: earlyCheckInIsSelected,
		emailVisiblePages: emailVisiblePages,
		firstTabActive: firstTabActive,
		isAnAdult: isAnAdult,
		isNaturalPerson: isNaturalPerson,
		isNaturalPersonModel: isNaturalPersonModel,
		isNoShow: isNoShow,
		lateCheckOutIsSelected: lateCheckOutIsSelected,
		nameLabel: nameLabel,
		nameModelLabel: nameModelLabel,
		nameModelMessage: nameModelMessage,
		nameValidateMessage: nameValidateMessage,
		noCustomerId: noCustomerId,
		notesPagesVisible: notesPagesVisible,
		numberNights: numberNights,
		numDocumentLength: numDocumentLength,
		saleNumDocumentLength: saleNumDocumentLength,
		showTypeBooking: showTypeBooking,
		pagesVisible: pagesVisible,
		pagesVisibleHistory: pagesVisibleHistory,
		personTypeName: personTypeName,
		printDisabled: printDisabled,
		saleDisabled: saleDisabled,
		symbol: symbol,
		totalAmount: totalAmount,
		totalLocalAmount: totalLocalAmount,
		totalNotes: totalNotes,
		validateAmount: validateAmount
	},
	created: created,
	data: data,
	filters: {
		currency: __WEBPACK_IMPORTED_MODULE_14__shared_filters__["a" /* currency */],
		parseDate: __WEBPACK_IMPORTED_MODULE_14__shared_filters__["b" /* parseDate */],
		round: __WEBPACK_IMPORTED_MODULE_14__shared_filters__["c" /* round */]
	},
	methods: {
		postPreview: postPreview,
		dowloadFunction: dowloadFunction,
		showAccommodationOption: showAccommodationOption,
		saveModal: saveModal,
		cancelModal: cancelModal,
		openModal: openModal,
		closeModal: closeModal,
		deletePeque: deletePeque,
		addCustomer: addCustomer,
		addGuest: addGuest,
		addNotes: addNotes,
		addPays: addPays,
		backToSales: backToSales,
		backToTab: backToTab,
		cancelAddGuest: cancelAddGuest,
		cancelBilling: cancelBilling,
		cancelDeleteCustomer: cancelDeleteCustomer,
		cancelDeleteNote: cancelDeleteNote,
		cancelUpdateChannel: cancelUpdateChannel,
		changeAmounts: changeAmounts,
		changeEndIcon: changeEndIcon,
		changeIcon: changeIcon,
		changeIconProduct: changeIconProduct,
		changeIconStart: changeIconStart,
		changeMainCustomer: changeMainCustomer,
		checkout: checkout,
		closeBillingDialog: closeBillingDialog,
		closeSummaryConfirm: closeSummaryConfirm,
		columnSortableEvent: columnSortableEvent,
		confirmCancelBilling: confirmCancelBilling,
		datesDisabled: datesDisabled,
		deleteCustomer: deleteCustomer,
		deleteNote: deleteNote,
		deleteSummaryDetail: deleteSummaryDetail,
		deleteSummaryDetailConfirm: deleteSummaryDetailConfirm,
		downloadSale: downloadSale,
		downloadSaleTicket: downloadSaleTicket,
		downLoadUniqueTicket: downLoadUniqueTicket,
		filterBookings: filterBookings,
		filterProducts: filterProducts,
		filterSummary: filterSummary,
		generateSale: generateSale,
		getExtraBed: getExtraBed,
		getCrib: getCrib,
		getSaleId: getSaleId,
		getServicesPrices: getServicesPrices,
		getTypeAndCodeRoom: getTypeAndCodeRoom,
		getTypeDocumentName: getTypeDocumentName,
		goToCalendar: goToCalendar,
		goToSummary: goToSummary,
		igvExonerated: igvExonerated,
		loadBankAccounts: loadBankAccounts,
		loadBillings: loadBillings,
		loadBillingDetail: loadBillingDetail,
		loadBookingData: loadBookingData,
		loadBookingHistory: loadBookingHistory,
		loadCities: loadCities,
		loadCurrencies: loadCurrencies,
		loadEmails: loadEmails,
		loadExchangeRate: loadExchangeRate,
		loadNotes: loadNotes,
		loadResources: loadResources,
		loadRooms: loadRooms,
		loadSaleResources: loadSaleResources,
		loadSummaryCategories: loadSummaryCategories,
		loadSummaryData: loadSummaryData,
		loadSummaryProducts: loadSummaryProducts,
		loadWarehouses: loadWarehouses,
		notesColumnSortableEvent: notesColumnSortableEvent,
		openBillingDetail: openBillingDetail,
		openBillingPay: openBillingPay,
		openDeleteConfirm: openDeleteConfirm,
		openDeleteCustomer: openDeleteCustomer,
		openProductsModal: openProductsModal,
		openSaleModal: openSaleModal,
		payBilling: payBilling,
		positiveValue: positiveValue,
		previewEmail: previewEmail,
		saveCustomer: saveCustomer,
		saveData: saveData,
		saveNote: saveNote,
		searchByColumn: searchByColumn,
		searchCustomer: searchCustomer,
		searchCustomerByMixin: searchCustomerByMixin,
		searchCustomerNew: searchCustomerNew,
		searchCustomerSale: searchCustomerSale,
		searchProductsByColumn: searchProductsByColumn,
		selectBed: selectBed,
		selectCrib: selectCrib,
		selectCategory: selectCategory,
		selectFilter: selectFilter,
		setPaymentMethod: setPaymentMethod,
		setTypeDocument: setTypeDocument,
		setTypePayment: setTypePayment,
		showChannelData: showChannelData,
		showCustomerData: showCustomerData,
		showError: showError,
		showGuestForm: showGuestForm,
		showSummaryOption: showSummaryOption,
		toggleIconBirthDate: toggleIconBirthDate,
		toggleIconEndDate: toggleIconEndDate,
		toggleIconProductDate: toggleIconProductDate,
		toggleIconStartDate: toggleIconStartDate,
		updateChannel: updateChannel,
		updateNote: updateNote,
		updateProducts: updateProducts,
		validateExoneration: validateExoneration,
		updateCheckOut: updateCheckOut,
		goToBill: goToBill
	},
	mixins: __WEBPACK_IMPORTED_MODULE_13__shared_mixins__["a" /* default */],
	props: ['hotelId', 'roomTypeId'],
	validations: validations,
	watch: {
		active: active
	}
});

/***/ }),

/***/ 1270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__clerkinn_shared_select_button__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__clerkinn_shared_select_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__clerkinn_shared_select_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clerkinn_shared_input_text__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clerkinn_shared_input_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__clerkinn_shared_input_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





function printSave() {
	return Number(this.dateBill[0].price) + Number(this.dateBill[1].price) === this.amountTotal;
}

function validations() {
	return {
		dateBill: {
			price: {
				required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
			}
		}
	};
}

function data() {
	return {
		dateBill: [{
			id: 0,
			price: 0
		}, {
			id: 1,
			price: 0
		}]
	};
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'modal-bill',
	data: data,
	validations: validations,
	computed: {
		printSave: printSave
	},
	props: {
		amountTotal: {
			default: false,
			type: [Number, String]
		},
		isVisible: {
			default: false,
			type: Boolean
		},
		idDetail: {
			default: false,
			type: [Number, String]
		}
	},
	components: {
		selectButton: __WEBPACK_IMPORTED_MODULE_0__clerkinn_shared_select_button___default.a,
		inputText: __WEBPACK_IMPORTED_MODULE_1__clerkinn_shared_input_text___default.a
	}
});

/***/ }),

/***/ 1406:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".btn-blue[data-v-6007a611]{background-color:#29abe2!important;color:#fff}.header-booking-data[data-v-6007a611]{height:31px;position:absolute;right:20px;text-align:right;top:55px;width:100%}.header-booking-data p[data-v-6007a611]{color:#2e394b;font-family:San Francisco Display;font-size:10px;margin:0}.header-booking-data span[data-v-6007a611]{color:#29abe2;font-family:San Francisco Display Medium;font-size:15px}.header-booking-data .border-select[data-v-6007a611]{border-right:2px solid hsla(0,0%,59%,.3);padding-right:10px!important}.header-booking-data .border-select[data-v-6007a611]:first-of-type{border-left:2px solid hsla(0,0%,59%,.3)}.header-booking-data .booking-number[data-v-6007a611]{color:#818181;font-family:San Francisco Display;font-size:16px}.header-booking-data .booking-number span[data-v-6007a611]{color:#2e394b;font-family:San Francisco Display Medium}.label-title[data-v-6007a611]{color:#2f302f;font-family:San Francisco Display Medium;font-size:14px}.bar-data[data-v-6007a611]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#fff;-webkit-box-shadow:0 2px 5px 0 rgba(0,0,0,.1);box-shadow:0 2px 5px 0 rgba(0,0,0,.1);display:-webkit-box;display:-ms-flexbox;display:flex;height:48px;-ms-flex-pack:distribute;justify-content:space-around}.bar-data-item[data-v-6007a611]{border-right:1px solid #e2e2e2;-webkit-box-flex:1;-ms-flex:1 auto;flex:1 auto}.bar-data-item.no-border[data-v-6007a611],.bar-data-item[data-v-6007a611]:last-of-type{border-right:0}.bar-data-item p[data-v-6007a611]{color:#545e72;font-family:San Francisco Display Medium;font-size:14px;margin-bottom:0}.bar-data-item p span[data-v-6007a611]{color:#818181;font-family:San Francisco Display;font-size:14px}.bar-data .bar-icon[data-v-6007a611]{font-size:20px;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;width:20px}.summary-footer-bar[data-v-6007a611]{background-color:#545e72;color:#fff}.summary-footer-bar p[data-v-6007a611]{font-family:San Francisco Display Bold;font-size:18px;margin:0}.btn-action.filter[data-v-6007a611]{background-color:#29abe2!important;color:#fff}.filter-list[data-v-6007a611]{color:#85939e;display:-webkit-box;display:-ms-flexbox;display:flex}.filter-list button.btn[data-v-6007a611]{background-color:#fff!important;-webkit-box-shadow:0 2px 4px 0 rgba(0,0,0,.18);box-shadow:0 2px 4px 0 rgba(0,0,0,.18);color:#85939e;height:40px;margin-right:14px}.filter-list button.btn.active[data-v-6007a611]{background-color:#29abe2!important;color:#fff}.btn-cancel[data-v-6007a611]{background-color:#e2525c!important}.btn-cancel.grey[data-v-6007a611]{background-color:#9b9b9b!important}.total-amount[data-v-6007a611]{color:#545e72;font-family:San Francisco Display Bold;font-size:24px;text-transform:uppercase}.col-without-label[data-v-6007a611]{margin-top:17.5px!important}.container-flex[data-v-6007a611]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", "", {"version":3,"sources":["/opt/build/repo/src/clerkinn/checkin/NewForm.vue"],"names":[],"mappings":"AACA,2BACE,mCAAqC,AACrC,UAAa,CACd,AACD,sCACE,YAAa,AACb,kBAAmB,AACnB,WAAY,AACZ,iBAAkB,AAClB,SAAU,AACV,UAAY,CACb,AACD,wCACI,cAAe,AACf,kCAAqC,AACrC,eAAgB,AAChB,QAAY,CACf,AACD,2CACI,cAAe,AACf,yCAA4C,AAC5C,cAAgB,CACnB,AACD,qDACI,yCAAiD,AACjD,4BAA+B,CAClC,AACD,mEACM,uCAAgD,CACrD,AACD,sDACI,cAAe,AACf,kCAAqC,AACrC,cAAgB,CACnB,AACD,2DACM,cAAe,AACf,wCAA4C,CACjD,AACD,8BACE,cAAe,AACf,yCAA4C,AAC5C,cAAgB,CACjB,AACD,2BACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,sBAAwB,AACxB,8CAAmD,AAC3C,sCAA2C,AACnD,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,YAAa,AACb,yBAA0B,AACtB,4BAA8B,CACnC,AACD,gCACI,+BAAgC,AAChC,mBAAoB,AAChB,gBAAiB,AACb,WAAa,CACxB,AAID,uFACM,cAAkB,CACvB,AACD,kCACM,cAAe,AACf,yCAA4C,AAC5C,eAAgB,AAChB,eAAmB,CACxB,AACD,uCACQ,cAAe,AACf,kCAAqC,AACrC,cAAgB,CACvB,AACD,qCACI,eAAgB,AAChB,uBAAwB,AACpB,oBAAqB,AACjB,2BAA4B,AACpC,UAAY,CACf,AACD,qCACE,yBAA0B,AAC1B,UAAa,CACd,AACD,uCACI,uCAA0C,AAC1C,eAAgB,AAChB,QAAY,CACf,AACD,oCACE,mCAAqC,AACrC,UAAa,CACd,AACD,8BACE,cAAe,AACf,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACf,AACD,yCACI,gCAAmC,AACnC,+CAAoD,AAC5C,uCAA4C,AACpD,cAAe,AACf,YAAa,AACb,iBAAmB,CACtB,AACD,gDACM,mCAAqC,AACrC,UAAa,CAClB,AACD,6BACE,kCAAqC,CACtC,AACD,kCACI,kCAAqC,CACxC,AACD,+BACE,cAAe,AACf,uCAA0C,AAC1C,eAAgB,AAChB,wBAA0B,CAC3B,AACD,oCACE,2BAA8B,CAC/B,AACD,iCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B","file":"NewForm.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.btn-blue[data-v-6007a611] {\n  background-color: #29abe2 !important;\n  color: white;\n}\n.header-booking-data[data-v-6007a611] {\n  height: 31px;\n  position: absolute;\n  right: 20px;\n  text-align: right;\n  top: 55px;\n  width: 100%;\n}\n.header-booking-data p[data-v-6007a611] {\n    color: #2e394b;\n    font-family: \"San Francisco Display\";\n    font-size: 10px;\n    margin: 0px;\n}\n.header-booking-data span[data-v-6007a611] {\n    color: #29abe2;\n    font-family: \"San Francisco Display Medium\";\n    font-size: 15px;\n}\n.header-booking-data .border-select[data-v-6007a611] {\n    border-right: 2px solid rgba(151, 151, 151, 0.3);\n    padding-right: 10px !important;\n}\n.header-booking-data .border-select[data-v-6007a611]:first-of-type {\n      border-left: 2px solid rgba(151, 151, 151, 0.3);\n}\n.header-booking-data .booking-number[data-v-6007a611] {\n    color: #818181;\n    font-family: \"San Francisco Display\";\n    font-size: 16px;\n}\n.header-booking-data .booking-number span[data-v-6007a611] {\n      color: #2e394b;\n      font-family: \"San Francisco Display Medium\";\n}\n.label-title[data-v-6007a611] {\n  color: #2f302f;\n  font-family: \"San Francisco Display Medium\";\n  font-size: 14px;\n}\n.bar-data[data-v-6007a611] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background-color: white;\n  -webkit-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);\n          box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 48px;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n.bar-data-item[data-v-6007a611] {\n    border-right: 1px solid #e2e2e2;\n    -webkit-box-flex: 1;\n        -ms-flex: 1 auto;\n            flex: 1 auto;\n}\n.bar-data-item[data-v-6007a611]:last-of-type {\n      border-right: 0px;\n}\n.bar-data-item.no-border[data-v-6007a611] {\n      border-right: 0px;\n}\n.bar-data-item p[data-v-6007a611] {\n      color: #545e72;\n      font-family: \"San Francisco Display Medium\";\n      font-size: 14px;\n      margin-bottom: 0px;\n}\n.bar-data-item p span[data-v-6007a611] {\n        color: #818181;\n        font-family: \"San Francisco Display\";\n        font-size: 14px;\n}\n.bar-data .bar-icon[data-v-6007a611] {\n    font-size: 20px;\n    -webkit-box-pack: start;\n        -ms-flex-pack: start;\n            justify-content: flex-start;\n    width: 20px;\n}\n.summary-footer-bar[data-v-6007a611] {\n  background-color: #545e72;\n  color: white;\n}\n.summary-footer-bar p[data-v-6007a611] {\n    font-family: \"San Francisco Display Bold\";\n    font-size: 18px;\n    margin: 0px;\n}\n.btn-action.filter[data-v-6007a611] {\n  background-color: #29abe2 !important;\n  color: white;\n}\n.filter-list[data-v-6007a611] {\n  color: #85939e;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.filter-list button.btn[data-v-6007a611] {\n    background-color: white !important;\n    -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18);\n            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18);\n    color: #85939e;\n    height: 40px;\n    margin-right: 14px;\n}\n.filter-list button.btn.active[data-v-6007a611] {\n      background-color: #29abe2 !important;\n      color: white;\n}\n.btn-cancel[data-v-6007a611] {\n  background-color: #e2525c !important;\n}\n.btn-cancel.grey[data-v-6007a611] {\n    background-color: #9b9b9b !important;\n}\n.total-amount[data-v-6007a611] {\n  color: #545e72;\n  font-family: \"San Francisco Display Bold\";\n  font-size: 24px;\n  text-transform: uppercase;\n}\n.col-without-label[data-v-6007a611] {\n  margin-top: 17.5px !important;\n}\n.container-flex[data-v-6007a611] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1430:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".container-rode[data-v-8724e1ec]{padding:10px}.text-rode[data-v-8724e1ec]{color:#afafaf;font-size:13px;margin-bottom:3px;text-align:center}.container-accommodation[data-v-8724e1ec]{background:#303645;border:#000;color:#fff;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:211px}.container-accommodation[data-v-8724e1ec],.container-modal-bill[data-v-8724e1ec]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex}.container-modal-bill[data-v-8724e1ec]{background:rgba(0,0,0,.42);bottom:0;content:\"\";height:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;left:0;position:fixed;right:0;top:0;width:100%;z-index:10}.section-bill[data-v-8724e1ec]{background:#fff;width:475px}.text-accommodation[data-v-8724e1ec]{font-size:14px;margin-bottom:3px;padding:5px;text-align:center}.border-bottom[data-v-8724e1ec]{border-bottom:1px solid #000;width:100%}.input-accomodation[data-v-8724e1ec]{background-color:#fff;-webkit-box-shadow:inset 0 2px 5px 0 rgba(0,0,0,.2);box-shadow:inset 0 2px 5px 0 rgba(0,0,0,.2);color:#818181;height:25px;margin-bottom:10px;outline:none;text-align:center;width:80px}.con-accommodation[data-v-8724e1ec]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;border:1px solid #000;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;left:50%;margin-bottom:22px;position:relative;-webkit-transform:translateX(-50%);transform:translateX(-50%);width:211px}", "", {"version":3,"sources":["/opt/build/repo/src/clerkinn/checkin/modal-bill.vue"],"names":[],"mappings":"AACA,iCACE,YAAc,CACf,AACD,4BACE,cAAe,AACf,eAAgB,AAChB,kBAAmB,AACnB,iBAAmB,CACpB,AACD,0CAIE,mBAAoB,AACpB,YAAgB,AAChB,WAAe,AAIf,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,WAAa,CACd,AACD,iFAfE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAI5B,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CA2Bf,AApBD,uCAIE,2BAAgC,AAChC,SAAU,AACV,WAAY,AAIZ,YAAa,AACb,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,OAAQ,AACR,eAAgB,AAChB,QAAS,AACT,MAAO,AACP,WAAY,AACZ,UAAY,CACb,AACD,+BACE,gBAAoB,AACpB,WAAa,CACd,AACD,qCACE,eAAgB,AAChB,kBAAmB,AACnB,YAAa,AACb,iBAAmB,CACpB,AACD,gCACE,6BAAiC,AACjC,UAAY,CACb,AACD,qCACE,sBAA0B,AAC1B,oDAAyD,AACjD,4CAAiD,AACzD,cAAe,AACf,YAAa,AACb,mBAAoB,AACpB,aAAc,AACd,kBAAmB,AACnB,UAAY,CACb,AACD,oCACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,sBAA0B,AAC1B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,SAAU,AACV,mBAAoB,AACpB,kBAAmB,AACnB,mCAAoC,AAC5B,2BAA4B,AACpC,WAAa,CACd","file":"modal-bill.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.container-rode[data-v-8724e1ec] {\n  padding: 10px;\n}\n.text-rode[data-v-8724e1ec] {\n  color: #afafaf;\n  font-size: 13px;\n  margin-bottom: 3px;\n  text-align: center;\n}\n.container-accommodation[data-v-8724e1ec] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background: #303645;\n  border: #000000;\n  color: #ffffff;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  width: 211px;\n}\n.container-modal-bill[data-v-8724e1ec] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background: rgba(0, 0, 0, 0.42);\n  bottom: 0;\n  content: '';\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 100%;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n  width: 100%;\n  z-index: 10;\n}\n.section-bill[data-v-8724e1ec] {\n  background: #ffffff;\n  width: 475px;\n}\n.text-accommodation[data-v-8724e1ec] {\n  font-size: 14px;\n  margin-bottom: 3px;\n  padding: 5px;\n  text-align: center;\n}\n.border-bottom[data-v-8724e1ec] {\n  border-bottom: 1px solid #000000;\n  width: 100%;\n}\n.input-accomodation[data-v-8724e1ec] {\n  background-color: #ffffff;\n  -webkit-box-shadow: inset 0 2px 5px 0 rgba(0, 0, 0, 0.2);\n          box-shadow: inset 0 2px 5px 0 rgba(0, 0, 0, 0.2);\n  color: #818181;\n  height: 25px;\n  margin-bottom: 10px;\n  outline: none;\n  text-align: center;\n  width: 80px;\n}\n.con-accommodation[data-v-8724e1ec] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  border: 1px solid #000000;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  left: 50%;\n  margin-bottom: 22px;\n  position: relative;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  width: 211px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1491:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1406);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("81b47ff8", content, true);

/***/ }),

/***/ 1515:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1430);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("c1ead0e0", content, true);

/***/ }),

/***/ 1547:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1515)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1270),
  /* template */
  __webpack_require__(1680),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8724e1ec",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1647:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    staticClass: "header-booking-data",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md7": "",
      "xs10": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "border-select",
    attrs: {
      "py-0": ""
    }
  }, [_c('p', [_vm._v("Tipo:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getTypeAndCodeRoom(_vm.bookingData)))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "border-select",
    attrs: {
      "py-0": ""
    }
  }, [_c('p', [_vm._v("Noches:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.bookingData.numberNights))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "border-select",
    attrs: {
      "py-0": ""
    }
  }, [_c('p', [_vm._v("Niños:")]), _vm._v(" "), _c('span', [_c('img', {
    staticClass: "mr-2",
    attrs: {
      "src": (_vm.$imageS3 + "/clerkinn/child-icon.svg"),
      "alt": ""
    }
  }), _vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.bookingData.summary.booking.childrens) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "border-select",
    attrs: {
      "py-0": ""
    }
  }, [_c('p', [_vm._v("Adultos:")]), _vm._v(" "), _c('span', [_c('img', {
    staticClass: "mr-2",
    attrs: {
      "src": (_vm.$imageS3 + "/clerkinn/adult-icon.svg"),
      "alt": ""
    }
  }), _vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.bookingData.summary.booking.adults) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "border-select",
    attrs: {
      "py-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('p', [_vm._v("CHECKIN")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("parseDate")(_vm.bookingData.bookingStart, 'DD/MM/YYYY')))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('p', [_vm._v("CHECKOUT")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("parseDate")(_vm.bookingData.bookingEnd, 'DD/MM/YYYY')))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "pa-0": ""
    }
  }, [_c('span', {
    staticClass: "booking-number"
  }, [_vm._v("Nº RESERVA\n\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.bookingData.numReservation))])])])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-tabs', {
    staticClass: "checkin-tabs",
    attrs: {
      "grow": ""
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('v-tabs-bar', {
    staticClass: "transparent"
  }, [_c('v-tabs-slider', {
    staticClass: "default-skyblue"
  }), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('v-tabs-item', {
      key: item.id,
      attrs: {
        "href": '#tab-' + item.id,
        "disabled": (!_vm.saleId || _vm.saleId < 1) ||
          _vm.isNoShow
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(item.title) + " "), (item.id === 3) ? _c('span', [_vm._v("(" + _vm._s(_vm.totalNotes) + ")")]) : _vm._e()])
  })], 2), _vm._v(" "), _c('v-tabs-items', _vm._l((_vm.items.length), function(i) {
    return _c('v-tabs-content', {
      key: i,
      attrs: {
        "id": 'tab-' + i
      }
    }, [(i === 1) ? _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "my-4": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "bar-data"
    }, [_c('div', {
      staticClass: "bar-data-item"
    }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tHuésped:\n\t\t\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v("Nº 1")])])]), _vm._v(" "), _c('div', {
      staticClass: "bar-data-item"
    }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tNº Tarjeta:\n\t\t\t\t\t\t\t\t\t\t\t"), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.bookingData.customer.data.cardVip),
        expression: "bookingData.customer.data.cardVip"
      }]
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tVip\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', [_vm._v("-")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.bookingData.customer.data.cardVip),
        expression: "bookingData.customer.data.cardVip"
      }]
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.bookingData.customer.data.cardVip) + "\n\t\t\t\t\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
      staticClass: "bar-data-item"
    }, [_c('p', [_c('app-type-document', {
      attrs: {
        "document-id": _vm.bookingData.customer.data.documentType
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.bookingData.customer.data.numDocument))])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "bar-data-item"
    }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tNombre:\n\t\t\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.bookingData.customer.data.name))])])]), _vm._v(" "), _c('div', {
      staticClass: "bar-data-item"
    }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tApellido:\n\t\t\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.bookingData.customer.data.lastname))])])]), _vm._v(" "), _c('div', {
      staticClass: "bar-data-item"
    }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tFec. Nac.:\n\t\t\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm._f("parseDate")(_vm.bookingData.customer.data.dateBirth, 'DD/MM/YYYY')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t- Adulto")])])]), _vm._v(" "), _c('div', {
      staticClass: "bar-data-item no-border"
    }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tPaís:\n\t\t\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.bookingData.customer.data.country.data.name))])])]), _vm._v(" "), _c('div', {
      staticClass: "bar-data-item no-border"
    }, [_c('v-icon', {
      staticClass: "bar-icon warning--text"
    }, [_vm._v("start")]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          _vm.showCustomerData(_vm.bookingData.customer.data, true)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": (_vm.$imageS3 + "/clerkinn/edit-icon.svg"),
        "alt": ""
      }
    })])], 1)])]), _vm._v(" "), (!_vm.additionalCustomersIsEmpty) ? _c('v-flex', {
      attrs: {
        "xs12": "",
        "pa-0": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, _vm._l((_vm.bookingData.customerAditional), function(customer, customerIndex) {
      return _c('v-flex', {
        key: customer.id,
        attrs: {
          "xs12": "",
          "mt-3": ""
        }
      }, [_c('div', {
        staticClass: "bar-data"
      }, [_c('div', {
        staticClass: "bar-data-item"
      }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tHuésped:\n\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v("Nº " + _vm._s(customerIndex + 2))])])]), _vm._v(" "), _c('div', {
        staticClass: "bar-data-item"
      }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tNº Tarjeta:\n\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (customer.cardVip),
          expression: "customer.cardVip"
        }]
      }, [_vm._v("Vip")]), _vm._v(" "), _c('span', [_vm._v("-")]), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (customer.cardVip),
          expression: "customer.cardVip"
        }]
      }, [_vm._v(_vm._s(customer.cardVip))])])]), _vm._v(" "), _c('div', {
        staticClass: "bar-data-item"
      }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tDNI:\n\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(customer.numDocument))])])]), _vm._v(" "), _c('div', {
        staticClass: "bar-data-item"
      }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tNombre:\n\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(customer.name))])])]), _vm._v(" "), _c('div', {
        staticClass: "bar-data-item"
      }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tApellido:\n\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(customer.lastname))])])]), _vm._v(" "), _c('div', {
        staticClass: "bar-data-item"
      }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tFec. Nac.:\n\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm._f("parseDate")(customer.dateBirth, 'DD/MM/YYYY')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t- " + _vm._s(customer.flagPerson))])])]), _vm._v(" "), _c('div', {
        staticClass: "bar-data-item no-border"
      }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tPaís:\n\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(customer.country))])])]), _vm._v(" "), _c('div', {
        staticClass: "bar-data-item no-border"
      }, [_c('v-btn', {
        staticClass: "grey--text",
        attrs: {
          "icon": ""
        },
        on: {
          "click": function($event) {
            _vm.changeMainCustomer(customer)
          }
        }
      }, [_c('v-icon', {
        staticClass: "bar-icon"
      }, [_vm._v("start")])], 1), _vm._v(" "), _c('v-btn', {
        attrs: {
          "icon": ""
        },
        on: {
          "click": function($event) {
            _vm.showCustomerData(customer)
          }
        }
      }, [_c('img', {
        attrs: {
          "src": (_vm.$imageS3 + "/clerkinn/edit-icon.svg"),
          "alt": ""
        }
      })]), _vm._v(" "), _c('v-btn', {
        staticClass: "red--text",
        attrs: {
          "icon": "",
          "disabled": _vm.customerForm
        },
        on: {
          "click": function($event) {
            _vm.openDeleteCustomer(customerIndex, customer)
          }
        }
      }, [_c('v-icon', {
        staticClass: "bar-icon"
      }, [_vm._v("close")])], 1)], 1)])])
    }))], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm9": "",
        "md3": "",
        "mt-4": ""
      }
    }, [_c('button-create', {
      attrs: {
        "text": "Agregar huésped",
        "btn-function": "",
        "disabled": _vm.cantAddGuest
      },
      on: {
        "function-click": _vm.showGuestForm
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm3": "",
        "md2": "",
        "mt-4": ""
      }
    }, [_c('v-radio-group', {
      staticClass: "radio-group-transparent",
      attrs: {
        "row": ""
      },
      model: {
        value: (_vm.personType),
        callback: function($$v) {
          _vm.personType = $$v
        },
        expression: "personType"
      }
    }, [_c('v-radio', {
      attrs: {
        "disabled": _vm.customerForm,
        "label": "Adulto",
        "value": 1
      }
    }), _vm._v(" "), _c('v-radio', {
      attrs: {
        "disabled": _vm.customerForm,
        "label": "Niño(a)",
        "value": 2
      }
    })], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "my-3": ""
      }
    }, [_c('v-divider')], 1), _vm._v(" "), _c('v-flex', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.customerForm),
        expression: "customerForm"
      }],
      attrs: {
        "xs12": "",
        "text-xs-left": "",
        "mb-2": ""
      }
    }, [_c('label', {
      staticClass: "label-title"
    }, [_vm._v("Completa los datos")])]), _vm._v(" "), _c('v-flex', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.customerForm),
        expression: "customerForm"
      }],
      attrs: {
        "xs12": "",
        "text-xs-left": ""
      }
    }, [_c('v-layout', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isAnAdult),
        expression: "isAnAdult"
      }],
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "text-xs-left": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Nº de Tarjeta")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('v-select', {
      staticClass: "filter-select filter-select-indicator",
      attrs: {
        "item-text": "name",
        "item-value": "id",
        "items": _vm.typeCards,
        "hide-details": "",
        "single-line": "",
        "bottom": ""
      },
      model: {
        value: (_vm.typeCard),
        callback: function($$v) {
          _vm.typeCard = $$v
        },
        expression: "typeCard"
      }
    }), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset input-form-select",
      attrs: {
        "type": "text"
      },
      model: {
        value: (_vm.model.cardVip),
        callback: function($$v) {
          _vm.model.cardVip = $$v
        },
        expression: "model.cardVip"
      }
    })], 1)], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs3": "",
        "mb-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Tipo de identificación")]), _vm._v(" "), _c('v-select', {
      staticClass: "filter-select filter-select-indicator",
      attrs: {
        "item-text": "name",
        "item-value": "id",
        "items": _vm.typeDocuments,
        "hide-details": "",
        "single-line": "",
        "bottom": ""
      },
      model: {
        value: (_vm.model.documentType),
        callback: function($$v) {
          _vm.model.documentType = $$v
        },
        expression: "model.documentType"
      }
    }), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset input-form-select",
      attrs: {
        "type": "text"
      },
      on: {
        "blur": _vm.searchCustomer
      },
      model: {
        value: (_vm.model.numDocument),
        callback: function($$v) {
          _vm.model.numDocument = $$v
        },
        expression: "model.numDocument"
      }
    }), _vm._v(" "), (_vm.$v.model.numDocument && _vm.$v.model.numDocument.$invalid) ? _c('span', {
      staticClass: "caption red--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tEl número de documento es requerido\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.$v.model.numDocument && _vm.$v.model.numDocument.$invalid &&
      _vm.$v.model.numDocument.$params.minLength) ? _c('p', {
      staticClass: "caption red--text mb-0"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tEs necesario ingresar " + _vm._s(_vm.$v.model.numDocument.$params.minLength.min) + " dígitos\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
      class: {
        'xs6': !_vm.isNaturalPersonModel
      },
      attrs: {
        "xs3": "",
        "mb-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v(_vm._s(_vm.nameModelLabel))]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "disabled": !_vm.model.numDocument
      },
      model: {
        value: (_vm.model.name),
        callback: function($$v) {
          _vm.model.name = $$v
        },
        expression: "model.name"
      }
    }), _vm._v(" "), (_vm.$v.model.name && _vm.$v.model.name.$invalid) ? _c('span', {
      staticClass: "caption red--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.nameModelMessage) + "\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), (_vm.isNaturalPersonModel) ? _c('v-flex', {
      attrs: {
        "xs3": "",
        "mb-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Apellidos")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "placeholder": "Completos",
        "disabled": !_vm.model.numDocument
      },
      model: {
        value: (_vm.model.lastname),
        callback: function($$v) {
          _vm.model.lastname = $$v
        },
        expression: "model.lastname"
      }
    }), _vm._v(" "), (_vm.$v.model.lastname && _vm.$v.model.lastname.$invalid) ? _c('span', {
      staticClass: "caption red--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tEl apellido es requerido\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isAnAdult),
        expression: "isAnAdult"
      }],
      attrs: {
        "xs3": "",
        "mb-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Correo electrónico")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "email",
        "placeholder": "nombre@mail.com",
        "disabled": !_vm.model.numDocument
      },
      model: {
        value: (_vm.model.email),
        callback: function($$v) {
          _vm.model.email = $$v
        },
        expression: "model.email"
      }
    }), _vm._v(" "), (_vm.$v.model.email && _vm.$v.model.email.$invalid) ? _c('span', {
      staticClass: "caption red--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tEl correo es requerido\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": "",
        "mb-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Fecha de nacimiento")]), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs4": "",
        "pa-0": ""
      }
    }, [_c('v-text-field', {
      staticClass: "input-regular input-label-select",
      attrs: {
        "value": _vm.personTypeName,
        "hide-details": "",
        "readonly": ""
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs8": "",
        "pa-0": ""
      }
    }, [_c('v-menu', {
      staticClass: "menu-date-picker",
      attrs: {
        "lazy": "",
        "transition": "scale-transition",
        "offset-y": "",
        "full-width": "",
        "disabled": !_vm.model.numDocument,
        "max-width": "290px"
      },
      on: {
        "input": _vm.changeIcon
      },
      model: {
        value: (_vm.menuBirthDate),
        callback: function($$v) {
          _vm.menuBirthDate = $$v
        },
        expression: "menuBirthDate"
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": "Fecha de nacimiento",
        "append-icon": _vm.arrowIconBirth,
        "append-icon-cb": _vm.toggleIconBirthDate,
        "single-line": "",
        "hide-details": "",
        "readonly": ""
      },
      slot: "activator",
      model: {
        value: (_vm.model.dateBirth),
        callback: function($$v) {
          _vm.model.dateBirth = $$v
        },
        expression: "model.dateBirth"
      }
    }), _vm._v(" "), _c('v-date-picker', {
      attrs: {
        "allowed-dates": _vm.datesDisabled,
        "locale": "es-PE",
        "year-icon": "",
        "scrollable": ""
      },
      model: {
        value: (_vm.model.dateBirth),
        callback: function($$v) {
          _vm.model.dateBirth = $$v
        },
        expression: "model.dateBirth"
      }
    })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isAnAdult && _vm.isNaturalPersonModel),
        expression: "isAnAdult && isNaturalPersonModel"
      }],
      attrs: {
        "xs3": "",
        "mb-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Estado civil")]), _vm._v(" "), _c('v-select', {
      staticClass: "filter-select",
      attrs: {
        "item-text": "name",
        "item-value": "id",
        "items": _vm.civilStatus,
        "hide-details": "",
        "disabled": !_vm.model.numDocument,
        "single-line": "",
        "bottom": ""
      },
      model: {
        value: (_vm.model.civilStatus),
        callback: function($$v) {
          _vm.model.civilStatus = $$v
        },
        expression: "model.civilStatus"
      }
    })], 1), _vm._v(" "), (_vm.isNaturalPersonModel) ? _c('v-flex', {
      attrs: {
        "xs3": "",
        "mb-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Género")]), _vm._v(" "), _c('v-select', {
      staticClass: "filter-select",
      attrs: {
        "item-text": "name",
        "item-value": "id",
        "items": _vm.genders,
        "hide-details": "",
        "disabled": !_vm.model.numDocument,
        "single-line": "",
        "bottom": ""
      },
      model: {
        value: (_vm.model.gender),
        callback: function($$v) {
          _vm.model.gender = $$v
        },
        expression: "model.gender"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("País")]), _vm._v(" "), _c('v-select', {
      staticClass: "filter-select",
      attrs: {
        "items": _vm.countries,
        "item-text": "name",
        "item-value": "id",
        "hide-details": "",
        "disabled": !_vm.model.numDocument,
        "single-line": "",
        "bottom": ""
      },
      on: {
        "input": _vm.loadCities
      },
      model: {
        value: (_vm.model.countryId),
        callback: function($$v) {
          _vm.model.countryId = $$v
        },
        expression: "model.countryId"
      }
    }), _vm._v(" "), (_vm.$v.model.countryId && _vm.$v.model.countryId.$invalid) ? _c('span', {
      staticClass: "caption red--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tEl país es requerido\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isAnAdult),
        expression: "isAnAdult"
      }],
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Ciudad")]), _vm._v(" "), _c('v-select', {
      staticClass: "filter-select",
      attrs: {
        "items": _vm.cities,
        "item-text": "province",
        "item-value": "id",
        "hide-details": "",
        "disabled": !_vm.model.numDocument,
        "single-line": "",
        "bottom": ""
      },
      model: {
        value: (_vm.model.cityId),
        callback: function($$v) {
          _vm.model.cityId = $$v
        },
        expression: "model.cityId"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isAnAdult),
        expression: "isAnAdult"
      }],
      attrs: {
        "xs3": "",
        "mb-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Dirección")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "disabled": !_vm.model.numDocument
      },
      model: {
        value: (_vm.model.address),
        callback: function($$v) {
          _vm.model.address = $$v
        },
        expression: "model.address"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isAnAdult),
        expression: "isAnAdult"
      }],
      attrs: {
        "xs3": "",
        "mb-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Teléfono")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "number",
        "disabled": !_vm.model.numDocument
      },
      model: {
        value: (_vm.model.phone),
        callback: function($$v) {
          _vm.model.phone = $$v
        },
        expression: "model.phone"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": "",
        "mb-3": ""
      }
    }, [_c('v-layout', {
      staticClass: "col-without-label",
      attrs: {
        "row": "",
        "wrap": "",
        "justify-end": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs5": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-action btn-cancel white--text",
      on: {
        "click": _vm.cancelAddGuest
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tCancelar\n\t\t\t\t\t\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs5": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-action btn-save white--text",
      attrs: {
        "disabled": _vm.addGuestDisabled
      },
      on: {
        "click": _vm.addGuest
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.customerBtnText) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-divider')], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.bookingData.channel.data.name),
        expression: "bookingData.channel.data.name"
      }],
      attrs: {
        "xs12": "",
        "text-xs-left": "",
        "mb-2": ""
      }
    }, [_c('label', {
      staticClass: "label-title"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\tDatos de " + _vm._s(_vm.bookingData.channel.data.name) + "\n\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.channelHasProperties),
        expression: "channelHasProperties"
      }],
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "bar-data"
    }, [_vm._l((_vm.bookingData.channel.data.questions), function(value, key) {
      return _c('div', {
        key: key,
        staticClass: "bar-data-item"
      }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(key) + ":\n\t\t\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(value))])])])
    }), _vm._v(" "), _c('div', {
      staticClass: "bar-data-item"
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": _vm.showChannelData
      }
    }, [_c('img', {
      attrs: {
        "src": (_vm.$imageS3 + "/clerkinn/edit-icon.svg"),
        "alt": ""
      }
    })])], 1)], 2), _vm._v(" "), (_vm.showChannelForm) ? _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "mt-3": ""
      }
    }, [_vm._l((_vm.bookingData.channel.data.inputInformations), function(field, fieldIndex) {
      return _c('v-flex', {
        key: fieldIndex,
        attrs: {
          "xs3": "",
          "text-xs-left": ""
        }
      }, [_c('label', {
        staticClass: "label-form"
      }, [_vm._v(_vm._s(field.label))]), _vm._v(" "), _c(field.type, {
        tag: "component",
        class: {
          'filter-select': field.type === 'v-select',
            'input-border-inset': field.type === 'v-text-field'
        },
        attrs: {
          "item-text": field.items.itemText,
          "item-value": field.items.itemValue,
          "items": field.items.name
        },
        model: {
          value: (field[field.value]),
          callback: function($$v) {
            _vm.$set(field, field.value, $$v)
          },
          expression: "field[field.value]"
        }
      })], 1)
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "text-xs-right": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-action btn-cancel grey white--text",
      on: {
        "click": _vm.cancelUpdateChannel
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tCancelar\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('v-btn', {
      staticClass: "btn-action btn-save white--text ml-2",
      on: {
        "click": _vm.updateChannel
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tGuardar\n\t\t\t\t\t\t\t\t\t\t")])], 1)], 2) : _vm._e(), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "mt-3": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-divider')], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "justify-end": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [((_vm.bookingData.bookingState === '2' || _vm.bookingData.bookingState === '7') && !_vm.lateCheckOutDisabled) ? _c('v-btn', {
      staticClass: "btn-action back",
      attrs: {
        "primary": "",
        "type": "button",
        "disabled": !_vm.lateCheckOut || _vm.disabledUpdateCheckOut
      },
      on: {
        "click": _vm.updateCheckOut
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tActualizar Check Out\n\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs8": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "text-xs-left": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('label', {
      staticClass: "label-text"
    }, [_vm._v("Late Check Out")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('label', {
      staticClass: "label-text"
    }, [_vm._v("Late Check Out")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('label', {
      staticClass: "label-text"
    }, [_vm._v("Late Check Out")])])], 1)], 1), _vm._v(" "), (_vm.lateCheckOutIsSelected) ? _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "text-xs-left": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Hora")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Precio")])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs8": ""
      }
    }, [_c('v-radio-group', {
      staticClass: "radio-check-group",
      attrs: {
        "row": ""
      },
      model: {
        value: (_vm.lateCheckOut),
        callback: function($$v) {
          _vm.lateCheckOut = $$v
        },
        expression: "lateCheckOut"
      }
    }, _vm._l((_vm.arrayLate), function(late) {
      return _c('v-radio', {
        key: late.id,
        attrs: {
          "disabled": _vm.lateCheckOutDisabled,
          "label": ((late.hour) + " - $" + (late.price)),
          "value": late
        }
      })
    }))], 1), _vm._v(" "), (_vm.lateCheckOutIsSelected) ? _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "readonly": _vm.lateCheckOutDisabled
      },
      model: {
        value: (_vm.lateCheckOut.hour),
        callback: function($$v) {
          _vm.lateCheckOut.hour = $$v
        },
        expression: "lateCheckOut.hour"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "readonly": _vm.lateCheckOutDisabled
      },
      model: {
        value: (_vm.lateCheckOut.price),
        callback: function($$v) {
          _vm.lateCheckOut.price = $$v
        },
        expression: "lateCheckOut.price"
      }
    })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs8": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "text-xs-left": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('label', {
      staticClass: "label-text"
    }, [_vm._v("Early Check In")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('label', {
      staticClass: "label-text"
    }, [_vm._v("Early Check In")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('label', {
      staticClass: "label-text"
    }, [_vm._v("Early Check In")])])], 1)], 1), _vm._v(" "), (_vm.earlyCheckInIsSelected) ? _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "text-xs-left": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Hora")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Precio")])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs8": ""
      }
    }, [_c('v-radio-group', {
      staticClass: "radio-check-group",
      attrs: {
        "row": ""
      },
      model: {
        value: (_vm.earlyCheckin),
        callback: function($$v) {
          _vm.earlyCheckin = $$v
        },
        expression: "earlyCheckin"
      }
    }, _vm._l((_vm.arrayEarly), function(early) {
      return _c('v-radio', {
        key: early.id,
        attrs: {
          "disabled": _vm.bookingData.bookingState === '2',
          "label": ((early.hour) + " - $" + (early.price)),
          "value": early
        }
      })
    }))], 1), _vm._v(" "), (_vm.earlyCheckInIsSelected) ? _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "readonly": _vm.earlyCheckinDisabled
      },
      model: {
        value: (_vm.earlyCheckin.hour),
        callback: function($$v) {
          _vm.earlyCheckin.hour = $$v
        },
        expression: "earlyCheckin.hour"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "readonly": _vm.earlyCheckinDisabled
      },
      model: {
        value: (_vm.earlyCheckin.price),
        callback: function($$v) {
          _vm.earlyCheckin.price = $$v
        },
        expression: "earlyCheckin.price"
      }
    })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs8": "",
        "text-xs-left": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs8": ""
      }
    }, [_c('button-field', {
      attrs: {
        "label-text": "Cama adicional",
        "activated-button": _vm.bedSelected
      },
      on: {
        "activate-button": _vm.selectBed
      },
      model: {
        value: (_vm.aditionalBedPrice),
        callback: function($$v) {
          _vm.aditionalBedPrice = $$v
        },
        expression: "aditionalBedPrice"
      }
    })], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs8": "",
        "text-xs-left": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs8": ""
      }
    }, [_c('button-field', {
      attrs: {
        "label-text": "Cuna",
        "activated-button": _vm.cribSelected
      },
      on: {
        "activate-button": _vm.selectCrib
      },
      model: {
        value: (_vm.cribPrice),
        callback: function($$v) {
          _vm.cribPrice = $$v
        },
        expression: "cribPrice"
      }
    })], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "text-xs-left": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Observaciones Adicionales")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-text-field', {
      staticClass: "input-border-inset input-textarea input-note mt-1",
      attrs: {
        "no-resize": "",
        "multi-line": "",
        "placeholder": "Escriba aquí",
        "rows": 7,
        "textarea": ""
      },
      model: {
        value: (_vm.bookingData.summary.personalInformation.specialRequest),
        callback: function($$v) {
          _vm.bookingData.summary.personalInformation.specialRequest = $$v
        },
        expression: "bookingData.summary.personalInformation.specialRequest"
      }
    })], 1)], 1) : (i === 2) ? _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": "",
        "my-4": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs9": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, _vm._l((_vm.localCategories), function(category) {
      return _c('v-flex', {
        key: category.id,
        staticClass: "filter-list",
        attrs: {
          "xs2": ""
        }
      }, [_c('v-btn', {
        staticClass: "mr-0",
        class: {
          'active': category.id === _vm.categoryValue
        },
        attrs: {
          "disabled": _vm.loading
        },
        on: {
          "click": function($event) {
            _vm.selectCategory(category.id)
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(category.name) + "\n\t\t\t\t\t\t\t\t\t\t")])], 1)
    }))], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "my-2": ""
      }
    }, [_c('v-divider')], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "justify-end": ""
      }
    }, [_c('v-flex', {
      staticClass: "container-flex",
      attrs: {
        "xs2": ""
      }
    }, [_c('label', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tMonto Abonado\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset inline",
      attrs: {
        "type": "text",
        "disabled": true
      },
      model: {
        value: (_vm.summaryData.documentsAmountPayment),
        callback: function($$v) {
          _vm.summaryData.documentsAmountPayment = $$v
        },
        expression: "summaryData.documentsAmountPayment"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "container-flex",
      attrs: {
        "xs2": ""
      }
    }, [_c('label', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tMonto Pendiente\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset inline",
      attrs: {
        "type": "text",
        "disabled": true
      },
      model: {
        value: (_vm.summaryData.documentsPendingAmount),
        callback: function($$v) {
          _vm.summaryData.documentsPendingAmount = $$v
        },
        expression: "summaryData.documentsPendingAmount"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "container-flex",
      attrs: {
        "xs2": ""
      }
    }, [_c('label', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tTotal\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset inline",
      attrs: {
        "type": "text",
        "disabled": true
      },
      model: {
        value: (_vm.summaryData.documentsAmount),
        callback: function($$v) {
          _vm.summaryData.documentsAmount = $$v
        },
        expression: "summaryData.documentsAmount"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('p', {
      staticClass: "title-form"
    }, [_vm._v("Filtro")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": "",
        "text-xs-left": "",
        "pt-0": ""
      }
    }, [_c('v-menu', {
      staticClass: "menu-date-picker",
      attrs: {
        "lazy": "",
        "transition": "scale-transition",
        "offset-y": "",
        "full-width": "",
        "nudge-left": 40,
        "max-width": "290px"
      },
      on: {
        "input": _vm.changeIconProduct
      },
      model: {
        value: (_vm.menuProduct),
        callback: function($$v) {
          _vm.menuProduct = $$v
        },
        expression: "menuProduct"
      }
    }, [_c('v-text-field', {
      staticClass: "product-date-picker",
      attrs: {
        "label": "Fecha de creación",
        "prepend-icon": "event",
        "append-icon": _vm.arrowIconProduct,
        "append-icon-cb": _vm.toggleIconProductDate,
        "single-line": "",
        "hide-details": "",
        "readonly": ""
      },
      slot: "activator",
      model: {
        value: (_vm.createdAt),
        callback: function($$v) {
          _vm.createdAt = $$v
        },
        expression: "createdAt"
      }
    }), _vm._v(" "), _c('v-date-picker', {
      attrs: {
        "no-title": "",
        "scrollable": ""
      },
      model: {
        value: (_vm.createdAt),
        callback: function($$v) {
          _vm.createdAt = $$v
        },
        expression: "createdAt"
      }
    })], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs1": "",
        "text-xs-left": "",
        "pt-0": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-success white--text",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.filterSummary
      }
    }, [_c('v-icon', [_vm._v("filter_list")])], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs8": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": "",
        "justify-end": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-action btn-success white--text",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.downloadSale
      }
    }, [_c('v-icon', [_vm._v("print")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\tImprimir Resumen\n\t\t\t\t\t\t\t\t\t\t")], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-action btn-success white--text",
      attrs: {
        "type": "button",
        "disabled": Number(_vm.bookingData.bookingState) === 3
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.openProductsModal($event)
        }
      }
    }, [_c('v-icon', [_vm._v("add")]), _vm._v(" Agregar\n\t\t\t\t\t\t\t\t\t\t")], 1), _vm._v(" "), _c('v-dialog', {
      attrs: {
        "persistent": "",
        "width": "auto"
      },
      model: {
        value: (_vm.dialog),
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    }, [_c('v-card', {
      attrs: {
        "height": "auto"
      }
    }, [_c('v-card-title', {
      staticClass: "headline"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tAgregar Producto\n\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "mb-4": ""
      }
    }, [_c('v-divider')], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": "",
        "pl-3": ""
      }
    }, [_c('v-subheader', {
      staticClass: "pl-0"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tAlmacenes\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('v-select', {
      staticClass: "filter-select",
      attrs: {
        "hide-details": "",
        "item-text": "name",
        "item-value": "id",
        "items": _vm.warehouses
      },
      model: {
        value: (_vm.productWarehouse),
        callback: function($$v) {
          _vm.productWarehouse = $$v
        },
        expression: "productWarehouse"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": "",
        "pl-3": ""
      }
    }, [_c('v-subheader', {
      staticClass: "pl-0"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tCategorías\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('v-select', {
      staticClass: "filter-select",
      attrs: {
        "hide-details": "",
        "item-text": "name",
        "item-value": "id",
        "items": _vm.categories
      },
      model: {
        value: (_vm.productCategory),
        callback: function($$v) {
          _vm.productCategory = $$v
        },
        expression: "productCategory"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs1": "",
        "pl-3": "",
        "text-xs-left": "",
        "pt-5": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-success white--text",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.filterProducts
      }
    }, [_c('v-icon', [_vm._v("filter_list")])], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "mt-5": ""
      }
    }, [_c('table-run', {
      attrs: {
        "columns": _vm.productColumns,
        "rows": _vm.productRows,
        "include-delete": false,
        "include-export-to-excel": false,
        "include-options": false,
        "include-switch": false,
        "include-settings": false,
        "include-delete-single": false,
        "key-value": "warProductId",
        "selectable": ""
      },
      on: {
        "on-search-event": _vm.searchProductsByColumn
      },
      scopedSlots: _vm._u([{
        key: "rows",
        fn: function(props) {
          return [_c('td', [_vm._v(_vm._s(props.row.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.warehouseName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.categoryName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.stock))]), _vm._v(" "), _c('td', {
            staticClass: "px-2"
          }, [_c('v-text-field', {
            staticClass: "input-border-inset width-60",
            attrs: {
              "type": "number"
            },
            on: {
              "keyup": function($event) {
                _vm.positiveValue(props.row, 'quantity')
              }
            },
            model: {
              value: (props.row.quantity),
              callback: function($$v) {
                props.row.quantity = _vm._n($$v)
              },
              expression: "props.row.quantity"
            }
          })], 1), _vm._v(" "), _c('td', {
            staticClass: "text-xs-center"
          }, [_vm._v(_vm._s(props.row.price))]), _vm._v(" "), _c('td', {
            staticClass: "px-2 d-flex"
          }, [_c('v-text-field', {
            staticClass: "input-border-inset basis-30 mr-2",
            attrs: {
              "type": "number"
            },
            on: {
              "keyup": function($event) {
                _vm.positiveValue(props.row, 'discount')
              }
            },
            model: {
              value: (props.row.discount),
              callback: function($$v) {
                props.row.discount = _vm._n($$v)
              },
              expression: "props.row.discount"
            }
          }), _vm._v(" "), _c('span', {
            staticClass: "basis-70"
          }, [_vm._v("%")])], 1)]
        }
      }])
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "text-xs-right": ""
      }
    }, [_c('v-pagination', {
      attrs: {
        "length": _vm.totalModalPages,
        "total-visible": _vm.pagesVisible
      },
      on: {
        "input": function($event) {
          _vm.loadSummaryProducts(_vm.paramsSummary.page)
        }
      },
      model: {
        value: (_vm.paramsSummary.page),
        callback: function($$v) {
          _vm.paramsSummary.page = $$v
        },
        expression: "paramsSummary.page"
      }
    })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "my-3": "",
        "align-end": "",
        "justify-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs2": "",
        "pr-2": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-action",
      attrs: {
        "type": "button",
        "primary": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.dialog = false
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tCancelar\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": "",
        "pl-2": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-action btn-success white--text",
      attrs: {
        "disabled": _vm.addProductsDisabled
      },
      nativeOn: {
        "click": function($event) {
          _vm.updateProducts($event)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tGuardar\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "total-amount"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tTotal $" + _vm._s(_vm._f("round")(_vm.totalAmount)) + "\n\t\t\t\t\t\t\t\t\t\t")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "my-2": ""
      }
    }, [_c('v-divider')], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "pb-0": ""
      }
    }, [_c('table-run', {
      attrs: {
        "columns": _vm.summaryColumns,
        "rows": _vm.summaryRows,
        "include-delete": false,
        "include-export-to-excel": false,
        "include-options": false,
        "include-search": false,
        "include-switch": false,
        "include-settings": false,
        "include-delete-single": false
      },
      scopedSlots: _vm._u([{
        key: "rows",
        fn: function(props) {
          return [_c('td', [_vm._v(_vm._s(_vm._f("parseDate")(props.row.createdAt)))]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("parseDate")(props.row.createdAt, 'HH:mm')) + "\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [(props.row.product) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(props.row.product.code) + "\n\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.quantity))]), _vm._v(" "), _c('td', [(props.row.product) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(props.row.product.name) + "\n\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("round")(props.row.subTotal)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.salDocumentsNumber))]), _vm._v(" "), _c('td', [_c('v-flex', {
            attrs: {
              "text-xs-right": ""
            }
          }, [_c('button', [(_vm.showAccommodationOption(props.row)) ? _c('img', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (props.row.product.name === 'ALOJAMIENTO'),
              expression: "props.row.product.name === 'ALOJAMIENTO'"
            }],
            attrs: {
              "src": "/static/img/divide.png",
              "alt": ""
            },
            on: {
              "click": function($event) {
                _vm.openModal(props.row.subTotal, props.row.idDetail, props.row.product.code)
              }
            }
          }) : _vm._e()]), _vm._v(" "), (_vm.showSummaryOption(props.row)) ? _c('v-btn', {
            staticClass: "error--text",
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                _vm.deleteSummaryDetailConfirm(props.row)
              }
            }
          }, [_c('v-icon', [_vm._v("delete")])], 1) : _vm._e()], 1)], 1)]
        }
      }])
    }), _vm._v(" "), _c('modal-bill', {
      attrs: {
        "amountTotal": _vm.modalSubTotal,
        "id-detail": _vm.modalDetail,
        "is-visible": _vm.visibleModal
      },
      on: {
        "close-modal": _vm.closeModal,
        "cancel-modal": _vm.cancelModal,
        "save-modal": _vm.saveModal
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "justify-center": "",
        "my-3": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs2": "",
        "pr-2": "",
        "text-xs-right": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-save btn-grey white--text",
      attrs: {
        "type": "button",
        "disabled": _vm.saleDisabled
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.openSaleModal($event)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.chargeBtnText) + "\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('v-dialog', {
      attrs: {
        "persistent": "",
        "width": "850px"
      },
      model: {
        value: (_vm.saleModal),
        callback: function($$v) {
          _vm.saleModal = $$v
        },
        expression: "saleModal"
      }
    }, [_c('v-card', {
      staticClass: "pb-5",
      attrs: {
        "height": "auto"
      }
    }, [_c('v-tabs', {
      staticClass: "checkin-tabs checkin-tabs-modal",
      model: {
        value: (_vm.salesTabs),
        callback: function($$v) {
          _vm.salesTabs = $$v
        },
        expression: "salesTabs"
      }
    }, [_c('v-tabs-bar', {
      staticClass: "transparent headline"
    }, [_c('v-tabs-slider', {
      staticClass: "default-skyblue"
    }), _vm._v(" "), _c('v-tabs-item', {
      attrs: {
        "href": "#tab-sales"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tVentas\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('v-tabs-item', {
      attrs: {
        "href": "#tab-customer"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tNuevo Cliente\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-tabs-items', [_c('v-tabs-content', {
      staticClass: "pt-4",
      attrs: {
        "id": "tab-sales"
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [(_vm.alert) ? _c('v-flex', {
      attrs: {
        "xs12": "",
        "px-2": ""
      }
    }, [_c('v-alert', {
      staticClass: "text-xs-left",
      attrs: {
        "info": _vm.alertInfo,
        "warning": _vm.alertWarning,
        "dismissible": ""
      },
      model: {
        value: (_vm.alert),
        callback: function($$v) {
          _vm.alert = $$v
        },
        expression: "alert"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.alertMessage) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])], 1) : _vm._e(), _vm._v(" "), (_vm.billingActive && !_vm.cantBilling) ? _c('v-flex', {
      attrs: {
        "xs12": "",
        "mb-2": "",
        "pl-2": ""
      }
    }, [_c('v-checkbox', {
      staticClass: "input-checkbox input-booking",
      attrs: {
        "label": "Exonerar impuestos",
        "color": "info",
        "hide-details": ""
      },
      on: {
        "change": _vm.validateExoneration
      },
      model: {
        value: (_vm.flagTaxes),
        callback: function($$v) {
          _vm.flagTaxes = $$v
        },
        expression: "flagTaxes"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "mb-2": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('label', {
      staticClass: "label-sale-modal"
    }, [_vm._v("Tipo de documento")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [(_vm.documentTypes.length > 0) ? _c('v-radio-group', {
      attrs: {
        "row": ""
      },
      on: {
        "change": _vm.setTypeDocument
      },
      model: {
        value: (_vm.saleModel.typeDocumentCode),
        callback: function($$v) {
          _vm.saleModel.typeDocumentCode = $$v
        },
        expression: "saleModel.typeDocumentCode"
      }
    }, [_c('v-radio', {
      staticClass: "sale-radio-button",
      attrs: {
        "color": "info",
        "label": _vm.documentTypes[0].documentType.name,
        "value": _vm.documentTypes[0].documentType.code
      }
    }), _vm._v(" "), _c('v-radio', {
      staticClass: "sale-radio-button",
      attrs: {
        "color": "info",
        "disabled": _vm.cantBilling,
        "label": _vm.documentTypes[1].documentType.name,
        "value": _vm.documentTypes[1].documentType.code
      }
    }), _vm._v(" "), _c('v-radio', {
      staticClass: "sale-radio-button",
      attrs: {
        "color": "info",
        "label": _vm.documentTypes[2].documentType.name,
        "value": _vm.documentTypes[2].documentType.code
      }
    })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs8": "",
        "mb-3": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs2": "",
        "pl-3": "",
        "text-xs-left": ""
      }
    }, [_c('label', {
      staticClass: "label-sale-modal"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tTipo de cambio\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": "",
        "pr-3": ""
      }
    }, [_c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text"
      },
      on: {
        "blur": function($event) {
          _vm.changeAmounts(_vm.currencySelected)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.changeAmounts(_vm.currencySelected)
        }
      },
      model: {
        value: (_vm.exchangeRate),
        callback: function($$v) {
          _vm.exchangeRate = $$v
        },
        expression: "exchangeRate"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('v-select', {
      staticClass: "filter-select",
      attrs: {
        "item-text": "code",
        "item-value": "code",
        "label": "Moneda",
        "items": _vm.currencies,
        "hide-details": "",
        "single-line": "",
        "bottom": ""
      },
      on: {
        "input": function($event) {
          _vm.validateExoneration(_vm.flagTaxes)
        }
      },
      model: {
        value: (_vm.currencySelected),
        callback: function($$v) {
          _vm.currencySelected = $$v
        },
        expression: "currencySelected"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": "",
        "mb-3": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "wrap": "",
        "justify-end": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs6": "",
        "text-xs-right": "",
        "pr-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Recargo al Consumo")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "number"
      },
      model: {
        value: (_vm.tip),
        callback: function($$v) {
          _vm.tip = $$v
        },
        expression: "tip"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "mb-3": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs4": "",
        "pl-2": ""
      }
    }, [_c('v-select', {
      staticClass: "filter-select filter-select-indicator",
      attrs: {
        "item-text": "name",
        "item-value": "id",
        "items": _vm.typeDocuments,
        "hide-details": "",
        "single-line": "",
        "bottom": ""
      },
      model: {
        value: (_vm.saleData.typeDocument),
        callback: function($$v) {
          _vm.saleData.typeDocument = $$v
        },
        expression: "saleData.typeDocument"
      }
    }), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset input-form-select",
      attrs: {
        "type": "text"
      },
      on: {
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.searchCustomerSale($event)
        },
        "blur": _vm.searchCustomerSale
      },
      model: {
        value: (_vm.saleData.numDocument),
        callback: function($$v) {
          _vm.saleData.numDocument = $$v
        },
        expression: "saleData.numDocument"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": "",
        "pl-3": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-action btn-success white--text",
      on: {
        "click": _vm.addCustomer
      }
    }, [_c('v-icon', [_vm._v("add")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tAgregar Cliente\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": "",
        "pl-3": "",
        "offset-xs1": ""
      }
    }, [_c('v-checkbox', {
      staticClass: "input-checkbox input-booking",
      attrs: {
        "label": "Incluir los datos del Huésped",
        "color": "info",
        "hide-details": ""
      },
      model: {
        value: (_vm.flagShowCustomer),
        callback: function($$v) {
          _vm.flagShowCustomer = $$v
        },
        expression: "flagShowCustomer"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "pl-2": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('v-select', {
      staticClass: "filter-select",
      attrs: {
        "item-text": "name",
        "item-value": "code",
        "label": "Modo de pago",
        "items": _vm.paymentMethods,
        "hide-details": "",
        "single-line": "",
        "bottom": ""
      },
      on: {
        "input": _vm.setPaymentMethod
      },
      model: {
        value: (_vm.saleModel.paymentMethodCode),
        callback: function($$v) {
          _vm.saleModel.paymentMethodCode = $$v
        },
        expression: "saleModel.paymentMethodCode"
      }
    })], 1), _vm._v(" "), (!_vm.creditPayment) ? _c('v-flex', {
      attrs: {
        "xs6": "",
        "pl-3": "",
        "pr-2": ""
      }
    }, [_c('v-select', {
      staticClass: "filter-select filter-select-multiple",
      attrs: {
        "chips": "",
        "hide-details": "",
        "item-text": "name",
        "item-value": "code",
        "disabled": _vm.invalid || _vm.invalidBol,
        "items": _vm.typePayments,
        "label": "Selecciona los tipos de pago a realizar",
        "multiple": "",
        "return-object": "",
        "single-line": ""
      },
      on: {
        "input": _vm.addPays,
        "click": _vm.openModal
      },
      model: {
        value: (_vm.typePaymentsSelected),
        callback: function($$v) {
          _vm.typePaymentsSelected = $$v
        },
        expression: "typePaymentsSelected"
      }
    })], 1) : _c('v-flex', {
      attrs: {
        "xs3": "",
        "px-3": ""
      }
    }, [_c('v-select', {
      staticClass: "filter-select",
      attrs: {
        "hide-details": "",
        "disabled": _vm.invalid || _vm.invalidBol,
        "items": _vm.numberDays,
        "label": "# Días",
        "single-line": ""
      },
      model: {
        value: (_vm.paymentDays),
        callback: function($$v) {
          _vm.paymentDays = $$v
        },
        expression: "paymentDays"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "px-3": "",
        "mt-3": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, _vm._l((_vm.paysByTypePayment), function(pay) {
      return _c('v-flex', {
        key: pay.code,
        attrs: {
          "xs2": "",
          "text-xs-left": "",
          "pr-2": ""
        }
      }, [_c('label', {
        staticClass: "label-form"
      }, [_vm._v(_vm._s(pay.name))]), _vm._v(" "), _c('v-text-field', {
        staticClass: "input-border-inset",
        attrs: {
          "type": "number"
        },
        model: {
          value: (pay.amount),
          callback: function($$v) {
            pay.amount = _vm._n($$v)
          },
          expression: "pay.amount"
        }
      })], 1)
    }))], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "mt-3": ""
      }
    }, [_c('div', {
      staticClass: "bar-data"
    }, [_c('div', {
      staticClass: "bar-data-item"
    }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tCliente:\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.saleCustomer.name))])])]), _vm._v(" "), _c('div', {
      staticClass: "bar-data-item"
    }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.documentTypeName) + ":\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.saleCustomer.document))])])]), _vm._v(" "), _c('div', {
      staticClass: "bar-data-item"
    }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tTipo de Documento:\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.saleCustomer.typeDocument))])])]), _vm._v(" "), _c('div', {
      staticClass: "bar-data-item"
    }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tMoneda:\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.currencySelected))])])])])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "mt-3": ""
      }
    }, [_c('table-run', {
      ref: "saleTable",
      refInFor: true,
      staticClass: "no-selectable-table width-auto",
      attrs: {
        "columns": _vm.localProductsColumns,
        "rows": _vm.newLocalProductsRows,
        "include-delete": false,
        "include-export-to-excel": false,
        "include-options": false,
        "include-search": false,
        "include-switch": false,
        "include-settings": false,
        "include-delete-single": false,
        "selectable": false
      },
      scopedSlots: _vm._u([{
        key: "rows",
        fn: function(props) {
          return [_c('td', [_vm._v(_vm._s(_vm._f("parseDate")(props.row.createdAt)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.product.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.product.category.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.product.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.quantity))]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.symbol) + " "), _c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (props.row.price),
              expression: "props.row.price"
            }],
            staticClass: "input-edit",
            attrs: {
              "type": "number",
              "maxlength": "4",
              "pattern": "\\d{2}",
              "required": ""
            },
            domProps: {
              "value": (props.row.price)
            },
            on: {
              "input": function($event) {
                if ($event.target.composing) { return; }
                props.row.price = $event.target.value
              }
            }
          }), _vm._v(" "), (props.row.product.flagIgvRequired) ? _c('v-btn', {
            directives: [{
              name: "tooltip",
              rawName: "v-tooltip:top",
              value: ({
                html: 'Impuesto obligatorio'
              }),
              expression: "{ html: 'Impuesto obligatorio' }",
              arg: "top"
            }],
            staticClass: "warning--text",
            attrs: {
              "icon": ""
            }
          }, [_c('v-icon', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\twarning\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])], 1) : _vm._e(), _vm._v(" "), (_vm.igvExonerated(props.row)) ? _c('v-btn', {
            directives: [{
              name: "tooltip",
              rawName: "v-tooltip:top",
              value: ({
                html: 'Impuesto exonerado'
              }),
              expression: "{ html: 'Impuesto exonerado' }",
              arg: "top"
            }],
            staticClass: "warning--text",
            attrs: {
              "icon": ""
            }
          }, [_c('v-icon', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\twarning\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])], 1) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.discountPercentage) + "%")])]
        }
      }])
    })], 1)], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "wrap": "",
        "mt-2": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "px-3": "",
        "text-xs-left": ""
      }
    }, [_c('label', [_vm._v("Observación:")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset input-textarea input-note mt-1",
      attrs: {
        "no-resize": "",
        "multi-line": "",
        "placeholder": "Escriba aquí",
        "rows": 2,
        "textarea": ""
      },
      model: {
        value: (_vm.commentary),
        callback: function($$v) {
          _vm.commentary = $$v
        },
        expression: "commentary"
      }
    })], 1)], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "wrap": "",
        "align-end": "",
        "justify-center": "",
        "mt-5": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs2": "",
        "pr-2": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-action",
      attrs: {
        "type": "button",
        "primary": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.saleModal = false
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tCancelar\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": "",
        "pl-2": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-action btn-success white--text",
      attrs: {
        "disabled": _vm.$v.saleCustomer.$invalid ||
          _vm.disableGenerateSale || _vm.validateAmount ||
          _vm.invalid || _vm.disabledSave || _vm.$v.paymentDays.$invalid ||
          _vm.invalidBol
      },
      nativeOn: {
        "click": function($event) {
          _vm.generateSale($event)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tGuardar\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": "",
        "pl-3": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-action back btn-blue",
      attrs: {
        "disabled": _vm.$v.saleCustomer.$invalid ||
          _vm.validateAmount
      },
      nativeOn: {
        "click": function($event) {
          _vm.postPreview($event)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tPrevisualización\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])], 1)], 1)], 1), _vm._v(" "), _c('v-tabs-content', {
      staticClass: "pt-4",
      attrs: {
        "id": "tab-customer"
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "px-3": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "wrap": "",
        "text-xs-left": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs4": "",
        "mb-3": "",
        "pr-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Tipo de identificación")]), _vm._v(" "), _c('v-select', {
      staticClass: "filter-select filter-select-indicator",
      attrs: {
        "item-text": "name",
        "item-value": "id",
        "items": _vm.typeDocuments,
        "hide-details": "",
        "single-line": "",
        "bottom": ""
      },
      model: {
        value: (_vm.newCustomerSale.documentType),
        callback: function($$v) {
          _vm.newCustomerSale.documentType = $$v
        },
        expression: "newCustomerSale.documentType"
      }
    }), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset input-form-select",
      attrs: {
        "type": "text"
      },
      on: {
        "blur": _vm.searchCustomerNew
      },
      model: {
        value: (_vm.newCustomerSale.numDocument),
        callback: function($$v) {
          _vm.newCustomerSale.numDocument = $$v
        },
        expression: "newCustomerSale.numDocument"
      }
    }), _vm._v(" "), (_vm.$v.newCustomerSale.numDocument &&
      _vm.$v.newCustomerSale.numDocument.$invalid) ? _c('span', {
      staticClass: "caption red--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tEl número de documento es requerido\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.$v.newCustomerSale.numDocument &&
      _vm.$v.newCustomerSale.numDocument.$invalid &&
      _vm.$v.newCustomerSale.numDocument.$params.minLength) ? _c('p', {
      staticClass: "caption red--text mb-0"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tEs necesario ingresar " + _vm._s(_vm.$v.newCustomerSale.numDocument.$params.minLength.min) + " dígitos\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
      class: {
        'xs8': !_vm.isNaturalPerson
      },
      attrs: {
        "xs4": "",
        "mb-3": "",
        "pr-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v(_vm._s(_vm.nameLabel))]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text"
      },
      model: {
        value: (_vm.newCustomerSale.name),
        callback: function($$v) {
          _vm.newCustomerSale.name = $$v
        },
        expression: "newCustomerSale.name"
      }
    }), _vm._v(" "), (_vm.$v.newCustomerSale.name &&
      _vm.$v.newCustomerSale.name.$invalid) ? _c('span', {
      staticClass: "caption red--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.nameValidateMessage) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), (_vm.isNaturalPerson) ? _c('v-flex', {
      attrs: {
        "xs4": "",
        "mb-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Apellidos")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "placeholder": "Completos"
      },
      model: {
        value: (_vm.newCustomerSale.lastname),
        callback: function($$v) {
          _vm.newCustomerSale.lastname = $$v
        },
        expression: "newCustomerSale.lastname"
      }
    }), _vm._v(" "), (_vm.$v.newCustomerSale.lastname &&
      _vm.$v.newCustomerSale.lastname.$invalid) ? _c('span', {
      staticClass: "caption red--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tEl apellido es requerido\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": "",
        "mb-3": "",
        "pr-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Correo electrónico")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "email",
        "placeholder": "nombre@mail.com"
      },
      model: {
        value: (_vm.newCustomerSale.email),
        callback: function($$v) {
          _vm.newCustomerSale.email = $$v
        },
        expression: "newCustomerSale.email"
      }
    }), _vm._v(" "), (_vm.$v.newCustomerSale.email &&
      _vm.$v.newCustomerSale.email.$invalid) ? _c('span', {
      staticClass: "caption red--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tEl correo es requerido\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs8": "",
        "mb-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Dirección")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text"
      },
      model: {
        value: (_vm.newCustomerSale.address),
        callback: function($$v) {
          _vm.newCustomerSale.address = $$v
        },
        expression: "newCustomerSale.address"
      }
    }), _vm._v(" "), (_vm.$v.newCustomerSale.address &&
      _vm.$v.newCustomerSale.address.$invalid) ? _c('span', {
      staticClass: "caption red--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tLa dirección es requerida\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "my-3": "",
        "align-end": "",
        "justify-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs2": "",
        "pr-2": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-action",
      attrs: {
        "type": "button",
        "primary": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.backToSales($event)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tCancelar\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": "",
        "pl-2": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-action btn-success white--text",
      attrs: {
        "disabled": _vm.$v.newCustomerSale.$invalid
      },
      nativeOn: {
        "click": function($event) {
          _vm.saveCustomer($event)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tRegistrar\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": "",
        "pl-2": "",
        "text-xs-left": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-save white--text",
      attrs: {
        "type": "button",
        "disabled": _vm.checkoutDisabled
      },
      on: {
        "click": _vm.checkout
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tCheck out\n\t\t\t\t\t\t\t\t\t\t")])], 1)], 1)], 1)], 1) : (i === 3) ? _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "mt-4": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "mb-5": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs10": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, _vm._l((_vm.filters), function(filter) {
      return _c('v-flex', {
        key: filter.id,
        staticClass: "filter-list",
        attrs: {
          "xs3": ""
        }
      }, [_c('v-btn', {
        class: {
          'active': filter.id === _vm.filterValue
        },
        attrs: {
          "disabled": _vm.loading
        },
        on: {
          "click": function($event) {
            _vm.selectFilter(filter.id)
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(filter.label) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t("), (filter.id === 1) ? _c('span', [_vm._v(_vm._s(_vm.quantityNotes.activeNotes))]) : _c('span', [_vm._v(_vm._s(_vm.quantityNotes.filedNotes))]), _vm._v(")\n\t\t\t\t\t\t\t\t\t\t\t\t")])], 1)
    }))], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-save btn-success",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.addNotes
      }
    }, [_c('v-icon', [_vm._v("add")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\tAgregar\n\t\t\t\t\t\t\t\t\t\t")], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.inputNote) ? _c('v-flex', {
      attrs: {
        "xs12": "",
        "mb-2": ""
      }
    }, [_c('form', {
      on: {
        "submit": function($event) {
          $event.preventDefault();
          _vm.saveNote($event)
        }
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "mb-2": ""
      }
    }, [_c('v-text-field', {
      staticClass: "input-textarea input-note",
      attrs: {
        "placeholder": "Añada notas aquí, pulse 'Enter' para guardar",
        "no-resize": "",
        "multi-line": "",
        "rows": 7,
        "textarea": ""
      },
      on: {
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.saveNote($event)
        }
      },
      model: {
        value: (_vm.note),
        callback: function($$v) {
          _vm.note = $$v
        },
        expression: "note"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "mt-2": "",
        "text-xs-right": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-save",
      attrs: {
        "type": "submit"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.actionNoteButton) + "\n\t\t\t\t\t\t\t\t\t\t\t")])], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('table-run', {
      staticClass: "no-selectable-table",
      attrs: {
        "columns": _vm.notesColumns,
        "rows": _vm.notesRows,
        "include-delete": false,
        "include-export-to-excel": false,
        "include-options": false,
        "include-search": false,
        "include-switch": false,
        "include-settings": false,
        "include-delete-single": false,
        "selectable": false
      },
      on: {
        "on-sortable-event": _vm.notesColumnSortableEvent
      },
      scopedSlots: _vm._u([{
        key: "rows",
        fn: function(props) {
          return [_c('td', [_vm._v("Nota " + _vm._s(props.row.id) + " (" + _vm._s(props.row.note) + ")")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-right"
          }, [(_vm.filterValue === 1) ? _c('v-btn', {
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                _vm.saveNote(props.row)
              }
            }
          }, [_c('img', {
            attrs: {
              "src": (_vm.$imageS3 + "/housekeeping/archive.svg"),
              "alt": ""
            }
          })]) : _c('v-btn', {
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                _vm.saveNote(props.row)
              }
            }
          }, [_c('img', {
            attrs: {
              "src": (_vm.$imageS3 + "/housekeeping/unarchive.svg"),
              "alt": ""
            }
          })]), _vm._v(" "), (_vm.filterValue === 1) ? _c('v-btn', {
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                _vm.updateNote(props.row, 1)
              }
            }
          }, [_c('img', {
            attrs: {
              "src": (_vm.$imageS3 + "/housekeeping/edit.svg"),
              "alt": ""
            }
          })]) : _vm._e(), _vm._v(" "), _c('v-btn', {
            attrs: {
              "icon": ""
            },
            nativeOn: {
              "click": function($event) {
                $event.stopPropagation();
                _vm.openDeleteConfirm(props.row.id)
              }
            }
          }, [_c('img', {
            attrs: {
              "src": (_vm.$imageS3 + "/housekeeping/delete.svg"),
              "alt": ""
            }
          })])], 1)]
        }
      }])
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "text-xs-right": "",
        "mb-5": ""
      }
    }, [_c('v-pagination', {
      attrs: {
        "length": _vm.totalNotesPages,
        "total-visible": _vm.notesPagesVisible
      },
      on: {
        "input": function($event) {
          _vm.loadNotes(_vm.paramsNotes.page)
        }
      },
      model: {
        value: (_vm.paramsNotes.page),
        callback: function($$v) {
          _vm.paramsNotes.page = $$v
        },
        expression: "paramsNotes.page"
      }
    })], 1)], 1) : (i === 4) ? _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "my-4": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('p', {
      staticClass: "title-form"
    }, [_vm._v("Filtro")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": "",
        "mb-3": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "md5": "",
        "my-1": ""
      }
    }, [_c('v-layout', {
      staticClass: "calendar-range",
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "md6": "",
        "pa-0": ""
      }
    }, [_c('v-menu', {
      staticClass: "menu-date-picker",
      attrs: {
        "lazy": "",
        "transition": "scale-transition",
        "offset-y": "",
        "full-width": "",
        "nudge-left": 40,
        "max-width": "290px"
      },
      on: {
        "input": _vm.changeIconStart
      },
      model: {
        value: (_vm.menu),
        callback: function($$v) {
          _vm.menu = $$v
        },
        expression: "menu"
      }
    }, [_c('v-text-field', {
      staticClass: "product-date-picker",
      attrs: {
        "label": "Fecha inicial",
        "prepend-icon": "event",
        "append-icon": _vm.arrowIconStart,
        "append-icon-cb": _vm.toggleIconStartDate,
        "single-line": "",
        "hide-details": "",
        "readonly": ""
      },
      slot: "activator",
      model: {
        value: (_vm.startDate),
        callback: function($$v) {
          _vm.startDate = $$v
        },
        expression: "startDate"
      }
    }), _vm._v(" "), _c('v-date-picker', {
      attrs: {
        "no-title": "",
        "scrollable": ""
      },
      model: {
        value: (_vm.startDate),
        callback: function($$v) {
          _vm.startDate = $$v
        },
        expression: "startDate"
      }
    })], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "md6": "",
        "pa-0": ""
      }
    }, [_c('v-menu', {
      staticClass: "menu-date-picker",
      attrs: {
        "lazy": "",
        "transition": "scale-transition",
        "offset-y": "",
        "full-width": "",
        "nudge-left": 40,
        "max-width": "290px"
      },
      on: {
        "input": _vm.changeEndIcon
      },
      model: {
        value: (_vm.menuEnd),
        callback: function($$v) {
          _vm.menuEnd = $$v
        },
        expression: "menuEnd"
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": "Fecha final",
        "append-icon": _vm.arrowIconEnd,
        "append-icon-cb": _vm.toggleIconEndDate,
        "single-line": "",
        "hide-details": "",
        "readonly": ""
      },
      slot: "activator",
      model: {
        value: (_vm.endDate),
        callback: function($$v) {
          _vm.endDate = $$v
        },
        expression: "endDate"
      }
    }), _vm._v(" "), _c('v-date-picker', {
      attrs: {
        "no-title": "",
        "scrollable": ""
      },
      model: {
        value: (_vm.endDate),
        callback: function($$v) {
          _vm.endDate = $$v
        },
        expression: "endDate"
      }
    })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "md1": "",
        "pr-5": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-action btn-success white--text",
      attrs: {
        "type": "button",
        "disabled": !_vm.startDate || !_vm.endDate
      },
      on: {
        "click": _vm.filterBookings
      }
    }, [_c('v-icon', [_vm._v("filter_list")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('table-run', {
      staticClass: "no-selectable-table",
      attrs: {
        "columns": _vm.columns,
        "rows": _vm.rows,
        "include-delete": false,
        "include-export-to-excel": false,
        "include-options": true,
        "include-settings": false,
        "include-delete-single": false,
        "selectable": false
      },
      on: {
        "on-sortable-event": _vm.columnSortableEvent,
        "on-search-event": _vm.searchByColumn
      },
      scopedSlots: _vm._u([{
        key: "rows",
        fn: function(props) {
          return [_c('td', [_vm._v(_vm._s(props.row.code))]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(props.row.codeRoomtype) + "\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(props.row.room.data.codeRoom) + "\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(props.row.customer.data.name) + "\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(props.row.customer.data.lastname) + "\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("parseDate")(props.row.bookingStart)) + " - " + _vm._s(_vm._f("parseDate")(props.row.bookingEnd)) + "\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.guests))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.numberNights))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.summary.promotion.currency) + " " + _vm._s(_vm._f("round")(props.row.total)))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-center"
          }, [_c('v-btn', {
            staticClass: "success--text",
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                _vm.downloadSale(props.row.room.data)
              }
            }
          }, [_c('v-icon', [_vm._v("file_download")])], 1)], 1)]
        }
      }])
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "text-xs-right": ""
      }
    }, [_c('v-pagination', {
      attrs: {
        "length": _vm.totalHistoryPages,
        "total-visible": _vm.pagesVisibleHistory
      },
      on: {
        "input": function($event) {
          _vm.loadBookingHistory(_vm.paramsBookingHistory.page)
        }
      },
      model: {
        value: (_vm.paramsBookingHistory.page),
        callback: function($$v) {
          _vm.paramsBookingHistory.page = $$v
        },
        expression: "paramsBookingHistory.page"
      }
    })], 1)], 1) : (i === 5) ? _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "mt-4": ""
      }
    }, [_c('table-run', {
      staticClass: "no-selectable-table no-search-table",
      attrs: {
        "columns": _vm.emailColumns,
        "rows": _vm.emailRows,
        "include-search": false,
        "include-delete": false,
        "include-export-to-excel": false,
        "include-options": false,
        "include-settings": false,
        "include-delete-single": false,
        "selectable": false
      },
      scopedSlots: _vm._u([{
        key: "rows",
        fn: function(props) {
          return [_c('td', [_vm._v(_vm._s(_vm._f("parseDate")(props.row.sentDate, 'DD-MM-YYYY')))]), _vm._v(" "), _c('td', [(props.row.data) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(props.row.data.from) + "\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('td', [(props.row.data) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(props.row.data.to) + "\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('td', [(props.row.data) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(props.row.data.message) + "\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('v-btn', {
            staticClass: "success--text",
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                $event.preventDefault();
                _vm.previewEmail(props.row)
              }
            }
          }, [_c('v-icon', [_vm._v("visibility")])], 1)], 1)]
        }
      }])
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "text-xs-right": "",
        "mb-5": ""
      }
    }, [_c('v-pagination', {
      attrs: {
        "length": _vm.emailPages,
        "total-visible": _vm.emailVisiblePages
      },
      on: {
        "input": function($event) {
          _vm.loadEmails(_vm.emailParams.page)
        }
      },
      model: {
        value: (_vm.emailParams.page),
        callback: function($$v) {
          _vm.emailParams.page = $$v
        },
        expression: "emailParams.page"
      }
    })], 1)], 1) : _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "my-4": ""
      }
    }, [_c('table-run', {
      staticClass: "no-selectable-table no-search-table",
      attrs: {
        "columns": _vm.billingColumns,
        "rows": _vm.billingRows,
        "include-search": false,
        "include-delete": false,
        "include-export-to-excel": false,
        "include-options": false,
        "include-settings": false,
        "include-delete-single": false,
        "selectable": false
      },
      scopedSlots: _vm._u([{
        key: "rows",
        fn: function(props) {
          return [_c('td', [_vm._v(_vm._s(props.row.serie) + "-" + _vm._s(props.row.number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getTypeDocumentName(props.row)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("parseDate")(props.row.createdAt)))]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(props.row.stateName) + "\n\t\t\t\t\t\t\t\t\t\t"), (props.row.showCanceled) ? _c('v-btn', {
            directives: [{
              name: "tooltip",
              rawName: "v-tooltip:top",
              value: ({
                html: 'Factura Anulada'
              }),
              expression: "{ html: 'Factura Anulada' }",
              arg: "top"
            }],
            staticClass: "error-icon",
            attrs: {
              "icon": ""
            }
          }, [_c('v-icon', [_vm._v("block")])], 1) : _vm._e()], 1), _vm._v(" "), _c('td', [(!props.row.flagAmountTotal &&
            props.row.showCancel) ? _c('v-btn', {
            directives: [{
              name: "tooltip",
              rawName: "v-tooltip:top",
              value: ({
                html: 'Pagar'
              }),
              expression: "{ html: 'Pagar' }",
              arg: "top"
            }],
            staticClass: "info--text",
            attrs: {
              "icon": ""
            },
            nativeOn: {
              "click": function($event) {
                $event.preventDefault();
                _vm.openBillingPay(props.row)
              }
            }
          }, [_c('v-icon', [_vm._v("payment")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
            directives: [{
              name: "tooltip",
              rawName: "v-tooltip:top",
              value: ({
                html: 'Ver detalle'
              }),
              expression: "{ html: 'Ver detalle' }",
              arg: "top"
            }],
            staticClass: "success--text",
            attrs: {
              "icon": ""
            },
            nativeOn: {
              "click": function($event) {
                $event.preventDefault();
                _vm.openBillingDetail(props.row)
              }
            }
          }, [_c('v-icon', [_vm._v("visibility")])], 1), _vm._v(" "), (props.row.showPrintCot) ? _c('v-btn', {
            directives: [{
              name: "tooltip",
              rawName: "v-tooltip:top",
              value: ({
                html: 'Imprimir Comanda'
              }),
              expression: "{ html: 'Imprimir Comanda' }",
              arg: "top"
            }],
            attrs: {
              "icon": ""
            },
            nativeOn: {
              "click": function($event) {
                $event.preventDefault();
                _vm.downLoadUniqueTicket(props.row)
              }
            }
          }, [_c('v-icon', [_vm._v("print")])], 1) : _vm._e()], 1)]
        }
      }])
    })], 1)], 1)
  }))], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "auto"
    },
    model: {
      value: (_vm.dialogNote),
      callback: function($$v) {
        _vm.dialogNote = $$v
      },
      expression: "dialogNote"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n\t\t\t\t\t¿Desea eliminar la nota " + _vm._s(_vm.noteId) + "?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelDeleteNote($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tCancelar\n\t\t\t\t\t")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteNote($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tEliminar\n\t\t\t\t\t")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "auto"
    },
    model: {
      value: (_vm.dialogCustomer),
      callback: function($$v) {
        _vm.dialogCustomer = $$v
      },
      expression: "dialogCustomer"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n\t\t\t\t\t¿Desea eliminar al huésped " + _vm._s(_vm.customerNumber) + "?")]), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": "",
      "pr-1": ""
    }
  }, [_c('v-btn', {
    staticClass: "white--text darken-1",
    attrs: {
      "info": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelDeleteCustomer($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tCancelar\n\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": "",
      "pl-1": ""
    }
  }, [_c('v-btn', {
    staticClass: "white--text darken-1",
    attrs: {
      "error": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteCustomer($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tEliminar\n\t\t\t\t\t\t\t")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "600"
    },
    model: {
      value: (_vm.dialogBillingDetail),
      callback: function($$v) {
        _vm.dialogBillingDetail = $$v
      },
      expression: "dialogBillingDetail"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n\t\t\t\t\tDetalle de Factura\n\t\t\t\t")]), _vm._v(" "), _c('table-run', {
    staticClass: "no-selectable-table no-search-table",
    attrs: {
      "columns": _vm.billingDetailsColumns,
      "rows": _vm.billingDetails,
      "include-search": false,
      "include-delete": false,
      "include-export-to-excel": false,
      "include-options": false,
      "include-settings": false,
      "include-delete-single": false,
      "selectable": false
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.documentId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("parseDate")(props.row.expirationDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")(_vm._f("round")(props.row.amount), _vm.symbol)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")(_vm._f("round")(props.row.amountPayment), _vm.symbol)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")(_vm._f("round")(props.row.amountToPay), _vm.symbol)))])]
      }
    }])
  }), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mt-3"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "pr-1": ""
    }
  }, [_c('v-btn', {
    staticClass: "white--text darken-1",
    attrs: {
      "info": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeBillingDialog($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tCerrar\n\t\t\t\t\t\t\t")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "650"
    },
    model: {
      value: (_vm.dialogBillingPay),
      callback: function($$v) {
        _vm.dialogBillingPay = $$v
      },
      expression: "dialogBillingPay"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n\t\t\t\t\tPagar Factura\n\t\t\t\t")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "wrap": "",
      "mb-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "text-xs-left": ""
    }
  }, [_c('v-subheader', {
    staticClass: "title black--text px-0"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tNº DOC: " + _vm._s(_vm.billingDetail.documentId) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "my-0 grey--text"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tEl adelanto se realizó en moneda " + _vm._s(_vm.currencySelected) + "\n\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-btn', {
    staticClass: "white--text darken-1",
    attrs: {
      "success": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.goToBill(_vm.billingDetail.documentId)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tVer Detalle de Factura\n\t\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "mr-3": "",
      "text-xs-left": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Tipo de pago")]), _vm._v(" "), _c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "item-text": "name",
      "item-value": "code",
      "items": _vm.typePayments,
      "hide-details": ""
    },
    model: {
      value: (_vm.billingTypePaymentCode),
      callback: function($$v) {
        _vm.billingTypePaymentCode = $$v
      },
      expression: "billingTypePaymentCode"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "text-xs-left": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Cuenta Bancaria")]), _vm._v(" "), _c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "disabled": _vm.bankAccountsDisabled,
      "hide-details": "",
      "item-text": "name",
      "item-value": "id",
      "items": _vm.bankAccounts,
      "single-line": ""
    },
    model: {
      value: (_vm.billingBankAccountId),
      callback: function($$v) {
        _vm.billingBankAccountId = $$v
      },
      expression: "billingBankAccountId"
    }
  })], 1)], 1), _vm._v(" "), _vm._l((_vm.billingDetails), function(billDetail) {
    return _c('v-layout', {
      key: billDetail.id,
      attrs: {
        "wrap": "",
        "mt-4": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm3": "",
        "text-xs-left": "",
        "pr-2": ""
      }
    }, [_c('label', {
      staticClass: "body-1 black--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\tTotal\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
      staticClass: "caption ma-0 grey--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\tDeuda\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "readonly": "",
        "value": _vm._f("currency")(_vm._f("round")(billDetail.amount), _vm.symbol)
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm3": "",
        "text-xs-left": "",
        "px-2": ""
      }
    }, [_c('label', {
      staticClass: "body-1 black--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\tPagado\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
      staticClass: "caption ma-0 grey--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\tMonto\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "readonly": "",
        "value": _vm._f("currency")(_vm._f("round")(billDetail.amountPayment), _vm.symbol)
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm3": "",
        "text-xs-left": "",
        "pl-2": ""
      }
    }, [_c('label', {
      staticClass: "body-1 black--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\tA pagar\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
      staticClass: "caption ma-0 grey--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\tMonto\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "number",
        "prefix": _vm.symbol
      },
      model: {
        value: (billDetail.amountToPay),
        callback: function($$v) {
          billDetail.amountToPay = _vm._n($$v)
        },
        expression: "billDetail.amountToPay"
      }
    })], 1)], 1)
  })], 2), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mt-3"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "pr-1": ""
    }
  }, [_c('v-btn', {
    staticClass: "white--text darken-1",
    attrs: {
      "info": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeBillingDialog($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tCerrar\n\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "pr-1": ""
    }
  }, [_c('v-btn', {
    staticClass: "white--text darken-1",
    attrs: {
      "success": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.payBilling($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tPagar\n\t\t\t\t\t\t\t")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "auto"
    },
    model: {
      value: (_vm.dialogCancelBilling),
      callback: function($$v) {
        _vm.dialogCancelBilling = $$v
      },
      expression: "dialogCancelBilling"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n\t\t\t\t\t¿Desea anular la factura " + _vm._s(_vm.billingNumber) + "?")]), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "pr-2": ""
    }
  }, [_c('v-btn', {
    staticClass: "white--text darken-1",
    attrs: {
      "info": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeBillingDialog($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tCerrar\n\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "pl-2": ""
    }
  }, [_c('v-btn', {
    staticClass: "white--text darken-1",
    attrs: {
      "error": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelBilling($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tAnular\n\t\t\t\t\t\t\t")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "auto"
    },
    model: {
      value: (_vm.summaryConfirm),
      callback: function($$v) {
        _vm.summaryConfirm = $$v
      },
      expression: "summaryConfirm"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n\t\t\t\t\t¿Desea eliminar " + _vm._s(_vm.summaryName) + " del resumen de cuenta?")]), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "pr-2": ""
    }
  }, [_c('v-btn', {
    staticClass: "white--text darken-1",
    attrs: {
      "info": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeSummaryConfirm($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tCerrar\n\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "pl-2": ""
    }
  }, [_c('v-btn', {
    staticClass: "white--text darken-1",
    attrs: {
      "error": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteSummaryDetail($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tEliminar\n\t\t\t\t\t\t\t")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": ""
    }
  }, [(!_vm.firstTabActive) ? _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-action back btn-blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.backToTab
    }
  }, [_vm._v("\n\t\t\t\tVolver\n\t\t\t")])], 1) : _vm._e(), _vm._v(" "), (_vm.firstTabActive && _vm.showCheckLoyalty) ? _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "input-checkbox",
    attrs: {
      "label": "Loyalty",
      "true-value": 1,
      "false-value": 0,
      "color": "info",
      "hide-details": ""
    },
    model: {
      value: (_vm.model.flagLoyalty),
      callback: function($$v) {
        _vm.model.flagLoyalty = $$v
      },
      expression: "model.flagLoyalty"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.firstTabActive && _vm.checkinActive) ? _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-action save btn-success white--text",
    attrs: {
      "type": "button",
      "disabled": !_vm.isToday
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v("\n\t\t\t\tCheck in\n\t\t\t")])], 1) : _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-action back btn-blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goToSummary
    }
  }, [_vm._v("\n\t\t\t\tVer resumen de cuenta\n\t\t\t")])], 1), _vm._v(" "), (_vm.firstTabActive && !_vm.isToday) ? _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-action back",
    attrs: {
      "primary": "",
      "type": "button"
    },
    on: {
      "click": _vm.goToCalendar
    }
  }, [_vm._v("\n\t\t\t\tVolver al calendario\n\t\t\t")])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1680:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isVisible) ? _c('div', {
    staticClass: "modal-bill"
  }, [_c('div', {
    staticClass: "container-modal-bill"
  }, [_c('div', {
    staticClass: "section-bill"
  }, [_c('v-flex', {
    attrs: {
      "text-xs-right": "",
      "pr-2": ""
    }
  }, [_c('v-icon', {
    on: {
      "click": function($event) {
        _vm.$emit('close-modal')
      }
    }
  }, [_vm._v("cancel")])], 1), _vm._v(" "), _c('div', {
    staticClass: "con-accommodation"
  }, [_c('div', {
    staticClass: "container-accommodation"
  }, [_c('p', {
    staticClass: "text-accommodation border-bottom"
  }, [_vm._v("Alojamiento")]), _vm._v(" "), _c('p', {
    staticClass: "text-accommodation"
  }, [_vm._v("Monto Total")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amountTotal),
      expression: "amountTotal"
    }],
    staticClass: "input-accomodation",
    attrs: {
      "type": "text",
      "readonly": "readonly",
      "placeholder": "0"
    },
    domProps: {
      "value": (_vm.amountTotal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amountTotal = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._l((_vm.dateBill), function(index) {
    return _c('div', {
      key: index.id,
      staticClass: "container-rode"
    }, [_c('p', {
      staticClass: "text-rode"
    }, [_vm._v("Monto")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (index.price),
        expression: "index.price"
      }],
      staticClass: "input-accomodation",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (index.price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          index.price = $event.target.value
        }
      }
    })])
  })], 2), _vm._v(" "), _c('v-layout', {
    attrs: {
      "justify-center": "",
      "align-content-center": "",
      "row": "",
      "my-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "text-xs-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-cancel grey",
    on: {
      "click": function($event) {
        _vm.$emit('cancel-modal')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tCancelar\n\t\t\t\t\t\t")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-action btn-save",
    attrs: {
      "disabled": !_vm.printSave
    },
    on: {
      "click": function($event) {
        _vm.$emit('save-modal', _vm.dateBill, _vm.idDetail)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tGuardar\n\t\t\t\t\t\t")])], 1)], 1)], 1)])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 807:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1491)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1269),
  /* template */
  __webpack_require__(1647),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6007a611",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 865:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.regex = exports.ref = exports.len = exports.req = exports.withParams = undefined;

var _withParams = __webpack_require__(903);

var _withParams2 = _interopRequireDefault(_withParams);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.withParams = _withParams2.default;

// "required" core, used in almost every validator to allow empty values

var req = exports.req = function req(value) {
  if (Array.isArray(value)) return !!value.length;
  if (value === undefined || value === null || value === false) {
    return false;
  }

  if (value instanceof Date) {
    // invalid date won't pass
    return !isNaN(value.getTime());
  }

  if (typeof value === 'object') {
    for (var _ in value) {
      return true;
    }return false;
  }

  return !!String(value).length;
};

// get length in type-agnostic way
var len = exports.len = function len(value) {
  if (Array.isArray(value)) return value.length;
  if (typeof value === 'object') {
    return Object.keys(value).length;
  }
  return String(value).length;
};

// resolve referenced value
var ref = exports.ref = function ref(reference, vm, parentVm) {
  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};

// regex based validator template
var regex = exports.regex = function regex(type, expr) {
  return (0, _withParams2.default)({ type: type }, function (value) {
    return !req(value) || expr.test(value);
  });
};

/***/ }),

/***/ 868:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(873);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(872);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ 871:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(881);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ 872:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(874), __esModule: true };

/***/ }),

/***/ 873:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(875), __esModule: true };

/***/ }),

/***/ 874:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(274);
__webpack_require__(273);
module.exports = __webpack_require__(876);


/***/ }),

/***/ 875:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(274);
__webpack_require__(273);
module.exports = __webpack_require__(877);


/***/ }),

/***/ 876:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(30);
var get = __webpack_require__(277);
module.exports = __webpack_require__(18).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 877:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(148);
var ITERATOR = __webpack_require__(9)('iterator');
var Iterators = __webpack_require__(41);
module.exports = __webpack_require__(18).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ 879:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.maxValue = exports.minValue = exports.and = exports.or = exports.url = exports.sameAs = exports.requiredUnless = exports.requiredIf = exports.required = exports.minLength = exports.maxLength = exports.macAddress = exports.ipAddress = exports.email = exports.between = exports.numeric = exports.alphaNum = exports.alpha = undefined;

var _alpha = __webpack_require__(885);

var _alpha2 = _interopRequireDefault(_alpha);

var _alphaNum = __webpack_require__(886);

var _alphaNum2 = _interopRequireDefault(_alphaNum);

var _numeric = __webpack_require__(896);

var _numeric2 = _interopRequireDefault(_numeric);

var _between = __webpack_require__(888);

var _between2 = _interopRequireDefault(_between);

var _email = __webpack_require__(889);

var _email2 = _interopRequireDefault(_email);

var _ipAddress = __webpack_require__(890);

var _ipAddress2 = _interopRequireDefault(_ipAddress);

var _macAddress = __webpack_require__(891);

var _macAddress2 = _interopRequireDefault(_macAddress);

var _maxLength = __webpack_require__(892);

var _maxLength2 = _interopRequireDefault(_maxLength);

var _minLength = __webpack_require__(894);

var _minLength2 = _interopRequireDefault(_minLength);

var _required = __webpack_require__(898);

var _required2 = _interopRequireDefault(_required);

var _requiredIf = __webpack_require__(899);

var _requiredIf2 = _interopRequireDefault(_requiredIf);

var _requiredUnless = __webpack_require__(900);

var _requiredUnless2 = _interopRequireDefault(_requiredUnless);

var _sameAs = __webpack_require__(901);

var _sameAs2 = _interopRequireDefault(_sameAs);

var _url = __webpack_require__(902);

var _url2 = _interopRequireDefault(_url);

var _or = __webpack_require__(897);

var _or2 = _interopRequireDefault(_or);

var _and = __webpack_require__(887);

var _and2 = _interopRequireDefault(_and);

var _minValue = __webpack_require__(895);

var _minValue2 = _interopRequireDefault(_minValue);

var _maxValue = __webpack_require__(893);

var _maxValue2 = _interopRequireDefault(_maxValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.alpha = _alpha2.default;
exports.alphaNum = _alphaNum2.default;
exports.numeric = _numeric2.default;
exports.between = _between2.default;
exports.email = _email2.default;
exports.ipAddress = _ipAddress2.default;
exports.macAddress = _macAddress2.default;
exports.maxLength = _maxLength2.default;
exports.minLength = _minLength2.default;
exports.required = _required2.default;
exports.requiredIf = _requiredIf2.default;
exports.requiredUnless = _requiredUnless2.default;
exports.sameAs = _sameAs2.default;
exports.url = _url2.default;
exports.or = _or2.default;
exports.and = _and2.default;
exports.minValue = _minValue2.default;
exports.maxValue = _maxValue2.default;

/***/ }),

/***/ 881:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(882), __esModule: true };

/***/ }),

/***/ 882:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(273);
__webpack_require__(884);
module.exports = __webpack_require__(18).Array.from;


/***/ }),

/***/ 883:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(57);
var createDesc = __webpack_require__(142);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ 884:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(61);
var $export = __webpack_require__(39);
var toObject = __webpack_require__(147);
var call = __webpack_require__(284);
var isArrayIter = __webpack_require__(283);
var toLength = __webpack_require__(149);
var createProperty = __webpack_require__(883);
var getIterFn = __webpack_require__(277);

$export($export.S + $export.F * !__webpack_require__(285)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ 885:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(865);

exports.default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

/***/ }),

/***/ 886:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(865);

exports.default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

/***/ }),

/***/ 887:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(865);

exports.default = function () {
  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({ type: 'and' }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid && fn.apply(_this, args);
    }, true);
  });
};

/***/ }),

/***/ 888:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(865);

exports.default = function (min, max) {
  return (0, _common.withParams)({ type: 'between', min: min, max: max }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
  });
};

/***/ }),

/***/ 889:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(865);

var emailRegex = /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/;

exports.default = (0, _common.regex)('email', emailRegex);

/***/ }),

/***/ 890:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(865);

exports.default = (0, _common.withParams)({ type: 'ipAddress' }, function (value) {
  if (!(0, _common.req)(value)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  var nibbles = value.split('.');
  return nibbles.length === 4 && nibbles.every(nibbleValid);
});


var nibbleValid = function nibbleValid(nibble) {
  if (nibble.length > 3 || nibble.length === 0) {
    return false;
  }

  if (nibble[0] === '0' && nibble !== '0') {
    return false;
  }

  if (!nibble.match(/^\d+$/)) {
    return false;
  }

  var numeric = +nibble | 0;
  return numeric >= 0 && numeric <= 255;
};

/***/ }),

/***/ 891:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(865);

exports.default = function () {
  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
  return (0, _common.withParams)({ type: 'macAddress' }, function (value) {
    if (!(0, _common.req)(value)) {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;

    return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
  });
};

var hexValid = function hexValid(hex) {
  return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
};

/***/ }),

/***/ 892:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(865);

exports.default = function (length) {
  return (0, _common.withParams)({ type: 'maxLength', max: length }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
  });
};

/***/ }),

/***/ 893:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(865);

exports.default = function (max) {
  return (0, _common.withParams)({ type: 'maxValue', max: max }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

/***/ }),

/***/ 894:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(865);

exports.default = function (length) {
  return (0, _common.withParams)({ type: 'minLength', min: length }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

/***/ }),

/***/ 895:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(865);

exports.default = function (min) {
  return (0, _common.withParams)({ type: 'minValue', min: min }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

/***/ }),

/***/ 896:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(865);

exports.default = (0, _common.regex)('numeric', /^[0-9]*$/);

/***/ }),

/***/ 897:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(865);

exports.default = function () {
  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({ type: 'or' }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid || fn.apply(_this, args);
    }, false);
  });
};

/***/ }),

/***/ 898:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(865);

exports.default = (0, _common.withParams)({ type: 'required' }, _common.req);

/***/ }),

/***/ 899:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(865);

exports.default = function (prop) {
  return (0, _common.withParams)({ type: 'requiredIf', prop: prop }, function (value, parentVm) {
    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

/***/ }),

/***/ 900:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(865);

exports.default = function (prop) {
  return (0, _common.withParams)({ type: 'requiredUnless', prop: prop }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

/***/ }),

/***/ 901:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(865);

exports.default = function (equalTo) {
  return (0, _common.withParams)({ type: 'sameAs', eq: equalTo }, function (value, parentVm) {
    return value === (0, _common.ref)(equalTo, this, parentVm);
  });
};

/***/ }),

/***/ 902:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(865);

var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

exports.default = (0, _common.regex)('url', urlRegex);

/***/ }),

/***/ 903:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* istanbul ignore next */
var withParams =  false ? require('./withParamsBrowser').withParams : __webpack_require__(286).withParams;

exports.default = withParams;

/***/ }),

/***/ 920:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(923),
  /* template */
  __webpack_require__(924),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 921:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(925),
  /* template */
  __webpack_require__(945),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 923:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function sendValue(value) {
	this.$emit('input', value);
}

function changeValue(value) {
	this.$emit('change', value);
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'select-button',
	inheritAttrs: false,
	methods: {
		changeValue: changeValue,
		sendValue: sendValue
	},
	props: {
		labelText: {
			default: '',
			type: String
		},
		value: null
	}
});

/***/ }),

/***/ 924:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "label-form"
  }, [_vm._v(_vm._s(_vm.labelText))]), _vm._v(" "), _c('v-select', _vm._b({
    staticClass: "filter-select filter-select filter-select-autocomplete",
    attrs: {
      "hide-details": "",
      "value": _vm.value,
      "single-line": ""
    },
    on: {
      "input": _vm.sendValue,
      "change": _vm.changeValue
    }
  }, 'v-select', _vm.$attrs, false))], 1)
},staticRenderFns: []}

/***/ }),

/***/ 925:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//


function sendValue(value) {
	this.$emit('input', value);
}

function sendValueOnBlur(value) {
	this.$emit('blur', value);
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'input-text',
	inheritAttrs: false,
	methods: {
		sendValue: sendValue,
		sendValueOnBlur: sendValueOnBlur
	},
	props: {
		labelText: {
			default: '',
			type: String
		},
		value: null
	}
});

/***/ }),

/***/ 945:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "label-form"
  }, [_vm._v(_vm._s(_vm.labelText))]), _vm._v(" "), _c('v-text-field', _vm._b({
    staticClass: "input-border-inset",
    attrs: {
      "value": _vm.value
    },
    on: {
      "input": _vm.sendValue,
      "blur": _vm.sendValueOnBlur
    }
  }, 'v-text-field', _vm.$attrs, false))], 1)
},staticRenderFns: []}

/***/ }),

/***/ 952:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(953), __esModule: true };

/***/ }),

/***/ 953:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(955);
module.exports = __webpack_require__(18).Object.keys;


/***/ }),

/***/ 954:
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(39);
var core = __webpack_require__(18);
var fails = __webpack_require__(90);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ 955:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(147);
var $keys = __webpack_require__(141);

__webpack_require__(954)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ })

});


// WEBPACK FOOTER //
// static/js/23.760638c2e442b63b8192.js